import {
  Box,
  Center,
  Container,
  Flex,
  Heading,
  Img,
  Text,
} from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React from 'react';
import { IAgendaEvent } from '@/components/agenda/EventCard';
// import SubDetails from './SubDetails';
import DetailsAndOverview from './DetailsAndOverview';
import EventAgenda from './EventAgenda';
import Speakers from './Speakers';
import TopCover from './TopCover';
import Link from 'next/link';

// import LogoComponent from '@/components/common/Logo';

interface IEventData {
  slug: string;
  imgSrc: string;
  imgType?: string;
  title: string;
  startTime?: string;
  startDate: string;
  location?: string;
  accentLabel?: string;
  coverImgLink?: string;
  link?: string;
  contact?: {
    name: string;
    designation?: string;
    image?: string;
    email: string;
    phone?: string;
  }[];
  speakers?: {
    name: string;
    designation?: string;
    image?: string;
    email?: string;
    phone?: string;
    gov?: boolean;
    fund?: string;
  }[];
  programTitle?: string;
  programHighlights?: string | string[];
  overviewTitle?: string;
  eventOverview?: string | string[];
  outcomeTitle?: string;
  outcomeHighlights?: string | string[];
  attendeesTitle?: string;
  attendeesHighlights?: string | string[];
  agendaEvents?: IAgendaEvent[];
  YTLink?: string;
  logos?: {
    name?: string;
    _id?: string;
    logo?: string;
    website_link?: string;
  }[];
  keyTopicsTitle?: string;
  keyTopicsTitleHighlights?: string | string[];
  alphabeticalSort?: boolean;
  sponsor_text?: string;
  supported_by_logos?: {
    name?: string;
    _id?: string;
    logo?: string;
    website_link?: string;
  }[];
  button?: {
    text: string;
    link?: string;
    external: boolean;
  };
}

const eventsData: IEventData[] = [
  {
    slug: 'ivca-secondaries-conference',
    title: 'IVCA SECONDARIES CONFERENCE',
    startDate: 'July 20, 2023',
    startTime: '9:30 AM',
    location: 'Trident, BKC, Mumbai',
    imgSrc: '/png/secondaries.png',
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSd01uW9QZ_myEWCLT59p3GJM9GSLmwwgpKAaCpCLT88pceqdg/viewform',
    agendaEvents: [
      {
        id: 'sec_conf_1',
        timing: {
          start: '9:30am',
          end: '9:55am',
        },
        accentTag: '25 Mins',
        normalHeading: 'Registration & Networking Tea/asdCoffee',
      },
      {
        id: 'sec_conf_2',
        timing: {
          start: '9:55am',
          end: '10:00am',
        },
        accentTag: '5 Mins',
        normalHeading: 'Welcome Address',
      },
      {
        id: 'sec_conf_3',
        timing: {
          start: '10:00am',
          end: '10:20am',
        },
        accentTag: '20 Mins',
        normalHeading:
          'GP led Secondaries in India – “Key considerations and challenges”: by Khaitan & Co.',
        listContent: [
          'Indian context',
          'Regulatory developments',
          'Structural issues',
          'Tax aspects',
        ],
        speakers: [
          {
            name: 'Divaspati Singh',
            designation: 'Partner, Khaitan & Co.',
          },
          {
            name: 'Vivek Mimani',
            designation: 'Partner, Khaitan & Co.',
          },
        ],
      },
      {
        id: 'sec_conf_4',
        timing: {
          start: '10:20am',
          end: '10:40am',
        },
        accentTag: '20 Mins',
        normalHeading:
          'International trends in Secondaries and Relevance for India: by Goodwin',
        listContent: [
          'Global developments',
          'Common structures',
          'Key commercial and regulatory consideraƟons',
          'Investors perspecƟve',
        ],
        speakers: [
          {
            name: 'Manish Ranjan',
            designation: 'Counsel, Goodwin',
          },
          {
            name: 'Dominic Wong',
            designation: 'Counsel, Goodwin',
          },
        ],
      },
      {
        id: 'sec_conf_5',
        timing: {
          start: '10:40am',
          end: '11:00am',
        },
        accentTag: '20 Mins',
        normalHeading: 'Fireside Chat',
        speakers: [
          {
            name: 'Neha Grover',
            designation:
              'Regional Lead-IFC, South Asia Funds Group, InternaƟonal Finance Corporation (IFC)',
          },
          {
            name: 'Bijal Ajinkya',
            designation: 'Partner, Khaitan & Co.',
          },
        ],
      },
      {
        id: 'sec_conf_6',
        timing: {
          start: '11:00am',
          end: '11:45am',
        },
        accentTag: '45 Mins',
        normalHeading:
          'Panel Discussion: GP led Secondaries – “The Next Chapter”',
        speakers: [
          {
            name: 'Alok Gupta',
            designation: 'Head of India, Foundation Private Equity',
          },
          {
            name: 'Dominic Goh',
            designation: 'Managing Director, HarbourVest',
          },
          {
            name: 'Peter Lui',
            designation: 'ExecuƟve Director, LGT Capital Partners',
          },
          {
            name: 'Norbert Fernandes',
            designation: 'Director, TR Capital',
          },
          {
            name: 'Siddharth Shah',
            designation: 'Senior Partner, Khaitan & Co.',
          },
          {
            name: 'Gregory Barclay',
            designation: 'Partner, Goodwin (Moderator)',
          },
        ],
      },
      {
        id: 'sec_conf_7',
        timing: {
          start: '11:45am',
          end: 'Onwards',
        },
        accentTag: 'Networking Lunch',
        normalHeading: 'Networking Lunch',
      },
    ],
  },
  {
    slug: 'ivca-road-to-ipo-conference',
    title: "IVCA's ROAD TO IPO CONFERENCE",
    startDate: 'July 25, 2023',
    startTime: '06:00 PM',
    location: 'Trident, BKC, Mumbai',
    imgSrc: '/jpeg/roadToIPOv3.jpeg',
    link: 'https://docs.google.com/forms/d/1m5VokGBFzk6VAwuDXiWUX36yLuW1zGCDXwkEIyDAoe8/viewform?edit_requested=true',
    agendaEvents: [
      {
        id: 'road_to_IPO_1',
        timing: {
          start: '11:30am',
          end: '11:55am',
        },
        accentTag: '25 Mins',
        normalHeading: 'Registration Starts',
      },
      {
        id: 'road_to_IPO_2',
        timing: {
          start: '11:55am',
          end: '12:55pm',
        },
        accentTag: '60 Mins',
        normalHeading: 'Networking Lunch',
      },
      {
        id: 'road_to_IPO_3',
        timing: {
          start: '12:55pm',
          end: '1:00pm',
        },
        accentTag: '5 Mins',
        normalHeading: 'Welcome Address',
      },
      {
        id: 'road_to_IPO_4',
        timing: {
          start: '1:00pm',
          end: '1:40pm',
        },
        accentTag: '40 Mins',
        normalHeading: 'Session by Avendus',
        listContent: [
          'Introduction to IPOs',
          'Preparing for a successful IPO',
          'Overview of the Indian IPO markets',
          'IPO process and valuation',
          'Public market investor lens',
          'Roadshows and marketing',
        ],
        speakers: [
          {
            name: 'Gaurav Sood',
            designation:
              'Managing Director and Head, Equity Capital Markets, Avendus',
          },
        ],
      },
      {
        id: 'road_to_IPO_5',
        timing: {
          start: '1:40pm',
          end: '2:20pm',
        },
        accentTag: '40 Mins',
        normalHeading: 'Session by IndusLaw',
        listContent: [
          'Introduction to IPOs',
          'Pre-IPO preparation',
          'Regulatory framework',
          'Important concepts',
          'Drafting the prospectus',
        ],
        speakers: [
          {
            name: 'Manan Lahoty',
            designation: 'Partner, IndusLaw',
          },
        ],
      },
      {
        id: 'road_to_IPO_6',
        timing: {
          start: '2:20pm',
          end: '3:00pm',
        },
        accentTag: '40 Mins',
        normalHeading: 'Session by Deloitte',
        listContent: [
          'Financial Statements',
          'KPIs and comfort letters',
          'Internal controls',
        ],
        speakers: [
          {
            name: 'Sunder Iyer',
            designation: 'Subject Matter Expert',
          },
        ],
      },
      {
        id: 'road_to_IPO_7',
        timing: {
          start: '3:00pm',
          end: '3:20pm',
        },
        accentTag: '20 Mins',
        normalHeading: 'Networking Tea/Coffee',
      },
      {
        id: 'road_to_IPO_8',
        timing: {
          start: '3:20pm',
          end: '4:00pm',
        },
        accentTag: '20 Mins',
        normalHeading:
          'Panel discussion: Road to IPO and beyond – fund managers perspective',
        speakers: [
          {
            name: 'Srinath S',
            designation:
              'Chief Executive Officer, Oman India Joint Investment Fund',
          },
          {
            name: 'Pranav Parikh',
            designation: 'Managing Partner and Head, Nuvama Private Equity',
          },
          {
            name: 'Sandeep Singh',
            designation: 'Managing Director, Everstone Capital',
          },
          {
            name: 'Vinayak Shenvi',
            designation: 'Partner & CIO, CX Partners',
          },
          {
            name: 'Imran Jafar',
            designation: 'Managing Partner, Gaja Capital',
          },
          {
            name: 'Abhiroop Lahiri',
            designation: 'Partner, IndusLaw (Moderator)',
          },
        ],
      },
      {
        id: 'road_to_IPO_9',
        timing: {
          start: '4:00pm',
          end: '4:40pm',
        },
        accentTag: '40 Mins',
        normalHeading:
          'Panel discussion: from scaling to listing – promoters perspective',
        speakers: [
          {
            name: 'Ankit Mehta',
            designation: 'Co-Founder & CEO, ideaForge',
          },
          {
            name: 'Hirendra Divgi',
            designation: 'Managing Director, Divgi TorqTransfer Systems',
          },
          {
            name: 'Sreekanth Nadella',
            designation: 'Managing Director And CEO, KFIN Technologies Limited',
          },
          {
            name: 'Ravi Dubey',
            designation: 'Partner, IndusLaw',
          },
          {
            name: 'Andy Khanna',
            designation: 'National Leader Private Equity, Deloitte (Moderator)',
          },
        ],
      },
      {
        id: 'road_to_IPO_10',
        timing: {
          start: '4:40pm',
          end: '5:30pm',
        },
        accentTag: '50 Mins',
        normalHeading: 'Networking Wine & Cheese',
      },
    ],
  },
  {
    slug: 'ivca-mic-singapore',
    title: 'Maximum India Conclave: Singapore Edition',
    startDate: 'September 20, 2023',
    startTime: '06:00 PM',
    accentLabel: 'India’s Investment Landscape: From Insights to Impact',
    imgSrc: '/jpeg/mic-singapore.jpeg',
    contact: [
      {
        name: 'Aakriti Bamniyal',
        email: 'aakriti@ivca.in',
        phone: '+91 9711110011',
        designation: 'Sr. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
      },
      {
        name: 'Sumeet Shetty',
        email: 'sumeet@ivca.in',
        phone: '+91 99998 93276',
        designation: 'Asst. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993102296848134363.jpg',
      },
      {
        name: 'Shreya Kumar',
        email: 'shreya@ivca.in',
        phone: '+91 95609 22999',
        designation: 'Manager - Member Relations & Knowledge Series',
        image: 'https://static.levocdn.com/WGLBUT82/6997905993761010384.png',
      },
    ],
    // link: 'https://docs.google.com/forms/d/1m5VokGBFzk6VAwuDXiWUX36yLuW1zGCDXwkEIyDAoe8/viewform?edit_requested=true',
    programHighlights: [
      "In-depth content sessions encapsulating the essence of India's investment milieu.",
      'Exclusive LP-GP Networking opportunities, fostering the exchange of ideas and collaboration.',
    ],
    eventOverview:
      "Witness India's incredible journey of the past decade as it establishes a commendable standing in the global arena. Its promising trajectory suggests that by the end of this decade, India will be fueling a staggering one-fifth of the world's growth. The burgeoning Private Equity/Venture Capital sector in India garners an impressive $55-60 Bn annually. The MIC, Singapore Edition will provide a comprehensive outlook on the lucrative 'India Opportunity' for alternate asset investors.",
    agendaEvents: [
      {
        id: 'mic_singapore_1',
        timing: {
          start: '6:00pm',
          end: '6:30pm',
        },
        accentTag: '30 Mins',
        normalHeading: 'Event Schedule',
      },
      {
        id: 'mic_singapore_2',
        timing: {
          start: '6:30pm',
          end: '6:40pm',
        },
        accentTag: '10 Mins',
        normalHeading: 'Registration and Networking High Tea',
      },
      {
        id: 'mic_singapore_3',
        timing: {
          start: '6:40pm',
          end: '7:00pm',
        },
        accentTag: '20 Mins',
        normalHeading: 'Inaugural Address',
      },
      {
        id: 'mic_singapore_4',
        timing: {
          start: '7:00pm',
          end: '7:30pm',
        },
        accentTag: '30 Mins',
        normalHeading:
          'Spotlight:  An overview of the private capital spotlight in India',
        // listContent: [
        //   'Introduction to IPOs',
        //   'Preparing for a successful IPO',
        //   'Overview of the Indian IPO markets',
        //   'IPO process and valuation',
        //   'Public market investor lens',
        //   'Roadshows and marketing',
        // ],
        // speakers: [
        //   {
        //     name: 'Gaurav Sood',
        //     designation:
        //       'Managing Director and Head, Equity Capital Markets, Avendus',
        //   },
        // ],
      },
      {
        id: 'mic_singapore_5',
        timing: {
          start: '7:30pm',
          end: '7:35pm',
        },
        accentTag: '5 Mins',
        normalHeading:
          'Panel Discussion: Decoding India’s Investor & Entrepreneurial Ecosystem',
        // listContent: [
        //   'Introduction to IPOs',
        //   'Pre-IPO preparation',
        //   'Regulatory framework',
        //   'Important concepts',
        //   'Drafting the prospectus',
        // ],
        // speakers: [
        //   {
        //     name: 'Manan Lahoty',
        //     designation: 'Partner, IndusLaw',
        //   },
        // ],
      },
      {
        id: 'mic_singapore_6',
        timing: {
          start: '7:35pm',
          end: '9:30pm',
        },
        accentTag: '115 Mins',
        normalHeading: 'Concluding Remarks: Reflections & Forward-Look',
        // listContent: [
        //   'Financial Statements',
        //   'KPIs and comfort letters',
        //   'Internal controls',
        // ],
        // speakers: [
        //   {
        //     name: 'Sunder Iyer',
        //     designation: 'Subject Matter Expert',
        //   },
        // ],
      },
      {
        id: 'mic_singapore_7',
        timing: {
          start: '9:30pm',
        },
        accentTag: 'Onwards',
        normalHeading: 'Networking Cocktails and Dinner',
      },
    ],
  },
  {
    slug: 'ivca-green-future-series-2.0',
    title: 'IVCA Green Future Series: Managing Data & Climate Analytics',
    startDate: 'November 2, 2023',
    startTime: '03:00 PM',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/7123965865100612505.jpg',
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSfLq7koeliE2IDE49PQA7rwDaKTYNPmkOxjgd0mG3fJGAb84w/viewform',
    contact: [
      {
        name: 'Aakriti Bamniyal',
        email: 'aakriti@ivca.in',
        phone: '+91 9711110011',
        designation: 'Sr. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
      },
      {
        name: 'Sumeet Shetty',
        email: 'sumeet@ivca.in',
        phone: '+91 99998 93276',
        designation: 'Asst. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993102296848134363.jpg',
      },
      {
        name: 'Shreya Kumar',
        email: 'shreya@ivca.in',
        phone: '+91 95609 22999',
        designation: 'Manager - Member Relations & Knowledge Series',
        image: 'https://static.levocdn.com/WGLBUT82/6997905993761010384.png',
      },
    ],

    agendaEvents: [
      {
        id: 'ivca_green_future_1',
        timing: {
          start: '3:00 PM',
          end: '3:15 PM',
        },
        accentTag: '15 Mins',
        normalHeading: 'Keynote Discussion on Investments in Climate Analytics',
        speakers: [
          {
            name: 'Samir Shah',
            designation: 'Managing Partner, Peak Sustainability Ventures',
          },
        ],
      },
      {
        id: 'ivca_green_future_2',
        timing: {
          start: '3:15 PM',
          end: '4:00 PM',
        },
        accentTag: '45 Mins',
        normalHeading: 'Panel Discussion on Managing Data in Climate Analytics',
        speakers: [
          {
            name: 'Anupam Rai',
            designation: 'SVP,Client & Data Delivery GIST Impact',
          },
          { name: 'Raj Pao', designation: 'Managing Partner, GEF Capital' },
          {
            name: 'Akash Shah',
            designation: 'Partner, Peak Sustainability Ventures',
          },
        ],
      },
    ],
    overviewTitle: 'Event Overview',
    eventOverview: [
      'We at IVCA are hosting the next edition of IVCA Green Future Series on the 2nd November 2023 (Thursday) on the topic Managing Data & Climate Analytics scheduled from 3 p.m. to 4 p.m.',
      "We are hosting the session in a virtual meeting format which will allow you to be at the forefront of a change that's reshaping the ecosystem. Don't miss this unique opportunity to understand, engage, and invest in a cleaner and greener future.",
    ],
    programTitle: 'Session would discuss:',
    programHighlights: [
      'How climate analytics can help investors identify and manage risks. - How to identify the physical and financial risks of climate change to specific companies, sectors, and regions, such as the risk of sea level rise, extreme weather events, and supply chain disruptions.',
      'How climate analytics can help investors identify investment opportunities - Identify companies and sectors that are well-positioned to succeed in the transition to a low-carbon economy.',
      'The role of climate analytics in ESG investing - Use of climate analytics to assess the ESG performance of portfolio companies and to identify companies that are taking steps to reduce their environmental impact.',
      'The use of climate analytics to inform public policy on climate change - Development and implementation of public policies that are designed to mitigate climate change and to adapt to its impacts.',
    ],
  },

  {
    slug: 'ivca-green-future-series',
    title:
      'IVCA Green Future Series: Transition from ICE to EV ~$1 Trillion Investment Opportunity',
    startDate: 'September 12, 2023',
    startTime: '02:45 PM',
    imgSrc: '/png/green-future.png',
    link: 'https://forms.gle/svVms5tBovTD9RKs9',
    agendaEvents: [
      {
        id: 'ivca_green_future_1',
        timing: {
          start: '2:45pm',
          end: '3:00pm',
        },
        accentTag: '15 Mins',
        normalHeading:
          'Special Address by Satish Mandhana, Senior MD & CIO, Eversource Capital',
      },
      {
        id: 'ivca_green_future_2',
        timing: {
          start: '3:00pm',
          end: '4:00pm',
        },
        accentTag: '60 Mins',
        normalHeading: 'Session',
        speakers: [
          {
            name: 'Akshay Shekhar',
            designation: 'Founder, Kazam',
          },
          {
            name: 'Kunal Khattar',
            designation: 'Founder & Managing Partner, AdvantEdge',
          },
          {
            name: 'Saurav Kumar',
            designation: 'Founder & CEO, Euler Motors',
          },
          {
            name: 'Kishlaya Mishra',
            designation: 'Senior Investment Officer, AIIB',
          },
          {
            name: 'Sheetal Bahl',
            designation: 'Partner, Merak Ventures',
          },
          {
            name: 'Priya Shah',
            designation: 'General Partner, Theia Ventures (Moderator)',
          },
        ],
      },
    ],
  },
  {
    slug: 'ivca-whats-next-linkedin',
    title:
      "IVCA's #What'sNext Driving Sustainable Growth: Impact Investing in India's Alternate Asset Industry",
    startDate: 'July 27, 2023',
    startTime: '12:00 PM',
    location: 'Hosted on LinkedIn Live',
    imgSrc: '/jpeg/whatsnextv2.jpeg',
    link: 'https://www.linkedin.com/events/7089146142914981889/comments/',
    agendaEvents: [
      {
        id: 'whats_next_1',
        timing: {
          start: '12:00pm',
        },
        accentTag: '1 hour',
        normalHeading: 'Session Details:',
        listContent: [
          'Investment Decisions and Driving Factors: Discover how impactful investment decisions are made as our panelists discuss the companies their funds have invested in and the driving factors behind those decisions.',
          'Investment and Exit Strategies: Learn about successful impact investment strategies and the guiding mantras for achieving sustainable returns.',
          'Overview of the Indian IPO markets',
          'Impact Investment through the SDG Lens: Gain insights into operationalizing impact investment through the SDG lens.',
          'Evolving Fund Management Industry: Discuss the evolving nature of the fund management industry and the need for inward-looking structures that align with the Indian market.',
          'Motivations Behind Sustainable Investing: Explore the motivations behind sustainable investing and the passion for specific sub-sectors.',
          "The Future of Sustainable Investing: Gain valuable insights into the panelists' outlook for sustainable investing in the next three years.",
        ],
        // speakers: [
        //   {
        //     name: 'Gaurav Sood',
        //     designation:
        //       'Managing Director and Head, Equity Capital Markets, Avendus',
        //   },
        // ],
      },
    ],
  },
  {
    slug: 'ivca-digital-personal-data-protection-bill-webinar',
    title: 'IVCA Digital Personal Data Protection Bill Webinar',
    startDate: 'September 21, 2023',
    startTime: '2:00 PM',
    // location: 'Hosted on LinkedIn Live',
    contact: [
      {
        name: 'Sreeram Sridhar',
        email: 'sreeram@ivca.in',
        image: 'https://static.levocdn.com/WGLBUT82/7059472688130418526.jpg',
        designation: 'Associate',
      },
    ],
    imgSrc: '/png/data-bill.png',
    link: 'https://forms.gle/Z2gUPAuPeUJwqqgt8',
    agendaEvents: [
      {
        id: 'data_bill_1',
        timing: {
          start: '2:00pm',
          end: '2:05pm',
        },
        accentTag: '5 Mins',
        normalHeading:
          'Opening Remark by Siddarth Pai, Co-Chair, Regulatory Affairs, IVCA',
      },
      {
        id: 'data_bill_2',
        timing: {
          start: '2:05pm',
          end: '2:15pm',
        },
        accentTag: '10 Mins',
        normalHeading:
          'Presentation on the Digital Personal Data Protection Bill by Partner, Deloitte',
        speakers: [
          {
            name: 'Goldie Dhama',
            designation: 'Partner, Deloitte',
          },
        ],
      },
      {
        id: 'data_bill_3',
        timing: {
          start: '2:15pm',
          end: '2:35pm',
        },
        accentTag: '20 Mins',
        normalHeading: 'Fireside with Investors',
        speakers: [
          {
            name: 'Supratim Chakraborty',
            designation: 'Partner, Khaitan & Co.',
          },
          {
            name: 'Siddarth Pai',
            designation: 'Co-Chair, Regulatory Affairs, IVCA',
          },
          {
            name: 'Neha Aggarwal',
            designation: 'Partner, Deloitte (Moderator)',
          },
        ],
      },
      {
        id: 'data_bill_4',
        timing: {
          start: '2:35pm',
          end: '2:55pm',
        },
        accentTag: '20 Mins',
        normalHeading: 'Fireside with Founders',
        speakers: [
          {
            name: 'Shobhit Chandra',
            designation: 'Counsel, Khaitan & Co.',
          },
          {
            name: 'Vaibhav Vardhan',
            designation: 'Inc42',
          },
          {
            name: 'Naiyya Saggi',
            designation: 'The Good Glamm Group',
          },
          {
            name: 'Manish Taneja',
            designation: 'Purple',
          },
          {
            name: 'Joyce Rodriguez',
            designation: 'Partner, Deloitte (Moderator)',
          },
        ],
      },
      {
        id: 'data_bill_5',
        timing: {
          start: '2:55pm',
          end: '2:25pm',
        },
        accentTag: '30 Mins',
        normalHeading: 'Townhall Session',
        listContent: [
          'An open platform for attendees to raise questions, initiate discussions, and provide feedback on discussed topics',
        ],
        // speakers: [
        //   {
        //     name: 'Gaurav Sood',
        //     designation:
        //       'Managing Director and Head, Equity Capital Markets, Avendus',
        //   },
        // ],
      },
    ],
  },
  {
    slug: 'ivca-climate-and-sustainability-conference',
    title: 'IVCA Climate and Sustainability Conference',
    startDate: 'December 12, 2023',
    startTime: '12:00 PM',
    imgSrc: '/webp/calendar_bg.webp',
  },
  {
    slug: 'ivca-circles',
    title: 'IVCA Circles',
    startDate: 'October 10, 2023',
    startTime: '4:00 PM',
    location: 'Delhi',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/7117107494171834827.png',
    contact: [
      {
        name: 'Aakriti Bamniyal',
        email: 'aakriti@ivca.in',
        phone: '+91 9711110011',
        designation: 'Sr. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
      },
      {
        name: 'Sumeet Shetty',
        email: 'sumeet@ivca.in',
        phone: '+91 99998 93276',
        designation: 'Asst. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993102296848134363.jpg',
      },
      {
        name: 'Shreya Kumar',
        email: 'shreya@ivca.in',
        phone: '+91 95609 22999',
        designation: 'Manager - Member Relations & Knowledge Series',
        image: 'https://static.levocdn.com/WGLBUT82/6997905993761010384.png',
      },
    ],
    /** webinar page pending  */
    // link: 'https://docs.google.com/forms/d/e/1FAIpQLSd01uW9QZ_myEWCLT59p3GJM9GSLmwwgpKAaCpCLT88pceqdg/viewform',
    agendaEvents: [
      {
        id: 'circle_1',
        timing: {
          start: '4:00pm',
          end: '4:50pm',
        },
        accentTag: '50 Mins',
        normalHeading: 'Registration ',
      },
      {
        id: 'circle_2',
        timing: {
          start: '4:50pm',
          end: '5:00pm',
        },
        accentTag: '10 Mins',
        normalHeading: 'Welcome Address',
      },
      {
        id: 'circle_4',
        timing: {
          start: '5:00pm',
          end: '5:20pm',
        },
        accentTag: '20 Mins',
        normalHeading: 'Keynote Address',

        speakers: [
          {
            name: 'Smt. Manmeet K. Nanda',
            designation:
              'Joint Secretary Ministry of Commerce & Industry, Department for Promotion of Industry and Internal Trade (DPIIT)',
          },
        ],
      },
      {
        id: 'circle_5',
        timing: {
          start: '5:20pm',
          end: '6:00pm',
        },
        accentTag: '40 Mins',
        normalHeading:
          'Panel Discussion: Navigating the Global landscape: Challenges and Opportunity for Indian Startup',
        speakers: [
          {
            name: 'Amitabh Nagpal',
            designation: 'Head - Startup Ecosystem, AWS India',
          },
          {
            name: 'Niraj Singh',
            designation: 'Founder, Spinny',
          },
          {
            name: 'Satyam Darmora',
            designation: 'Co-Founder, Wiom',
          },
          {
            name: 'Puja Sondhi',
            designation: 'Partner, Shardul Amarchand Mangaldas & Co.',
          },
          {
            name: 'Swati Gupta',
            designation: 'Co-Founder & CEO, Industry Buying',
          },
          {
            name: 'Tushar Garg',
            designation: 'Co-Founder & CBO, BluSmart',
          },
          {
            name: 'Ishpreet Gandhi',
            designation:
              'Founder & Managing Partner,Stride Venture (Moderator))',
          },
        ],
      },
      {
        id: 'circle_6',
        timing: {
          start: '6:00pm',
          end: '6:20pm',
        },
        accentTag: '20 Mins',
        normalHeading:
          'Value Creation: Guiding the Investee Company for Sustained Growth & Beyond',
        speakers: [
          {
            name: 'Jayant Basu',
            designation: 'Manging Partner, CX Partners',
          },
          {
            name: 'Rahul Bhasin',
            designation: 'Managing Partner,Baring Private Equity Partner',
          },
          {
            name: 'Nisha Poddar ',
            designation: 'Editor and Anchor, CNBC TV18 (Moderator)',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '6:20pm',
          end: '7:00 pm',
        },
        accentTag: '40 Min',
        normalHeading:
          'Panel Discussion : LP Perspective on the current state of Fund Raising for Manager',
        speakers: [
          {
            name: 'Craig Gifford ',
            designation:
              'Head of South Asia Private Equity Funds, British International Investment (BII)',
          },
          {
            name: 'Gaurav Kapoor ',
            designation: 'Head Capital, British High Commmission',
          },
          {
            name: 'Nidhi Ghuman ',
            designation: 'Senior EVP 360 ONE Asset',
          },
          {
            name: 'Nitai Utkarsh ',
            designation: 'Lead- Investment Strategy, Hero MotoCorp',
          },
          {
            name: 'Pratibha Jain ',
            designation:
              'Head of Strategy & Group General Counsel, Everstone Group',
          },
          {
            name: 'Karan Mohla ',
            designation: 'Partner, B Capital Group (Moderator)',
          },
        ],
      },
      {
        id: 'circle_8',
        timing: {
          start: '7:00 pm',
          end: '7:05 pm',
        },
        accentTag: '5 Min',
        normalHeading: 'Closing Remarks',
        speaker: [
          {
            name: 'Rajat Tondon ',
            designation: 'President, IVCA',
          },
        ],
      },
      {
        id: 'circle_9',
        timing: {
          start: '7:05 pm',
          end: 'Onwards',
        },
        accentTag: 'Onwards',
        normalHeading: 'Networking Cocktail & Dinner',
      },
    ],
  },
  {
    slug: 'ivca-private-credit-summit',
    title: 'IVCA Private Credit Summit 2023',
    startDate: 'Decemeber 6th, 2023',
    location: 'Mumbai',
    startTime: '11:30 AM',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/7135886103199329294.png',
    // imgSrc: '/png/ivca_private_preview.png',
    // link: 'https://forms.gle/ALar6Viid6mgWeFs7',
    contact: [
      {
        name: 'Aakriti Bamniyal',
        email: 'aakriti@ivca.in',
        phone: '+91 9711110011',
        designation: 'Sr. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
      },
      {
        name: 'Sumeet Shetty',
        email: 'sumeet@ivca.in',
        phone: '+91 99998 93276',
        designation: 'Asst. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993102296848134363.jpg',
      },
      {
        name: 'Shreya Kumar',
        email: 'shreya@ivca.in',
        phone: '+91 95609 22999',
        designation: 'Manager - Member Relations & Knowledge Series',
        image: 'https://static.levocdn.com/WGLBUT82/6997905993761010384.png',
      },
    ],
    eventOverview:
      "Join industry leaders and policymakers at the forefront of India's burgeoning private credit sector for a day of in-depth discussions and networking.",
    programHighlights: [
      "Each session will be an opportunity to gain insights from the leading minds in the industry. We will delve into the current trends, investment strategies, and the future outlook of India's private credit landscape.",
      'Join us as we explore the opportunities and navigate the challenges of this dynamic sector.',
    ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '11:15 AM',
          end: '11:40 AM',
        },
        accentTag: '25 Mins',
        normalHeading: 'REGISTRATION & NETWORKING TEA/COFFEE',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '11:40 AM',
          end: '12:40 PM',
        },
        accentTag: '60 Mins',
        normalHeading: 'NETWORKING LUNCH',
      },
      {
        id: 'ivca_private_3',
        timing: {
          start: '12:40 PM',
          end: '12:45 PM',
        },
        accentTag: '5 Mins',
        normalHeading: 'WELCOME ADDRESS',
        speaker: [
          {
            name: 'Rajat Tondon ',
            designation: 'President, IVCA',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '12:45 PM',
          end: '1:00 PM',
        },
        accentTag: '15 Mins',
        normalHeading:
          'PRIVATE CREDIT REPORT LAUNCH & PRESENTATION: BY IVCA & PRAXIS GLOBAL ALLIANCE',
        speakers: [
          {
            name: 'Madhur Singhal',
            designation: 'Managing Partner and CEO at Praxis Global Alliance ',
          },
        ],
      },

      {
        id: 'ivca_private_4',
        timing: {
          start: '1:00 PM',
          end: '1:20 PM',
        },
        accentTag: '20 Mins',
        normalHeading:
          'FIRESIDE CHAT: POLICYMAKERS PERSPECTIVE ON PRIVATE CREDIT MARKET IN INDIA',
        speakers: [
          {
            name: 'Shri. Ananth Narayan G',
            designation: 'Whole Time Member, SEBI',
          },
          {
            name: 'Venkat Ramaswamy',
            designation: 'Vice Chairman, Edelweiss Financial Services',
          },
        ],
      },
      {
        id: 'ivca_private_5',
        timing: {
          start: '1:20 PM',
          end: '2:00 PM',
        },
        accentTag: '40 Mins',
        normalHeading:
          'PANEL DISCUSSION - INVESTING IN PERFORMING CREDIT AND SPECIAL SITUATIONS IN INDIA',
        listContent: [
          ' How big is the Performing Credit and Special Situations space in India',
          ' What are the key considerations for Indian market vis-a-vis International market',
          'What are the entry experiences and challenges faced by investors before deployment of funds',
          'Discussion on existing regulatory framework and proposed amendments',
          ' What is the Private Credit market outlook over next 3-5 years',
        ],
        speakers: [
          {
            name: 'Aakash Desai',
            designation: 'CIO and Head Private Credit, 360One Asset Management',
          },
          {
            name: 'Monu Jain',
            designation: ' Partner - Credit, Aavishkaar Capital',
          },
          {
            name: 'Nilesh Dhedhi',
            designation:
              'Managing Director & CEO, Avendus Finance Private Limited',
          },
          {
            name: 'Piyush Gupta',
            designation: ' Head of Credit Markets, Investec Capital',
          },
          {
            name: 'Sabita Prakash',
            designation: ' Managing Director, Asia Pacific, ADM Capital',
          },
          {
            name: 'Rishi Aswani',
            designation:
              'Managing Director Financial and Valuation Advisory, Houlihan Lokey (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_6',
        timing: {
          start: '2:00 PM',
          end: '2:20 PM',
        },
        accentTag: '20 Mins',
        normalHeading:
          'FIRESIDE CHAT: BUILDING DOMESTIC CAPITAL POOLS FOR PRIVATE CREDIT',
        speakers: [
          {
            name: 'Shri. S Ramann',
            designation: ' CMD, SIDBI',
          },
          {
            name: 'Nipun Sahni',
            designation: ' Partner, Apollo Global Management',
          },
        ],
      },
      {
        id: 'ivca_private_7',
        timing: {
          start: '2:20 PM',
          end: '2:40 PM',
        },
        accentTag: '20 Mins',
        normalHeading: 'NETWORKING TEA/COFFEE',
      },
      {
        id: 'ivca_private_8',
        timing: {
          start: '2:50 PM',
          end: '3:30 PM',
        },
        accentTag: '40 Mins',
        normalHeading:
          'PANEL DISCUSSION: THE REAL ESTATE OPPORTUNITY IN INDIA’S PRIVATE CREDIT SPACE',
        listContent: [
          'Real estate sector alone accounts for more than 30% of $5Bn Private Credit Investments in India made in 2022',
          'Indian real estate needs more than $8-10 billion of credit per annum',
          'In this panel, Real Estate Fund Managers will give their perspectives on RE credit Investments and outlook',
        ],
        speakers: [
          {
            name: 'Amit Bhagat',
            designation:
              ' CEO & Managing Director, ASK Property Investment Advisors',
          },
          {
            name: 'Avnish Singh',
            designation: 'Managing Director, RMZ Corp Mixed Use',
          },
          {
            name: 'Rahul Rai',
            designation:
              ' Head - Real Estate Investment Business, ICICI Prudential AMC',
          },
          {
            name: 'Vikas Chimakurthy',
            designation: 'CEO, Kotak Realty Fund',
          },
          {
            name: 'Bhairav Dalal',
            designation: 'Partner, PwC India (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_9',
        timing: {
          start: '3:30 PM',
          end: '3:50 PM',
        },
        normalHeading:
          'FIRESIDE CHAT: CREATING NEW DESTINATIONS FOR GLOBAL CAPITAL IN PRIVATE CREDIT',
        accentTag: '20 Mins',
        speakers: [
          {
            name: 'Shri. K Rajaraman',
            designation:
              ' Chairperson, International Financial Services Centres Authority (IFSCA)',
          },
          {
            name: 'Venkat Ramaswamy',
            designation: 'Vice Chairman, Edelweiss Financial Services',
          },
        ],
      },
      {
        id: 'ivca_private_8',
        timing: {
          start: '3:50 PM',
          end: '4:30 PM',
        },
        normalHeading:
          'PANEL DISCUSSION - POST INVESTMENT VALUE CREATION AND EXIT EXPERIENCE',
        accentTag: '40 Mins',
        listContent: [
          'Value creation in Special Situation  deals vs Private Equity deals',
          'Differing approaches post investing in performing versus high yield situations',
          'Post Investment Monitoring in performing credit and special situations',
          'Operational turnaround experience in distress/insolvency situations',
          'Exit experience of few recent marquee deals',
        ],
        speakers: [
          {
            name: 'Apoorva Sharma',
            designation: ' Managing Partner, Stride Ventures',
          },
          {
            name: 'Eshwar Karra',
            designation: 'CEO, Kotak Special Situations Fund',
          },
          {
            name: 'Kriti Ghosh',
            designation:
              'Managing Director, Special Situations Fund, Edelweiss Alternative Asset Advisors',
          },
          {
            name: 'Kapil Singhal',
            designation: 'Managing Partner, Private Credit, True North',
          },
          {
            name: 'Saurabh Jhalaria',
            designation:
              'Chief Investment Officer (CIO)- Credit Strategies, InCred Alternative Investments',
          },
          {
            name: 'Nilang Desai',
            designation: 'Senior Partner, AZB (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_10',
        timing: {
          start: '4:30 PM',
          end: '6:00 PM',
        },
        normalHeading: 'NETWORKING COCKTAILS AND SNACKS',
        accentTag: '90 Mins',
      },
    ],
    speakers: [
      {
        name: 'Shri. K Rajaraman',
        email: '',
        phone: '',
        designation: 'Chairperson',
        image: 'https://static.levocdn.com/WGLBUT82/7135216477647536838.jpg',
        gov: true,
        fund: 'International Financial Services Centres Authority (IFSCA)',
      },
      {
        name: 'Shri. Ananth Narayan G',
        email: '',
        phone: '',
        designation: 'Whole Time Member',
        image: 'https://static.levocdn.com/WGLBUT82/7130243903793469867.png',
        gov: true,
        fund: 'Securities and Exchange Board of India (SEBI)',
      },
      {
        name: 'Shri. S Ramann',
        email: '',
        phone: '',
        designation: 'CMD',
        image: ' https://static.levocdn.com/WGLBUT82/7130243903704483505.png',
        gov: true,
        fund: 'SIDBI',
      },

      {
        name: 'Madhur Singhal',
        email: '',
        phone: '',
        designation: 'Managing Partner and CEO',
        image: 'https://static.levocdn.com/WGLBUT82/7135648803370288879.jpg',
        gov: false,
        fund: 'Praxis Global Alliance',
      },

      {
        name: 'Venkat Ramaswamy',
        email: '',
        phone: '',
        designation: 'Vice Chairman',
        image: 'https://static.levocdn.com/WGLBUT82/7131182575085441791.jpg',
        gov: false,
        fund: 'Edelweiss Financial Services',
      },

      {
        name: 'Aakash Desai',
        email: '',
        phone: '',
        designation: 'CIO and Head Private Credit',
        image: 'https://static.levocdn.com/WGLBUT82/7131183562707280471.jpeg',
        gov: false,
        fund: '360One Asset Management',
      },
      {
        name: 'Monu Jain',
        email: '',
        phone: '',
        designation: 'Partner - Credit',
        image: 'https://static.levocdn.com/WGLBUT82/7131183095322300859.jpeg',
        gov: false,
        fund: 'Aavishkaar Capital',
      },
      {
        name: 'Nilesh Dedhi',
        email: '',
        phone: '',
        designation: 'Managing Director & CEO',
        image: 'https://static.levocdn.com/WGLBUT82/7130243903602757529.jpg ',
        gov: false,
        fund: 'Avendus Finance Private Limited',
      },

      {
        name: 'Piyush Gupta',
        email: '',
        phone: '',
        designation: 'Head of Credit Markets',
        image: 'https://static.levocdn.com/WGLBUT82/7130244856559309199.jpeg',
        gov: false,
        fund: 'Investec Capital',
      },

      {
        name: 'Sabita Prakash',
        email: '',
        phone: '',
        designation: 'Managing Director, Asia Pacific',
        image: 'https://static.levocdn.com/WGLBUT82/7131182926298849962.jpg',
        gov: false,
        fund: 'ADM Capital',
      },
      {
        name: 'Rishi Aswani',
        email: '',
        phone: '',
        designation: 'Managing Director-Financial and Valuation Advisory',
        image: ' https://static.levocdn.com/WGLBUT82/7130243903607735197.jpg',
        gov: false,
        fund: 'Houlihan Lokey',
      },

      {
        name: 'Nipun Sahni',
        email: '',
        phone: '',
        designation: 'Partner ',
        image: 'https://static.levocdn.com/WGLBUT82/7131183308767082693.jpg',
        gov: false,
        fund: 'Apollo Global Management',
      },

      // {
      //   name: 'Srini Sriniwasan',
      //   email: '',
      //   phone: '',
      //   designation: 'Managing Director',
      //   image: 'https://static.levocdn.com/WGLBUT82/7130243903725429725.png',
      //   gov: false,
      //   fund: 'Kotak Alternate Asset Managers',
      // },
      {
        name: 'Amit Bhagat',
        designation: ' CEO & Managing Director',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/7131183424369490164.jpg',
        gov: false,
        fund: ' ASK Property Investment Advisors',
      },
      {
        name: 'Avnish Singh',
        designation: 'Managing Director',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/7135576571169627050.jpg',
        gov: false,
        fund: ' RMZ Corp Mixed Use',
      },

      {
        name: 'Rahul Rai',
        email: '',
        phone: '',
        designation: 'Head - Real Estate Investment Business',
        image: 'https://static.levocdn.com/WGLBUT82/7130243903601828483.jpg',
        gov: false,
        fund: 'ICICI Prudential AMC',
      },

      {
        name: 'Vikas Chimakurthy',
        email: '',
        phone: '',
        designation: 'CEO ',
        image: 'https://static.levocdn.com/WGLBUT82/7130243903762365141.jpeg',
        gov: false,
        fund: 'Kotak Realty Fund',
      },
      {
        name: 'Bhairav Dalal',
        designation: 'Partner ',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/7135576571164379626.png',
        gov: false,
        fund: 'PwC India ',
      },

      {
        name: 'Apoorva Sharma',
        designation: ' Managing Partner ',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/7135576571168494160.jpeg',
        gov: false,
        fund: 'Stride Ventures',
      },
      {
        name: 'Eshwar Karra',
        email: '',
        phone: '',
        designation: 'CEO',
        image: ' https://static.levocdn.com/WGLBUT82/7130491158572344809.jpeg',
        gov: false,
        fund: 'Kotak Special Situations Fund',
      },
      {
        name: 'Kriti Ghosh',
        email: '',
        phone: '',
        designation: 'Managing Director',
        image: ' https://static.levocdn.com/WGLBUT82/7130243903599684291.jpeg',
        gov: false,
        fund: 'Edelweiss Alternative Asset Advisors',
      },

      {
        name: 'Kapil Singhal',
        email: '',
        phone: '',
        designation: 'Managing Partner, Private Credit',
        image: 'https://static.levocdn.com/WGLBUT82/7130243903556585005.png',
        gov: false,
        fund: 'True North',
      },
      {
        name: 'Saurabh Jhalaria',
        designation: ' CIO - Credit Strategies',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/7135642429437330959.jpg',
        gov: false,
        fund: 'InCred Alternative Investments',
      },

      {
        name: 'Nilang Desai',
        email: '',
        phone: '',
        designation: 'Senior Partner',
        image: 'https://static.levocdn.com/WGLBUT82/7131183095327036641.jpeg',
        gov: false,
        fund: 'AZB',
      },
    ],
    logos: [
      {
        name: 'Avendus',
        _id: '2',
        logo: 'https://static.levocdn.com/WGLBUT82/7135949151526737028.png',
        website_link: '',
      },
      {
        name: 'Investec',
        _id: '1',
        logo: 'https://static.levocdn.com/WGLBUT82/7135949151532324360.png',
        website_link: '',
      },
      {
        name: 'InCred Alternative Investments',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/7135950261248553781.png',
        website_link: '',
      },
      {
        name: 'Houlihan Lokey',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/7135949151534517525.png',
        website_link: '',
      },
      {
        name: 'PwC',
        _id: '2',
        logo: 'https://static.levocdn.com/WGLBUT82/7135949151534698681.png',
        website_link: '',
      },
    ],
  },
  {
    slug: 'ivca-secondaries-conference-2.0',
    title: 'IVCA SECONDARIES CONFERENCE',
    startDate: 'December 4, 2023',
    startTime: '09:30 AM',
    location: 'Bengaluru',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/7132727355419301509.png',
    link: 'https://docs.google.com/forms/d/1xWW0mDh9ZyMd9dixkaC0iLw5vgUtuclq2JsHEy3NZOs/viewform?edit_requested=true',
    contact: [
      {
        name: 'Sunitha Prasad',
        designation: 'Vice President, IVCA',
        phone: '+91 99724 70000',
        email: 'sunitha@ivca.in',
        image: 'https://static.levocdn.com/WGLBUT82/6993101868986119948.png',
      },
      {
        name: ' Nikita Shukla',
        designation: 'Associate, IVCA',
        phone: '+91 95000 92894',
        email: 'nikita@ivca.in',
        image: 'https://static.levocdn.com/WGLBUT82/7089563426032951113.png',
      },
    ],
    speakers: [
      {
        name: 'Alok Gupta',
        email: '',
        phone: '',
        designation: 'Principal, Head of India',
        image: 'https://static.levocdn.com/WGLBUT82/7132614001882315936.jpg',
        gov: false,
        fund: 'Foundation PE',
      },
      {
        name: 'David Huang',
        email: '',
        phone: '',
        designation: 'Principal',
        image: 'https://static.levocdn.com/WGLBUT82/7132613623125839938.png',
        gov: false,
        fund: 'Stepstone',
      },

      {
        name: 'Divaspati Singh',
        email: '',
        phone: '',
        designation: 'Partner',
        image: 'https://static.levocdn.com/WGLBUT82/7132613623133871430.jpg',
        gov: false,
        fund: 'Khaitan & Co.',
      },

      {
        name: 'Gregory Barclay',
        email: '',
        phone: '',
        designation:
          'Private Investment Funds Partner, Chair of Singapore Office',
        image: 'https://static.levocdn.com/WGLBUT82/7132613623147665356.jpg',
        gov: false,
        fund: 'Goodwin',
      },

      {
        name: 'Jude Wong',
        email: '',
        phone: '',
        designation: 'Director ',
        image: 'https://static.levocdn.com/WGLBUT82/7132613903474958969.jpg',
        gov: false,
        fund: 'Lazard',
      },

      {
        name: 'Krishna Skandakumar',
        email: '',
        phone: '',
        designation: 'Private Funds and Seconadaries Partner',
        image: 'https://static.levocdn.com/WGLBUT82/7132613903477938912.jpg',
        gov: false,
        fund: 'Goodwin',
      },

      {
        name: 'KT Chandy',
        email: '',
        phone: '',
        designation: 'Co-Leader EY Private Tax',
        image: ' https://static.levocdn.com/WGLBUT82/7132613903513623527.jpg',
        gov: false,
        fund: 'EY',
      },

      {
        name: 'Manish Ranjan',
        email: '',
        phone: '',
        designation: 'Private Investment Funds Lawyer',
        image: 'https://static.levocdn.com/WGLBUT82/7132613903550699590.jpg',
        gov: false,
        fund: 'Goodwin',
      },
      {
        name: 'Mohan Kumar',
        email: '',
        phone: '',
        designation: 'Managing Partner',
        image: 'https://static.levocdn.com/WGLBUT82/7132613372261708575.jpeg',
        gov: false,
        fund: 'Avataar Ventures',
      },
      {
        name: 'Shagoofa Rashid Khan',
        email: '',
        phone: '',
        designation: 'Group General Counsel and Head Corporate Affairs',
        image: 'https://static.levocdn.com/WGLBUT82/7132613372372353055.jpg',
        gov: false,
        fund: 'National Investment and Infrastructure Fund (NIIF)',
      },
      {
        name: 'Siddharth Shah',
        email: '',
        phone: '',
        designation: 'Partner',
        image: 'https://static.levocdn.com/WGLBUT82/7132613372394413783.jpg',
        gov: false,
        fund: 'Khaitan & Co.',
      },

      {
        name: 'Vivek Mimani',
        email: '',
        phone: '',
        designation: 'Partner',
        image: '',
        gov: false,
        fund: 'Khaitan & Co.',
      },
      {
        name: 'Sandeep Maheshwari',
        email: '',
        phone: '',
        designation: 'EVP - IIFL PE',
        image: 'https://static.levocdn.com/WGLBUT82/7135952082061446936.jpg',
        gov: false,
        fund: '360 One',
      },

      {
        name: 'Niklas Risberg',
        email: '',
        phone: '',
        designation: 'Vice President',
        image: 'https://static.levocdn.com/WGLBUT82/7132613372263085796.jpg',
        gov: false,
        fund: 'Lexington Partners',
      },
      {
        name: 'Mamtesh Sugla',
        email: '',
        phone: '',
        designation: 'Principal ',
        image: 'https://static.levocdn.com/WGLBUT82/7135952082064255309.jpg',
        gov: false,
        fund: 'TPG NewQuest',
      },
    ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '9:30 AM',
          end: '9:55 AM',
        },
        accentTag: '25 Mins',
        normalHeading: 'REGISTRATION & NETWORKING TEA/ COFFEE',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '10:00 AM',
          end: '10:05 PM',
        },
        accentTag: '05 Mins',
        normalHeading: 'WELCOME ADDRESS',
      },
      {
        id: 'ivca_private_3',
        timing: {
          start: '10:05 AM',
          end: '10:15 AM',
        },
        accentTag: '10 Mins',
        normalHeading:
          'GP LED SECONDARIES IN INDIA – “KEY CONSIDERATIONS AND CHALLENGES”: BY KHAITAN & CO.',
        listContent: [
          'Indian context',
          'Regulatory developments',
          'Structural issues',
        ],
        speakers: [
          {
            name: 'Divaspati Singh',
            designation: 'Partner, Khaitan & Co.',
          },
          {
            name: 'Vivek Mimani',
            designation: 'Partner, Khaitan & Co.',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '10:15 AM',
          end: '10:25 AM',
        },
        accentTag: '10 Mins',
        normalHeading:
          'INTERNATIONAL TRENDS IN SECONDARIES AND RELEVANCE FOR INDIA: BY GOODWIN',
        listContent: [
          'Global developments',
          '	Common structures',
          'Key commercial and regulatory considerations',
          'Investors perspective',
        ],
        speakers: [
          {
            name: 'Manish Ranjan',
            designation: ' Counsel, Goodwin',
          },
          {
            name: 'Krishna Skandakumar',
            designation: 'Private Funds and Secondaries Partner, Goodwin ',
          },
        ],
      },
      {
        id: 'ivca_private_5',
        timing: {
          start: '10:25 AM',
          end: '11:15 AM',
        },
        accentTag: '50 Mins',
        normalHeading:
          'PANEL DISCUSSION: GP LED SECONDARIES – “THE NEXT CHAPTER” (LP Perspectives)',
        speakers: [
          {
            name: 'David Huang ',
            designation: 'Principal, Stepstone',
          },
          {
            name: 'Niklas Risberg ',
            designation: 'Vice President, Lexington Partners',
          },
          {
            name: 'Jude Wong',
            designation: ' Director, Lazard',
          },
          {
            name: 'Mamtesh Sugla ',
            designation: 'Principal, TPG NewQuest',
          },
          {
            name: '	Siddharth Shah ',
            designation: 'Senior Partner, Khaitan & Co.',
          },
          {
            name: 'Gregory Barclay ',
            designation: 'Partner, Goodwin (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_6',
        timing: {
          start: '11:20 AM',
          end: '12:10 PM',
        },
        accentTag: '50 Mins',
        normalHeading:
          'PANEL DISCUSSION: GP PERSPECTIVES ON GP LED SECONDARIES',
        speakers: [
          {
            name: 'K T Chandy',
            designation: 'Co-Leader EY Private Tax, EY',
          },
          {
            name: 'Alok Gupta',
            designation: 'Principal, Head of India, Foundation PE',
          },
          {
            name: 'Sandeep Maheshwai',
            designation: ' EVP, 360 One Asset',
          },
          {
            name: 'Mohan Kumar',
            designation: ' Managing Partner, Avataar Ventures',
          },
          {
            name: 'Shagoofa Rashid Khan',
            designation:
              ' Group General Counsel and Head Corporate Affairs, National Investment and Infrastructure Fund (NIIF)',
          },
        ],
      },
      {
        id: 'ivca_private_7',
        timing: {
          start: '12:10 PM',
          end: '12:20 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'CLOSING REMARKS',
      },

      {
        id: 'ivca_private_8',
        timing: {
          start: '12:20 PM',
        },
        normalHeading: 'NETWORKING LUNCH',
      },
    ],
  },
  {
    slug: 'ivca-esg-imperative-and-opportunities',
    title: 'ESG Imperative and Opportunities for Investors',
    startDate: 'November 28, 2023',
    startTime: '03:30 PM',

    imgSrc: 'https://static.levocdn.com/WGLBUT82/7135262945561085364.jpg',
    link: 'https://forms.gle/ZjKdiPHbAnQctQHd9',

    speakers: [
      {
        name: 'Dr Mukund Rajan',
        email: '',
        phone: '',
        designation: 'Chairman',
        image: 'https://static.levocdn.com/WGLBUT82/7135272238133691132.jpeg',
        gov: false,
        fund: 'ECube',
      },
      {
        name: 'Shankar Venkateswaran',
        email: '',
        phone: '',
        designation: 'Managing Partner - Sustainability Integration',
        image: 'https://static.levocdn.com/WGLBUT82/7135272111656158979.jpeg',
        gov: false,
        fund: 'ECube',
      },

      {
        name: 'Richa Arora',
        email: '',
        phone: '',
        designation: 'Managing Partner and CEO ESG Solutions.',
        image: 'https://static.levocdn.com/WGLBUT82/7135272111656928262.jpeg',
        gov: false,
        fund: 'ECube',
      },
      {
        name: 'Burzin Dubash',
        fund: 'Ankur Capital',
        email: '',
        phone: '',
        designation: 'Chief Operating Officer',
        image: 'https://static.levocdn.com/WGLBUT82/7135272238130876051.png',
        gov: false,
      },
      {
        name: 'Sanskriti Kapoor',
        fund: 'Aavishkar Capital',
        email: '',
        phone: '',
        designation: 'Impact and ESG ',
        image: 'https://static.levocdn.com/WGLBUT82/7135883570082956510.jpeg',
        gov: false,
      },

      {
        name: 'Harish H V',
        fund: 'ECube',
        email: '',
        phone: '',
        designation: 'Managing Director',
        image: 'https://static.levocdn.com/WGLBUT82/7135272238132913654.jpeg',
        gov: false,
      },
      {
        name: 'Kanika Mayar',
        fund: 'Vertex Ventures',
        email: '',
        phone: '',
        designation: 'Partner, Investment & ESG Officer',
        image: 'https://static.levocdn.com/WGLBUT82/7135272111653994839.jpeg',
        gov: false,
      },
    ],
    agendaEvents: [
      {
        id: 'ivca_1',
        timing: {
          start: '03:30 PM',
          end: '04:15 PM',
        },
        accentTag: '45 Mins',
        normalHeading:
          'Presentation on The ESG Imperative and Opportunities for Investors',
        speakers: [
          {
            name: 'Dr Mukund Rajan',
            designation: 'Chairman',
          },
          {
            name: 'Shankar Venkateswaran',
            designation: 'Managing Partner - Sustainability Integration',
          },
          {
            name: 'Richa Arora',
            designation: 'Managing Partner and CEO ESG Solutions.',
          },
        ],
      },

      {
        id: 'ivca_2',
        timing: {
          start: '04:15 PM',
          end: '05:00 PM',
        },
        accentTag: '45 Mins',
        normalHeading:
          'Panel Discussion on ESG Imperative and Opportunities for Investors',
        speakers: [
          {
            name: 'Burzin Dubash',
            designation: 'Chief Operating Officer',
          },
          {
            name: 'Sanskriti Kapoor',
            designation: 'Impact and ESG ',
          },
          {
            name: 'Richa Arora',
            designation: 'Managing Partner and CEO ESG Solutions',
          },
          {
            name: 'Harish H V',
            designation: 'Managing Director',
          },
          {
            name: 'Kanika Mayar',
            designation: 'Partner, Investment & ESG Officer',
          },
        ],
      },
    ],
  },
  // IVCA EY Webinar
  {
    slug: 'ivca-ey-webinar-navigating-governance',
    title:
      'IVCA - EY Webinar on ‘Navigating Governance: Essential Strategies for Start-up Success’',
    startDate: 'December 12, 2023',
    startTime: '03:00 PM',
    location: 'Virtual',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/7137807665081242170.png',
    overviewTitle: 'Event Overview',
    eventOverview: [
      "The Indian start-up landscape has been witnessing sustained momentum and unprecedented growth. Recognizing the notable shift in India's entrepreneurial landscape capturing global interest, it becomes essential for companies to maintain their impressive growth trajectory amidst geopolitical risks and dynamic market challenges.",
      'New ventures hold the critical responsibility of implementing good governance practices from the outset to foster a culture of integrity. Building a framework of ethics will not only help start-ups achieve exemplary regulatory compliance, but also contribute to their long-term success. EY and IVCA, in association with Pratithi Investments, will be launching the report titled ‘Start-up Governance Navigator’ to help nascent companies make informed governance decisions.',
      'As a part of the launch webinar, we invite you to join the panel discussion on ‘Navigating Governance: Essential Strategies for Start-up Success’ from 03:00 pm to 04:15 pm on Tuesday, 12 December 2023.',
    ],
    link: 'https://docs.google.com/forms/d/1DeFtJiZv6JdLlRppQasYvqJFuZbsbhi6AkLzQJREloA/viewform?edit_requested=true',
    // programTitle: 'Session would discuss:',
    // programHighlights: [
    //   'How climate analytics can help investors identify and manage risks. - How to identify the physical and financial risks of climate change to specific companies, sectors, and regions, such as the risk of sea level rise, extreme weather events, and supply chain disruptions.',
    //   'How climate analytics can help investors identify investment opportunities - Identify companies and sectors that are well-positioned to succeed in the transition to a low-carbon economy.',
    //   'The role of climate analytics in ESG investing - Use of climate analytics to assess the ESG performance of portfolio companies and to identify companies that are taking steps to reduce their environmental impact.',
    //   'The use of climate analytics to inform public policy on climate change - Development and implementation of public policies that are designed to mitigate climate change and to adapt to its impacts.',
    // ],
    contact: [
      {
        name: 'Amit Pandey',
        designation: 'Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993102139971719039.jpg',
        email: 'amit.pandey@ivca.in',
        phone: '+91 8860719730',
      },

      {
        name: 'Anirudh Garg',
        designation: 'Associate - VC Ecosystem',
        phone: '+91 8556817134',
        email: 'anirudh@ivca.in',
        image: 'https://static.levocdn.com/WGLBUT82/7059471731709423758.jpeg',
      },
    ],
    /** webinar page pending  */
    // link: 'https://docs.google.com/forms/d/e/1FAIpQLSd01uW9QZ_myEWCLT59p3GJM9GSLmwwgpKAaCpCLT88pceqdg/viewform',
    agendaEvents: [
      {
        id: 'circle_2',
        timing: {
          start: '03:05pm',
          end: '03:10pm',
        },
        accentTag: '05 Mins',
        normalHeading: 'Welcome Address',
      },
      {
        id: 'circle_4',
        timing: {
          start: '03:10pm',
          end: '03:20pm',
        },
        accentTag: '10 Mins',
        normalHeading: 'Report introduction & highlights',

        speakers: [
          {
            name: 'Arpinder Singh',
            designation:
              'Global Markets & India Leader, EY Forensic & Integrity Services',
          },
        ],
      },
      {
        id: 'circle_5',
        timing: {
          start: '03:20pm',
          end: '03:25pm',
        },
        accentTag: '05 Mins',
        normalHeading: 'Report launch photo-opp',
        listContent: ['Contributors pose with the report cover'],
      },
      {
        id: 'circle_6',
        timing: {
          start: '03:25pm',
          end: '03:35pm',
        },
        accentTag: '10 Mins',
        normalHeading: 'Keynote address',
        listContent: ['Government representative'],
      },
      {
        id: 'circle_7',
        timing: {
          start: '3:35pm',
          end: '4:10 pm',
        },
        accentTag: '35 Min',
        normalHeading:
          'Panel discussion on ‘Navigating Governance: Essential Strategies for Start-up Success’',
        speakers: [
          {
            name: ' Siddarth Pai',
            designation:
              'Founding Partner, CFO, and ESG Officer, 3one4 Capital',
          },
          {
            name: 'Karthik Reddy',
            designation: 'Co-founder & Partner, Blume Ventures',
          },
          {
            name: 'Rajan Anandan',
            designation: 'Managing Director, Peak XV Partners',
          },
          {
            name: 'Arpinder Singh',
            designation:
              'Global Markets & India Leader, EY Forensic & Integrity Services Moderator',
          },
          {
            name: 'Amit Pandey',
            designation: 'IVCA Vice President',
          },
        ],
      },
      {
        id: 'circle_8',
        timing: {
          start: '04:10 pm',
          end: '04:15 pm',
        },
        accentTag: '5 Min',
        normalHeading: 'Closing Remarks',
        speaker: [
          {
            name: 'Anirudh Garg ',
            designation: 'IVCA',
          },
        ],
      },
    ],
  },
  // Delivering Impact through good governance
  {
    slug: 'ivca-delivering-impact',
    title: 'Delivering Impact through Good Governance',
    startDate: 'December 13, 2023',
    startTime: '2:30 PM',
    imgType: 'banner',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/7139187072791202271.png',
    overviewTitle: 'Event Overview',
    eventOverview: [
      'IVCA and British International Investment (BII) are excited to host an insightful knowledge session titled “Delivering Impact through Good Governance”.',
      "This event is scheduled for December 13th, starting at 2:30 PM, at the Trident Hotel in Mumbai's Bandra Kurla Complex.",
    ],
    programTitle: 'About the Session',
    programHighlights: [
      'This session aims to explore various aspects of corporate governance, especially in the context of unlisted companies and startups  ',
      'Evolution of the regulatory environment for unlisted companies.',
      'Ways investors can drive good governance.',
      'Practical challenges and strategies in implementing effective governance frameworks, with a focus on startups and smaller businesses.',
      'Insights into how founders navigate governance challenges throughout their startup journey.',
      'Introduction to BII’s guidance note on “Governance Red Flags in Venture Capital Start-Ups” – a tool for investors to identify and manage governance risks.',
      'The session will conclude with a networking high tea from 4:30 PM. Your presence as a valued member of the investment ecosystem is highly appreciated and will add significant value to the discussions.',
    ],
    contact: [
      {
        name: 'Aakriti Bamniyal',
        email: 'aakriti@ivca.in',
        phone: '+91 9711110011',
        designation: 'Sr. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
      },
      {
        name: 'Sumeet Shetty',
        email: 'sumeet@ivca.in',
        phone: '+91 99998 93276',
        designation: 'Asst. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993102296848134363.jpg',
      },
      {
        name: 'Shreya Kumar',
        email: 'shreya@ivca.in',
        phone: '+91 95609 22999',
        designation: 'Manager - Member Relations & Knowledge Series',
        image: 'https://static.levocdn.com/WGLBUT82/6997905993761010384.png',
      },
    ],
    speakers: [
      {
        name: 'Rujuta Bankar',
        email: '',
        phone: '',
        designation:
          'Assistant Registrar of Companies, Mumbai (Ministry of Corporate Affairs)',
        image: 'https://static.levocdn.com/WGLBUT82/7135272238133691132.jpeg',
        gov: false,
      },
      {
        name: 'Alex Maddy',
        email: '',
        phone: '',
        designation:
          'Head of Business Integrity & Corporate Governance, British International Investment',
        image: 'https://static.levocdn.com/WGLBUT82/7137752961051141686.jpg',
        gov: false,
      },

      {
        name: 'Swaminathan Shankar',
        email: '',
        phone: '',
        designation: 'Chief Financial Officer, Chiratae Ventures',
        image: 'https://static.levocdn.com/WGLBUT82/7137752961049502309.jpg',
        gov: false,
      },
      {
        name: 'Rama Tadepalli',
        email: '',
        phone: '',
        designation: 'Co-founder and Chief Product Officer of Mintoak',
        image: 'https://static.levocdn.com/WGLBUT82/7137752960970119039.jpg',
        gov: false,
      },
    ],
    link: 'https://docs.google.com/forms/d/e/1FAIpQLSeFBKjVSoxvrjAMaHWpG86tLsEDtUKCjB6ZRdV0qn878soG6A/viewform',
    /** webinar page pending  */
    // link: 'https://docs.google.com/forms/d/e/1FAIpQLSd01uW9QZ_myEWCLT59p3GJM9GSLmwwgpKAaCpCLT88pceqdg/viewform',
    // agendaEvents: [
    //   {
    //     id: 'circle_1',
    //     timing: {
    //       start: '4:00pm',
    //       end: '4:50pm',
    //     },
    //     accentTag: '50 Mins',
    //     normalHeading: 'Registration ',
    //   },
    //   {
    //     id: 'circle_2',
    //     timing: {
    //       start: '4:50pm',
    //       end: '5:00pm',
    //     },
    //     accentTag: '10 Mins',
    //     normalHeading: 'Welcome Address',
    //   },
    //   {
    //     id: 'circle_4',
    //     timing: {
    //       start: '5:00pm',
    //       end: '5:20pm',
    //     },
    //     accentTag: '20 Mins',
    //     normalHeading: 'Keynote Address',

    //     speakers: [
    //       {
    //         name: 'Smt. Manmeet K. Nanda',
    //         designation:
    //           'Joint Secretary Ministry of Commerce & Industry, Department for Promotion of Industry and Internal Trade (DPIIT)',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'circle_5',
    //     timing: {
    //       start: '5:20pm',
    //       end: '6:00pm',
    //     },
    //     accentTag: '40 Mins',
    //     normalHeading:
    //       'Panel Discussion: Navigating the Global landscape: Challenges and Opportunity for Indian Startup',
    //     speakers: [
    //       {
    //         name: 'Amitabh Nagpal',
    //         designation: 'Head - Startup Ecosystem, AWS India',
    //       },
    //       {
    //         name: 'Niraj Singh',
    //         designation: 'Founder, Spinny',
    //       },
    //       {
    //         name: 'Satyam Darmora',
    //         designation: 'Co-Founder, Wiom',
    //       },
    //       {
    //         name: 'Puja Sondhi',
    //         designation: 'Partner, Shardul Amarchand Mangaldas & Co.',
    //       },
    //       {
    //         name: 'Swati Gupta',
    //         designation: 'Co-Founder & CEO, Industry Buying',
    //       },
    //       {
    //         name: 'Tushar Garg',
    //         designation: 'Co-Founder & CBO, BluSmart',
    //       },
    //       {
    //         name: 'Ishpreet Gandhi',
    //         designation:
    //           'Founder & Managing Partner,Stride Venture (Moderator))',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'circle_6',
    //     timing: {
    //       start: '6:00pm',
    //       end: '6:20pm',
    //     },
    //     accentTag: '20 Mins',
    //     normalHeading:
    //       'Value Creation: Guiding the Investee Company for Sustained Growth & Beyond',
    //     speakers: [
    //       {
    //         name: 'Jayant Basu',
    //         designation: 'Manging Partner, CX Partners',
    //       },
    //       {
    //         name: 'Rahul Bhasin',
    //         designation: 'Managing Partner,Baring Private Equity Partner',
    //       },
    //       {
    //         name: 'Nisha Poddar ',
    //         designation: 'Editor and Anchor, CNBC TV18 (Moderator)',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'circle_7',
    //     timing: {
    //       start: '6:20pm',
    //       end: '7:00 pm',
    //     },
    //     accentTag: '40 Min',
    //     normalHeading:
    //       'Panel Discussion : LP Perspective on the current state of Fund Raising for Manager',
    //     speakers: [
    //       {
    //         name: 'Craig Gifford ',
    //         designation:
    //           'Head of South Asia Private Equity Funds, British International Investment (BII)',
    //       },
    //       {
    //         name: 'Gaurav Kapoor ',
    //         designation: 'Head Capital, British High Commmission',
    //       },
    //       {
    //         name: 'Nidhi Ghuman ',
    //         designation: 'Senior EVP 360 ONE Asset',
    //       },
    //       {
    //         name: 'Nitai Utkarsh ',
    //         designation: 'Lead- Investment Strategy, Hero MotoCorp',
    //       },
    //       {
    //         name: 'Pratibha Jain ',
    //         designation:
    //           'Head of Strategy & Group General Counsel, Everstone Group',
    //       },
    //       {
    //         name: 'Karan Mohla ',
    //         designation: 'Partner, B Capital Group (Moderator)',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'circle_8',
    //     timing: {
    //       start: '7:00 pm',
    //       end: '7:05 pm',
    //     },
    //     accentTag: '5 Min',
    //     normalHeading: 'Closing Remarks',
    //     speaker: [
    //       {
    //         name: 'Rajat Tondon ',
    //         designation: 'President, IVCA',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'circle_9',
    //     timing: {
    //       start: '7:05 pm',
    //       end: 'Onwards',
    //     },
    //     accentTag: 'Onwards',
    //     normalHeading: 'Networking Cocktail & Dinner',
    //   },
    // ],
  },

  // 15 December Webinar
  {
    slug: 'ivca-regulatory-update-webinar',
    title: 'IVCA Invitation: Regulatory Update Webinar',
    startDate: ' Dec 15, 2023  ',
    startTime: '04:00 PM',
    location: 'Virtual',
    imgSrc: '',
    overviewTitle: 'Event Overview',
    eventOverview: [
      'At IVCA, we are dedicated to nurturing a thriving environment for the Alternate asset industry.',
      'Our commitment is steadfast in advocating for policy reforms that enhance our industry, consistently engaging with key regulatory and government stakeholders.',
      'Join us for an exclusive webinar, dedicated to unveiling the scope and impact of our advocacy efforts.',
      'Scheduled for December 15th, 2023, at 4 PM, this session is an opportunity to gain in-depth insights into how IVCA champions the interests of our industry.',
    ],
    programTitle: 'Things to be covered',
    programHighlights: [
      'COMPREHENSIVE ADVOCACY REVIEW: The nature and extent of representations IVCA has made in recent months.',
      'INFLUENCING POLICY: A look at our advocacy engagements and their consequential impact on policy discussions and outcomes.',
      'CURRENT ADVOCACY FOCUS: Insight into the current issues IVCA is actively addressing with key regulatory bodies, including SEBI and the Ministry of Finance.',
      'ADVOCACY SUCCESSES: Highlights of what IVCA has achieved through its advocacy efforts.',
      'STRENGTHENING OUR VOICE: How IVCA, backed by its members, continues to be a significant influence in the alternate asset sector in India.',
    ],
    link: 'mailto:soniya@ivca.in',
    contact: [
      {
        name: ' Soniya Tolani',
        email: 'soniya@ivca.in',
        phone: '+91 7023854835',
        designation: 'Senior Manager',
        image: '',
      },
    ],
  },
  {
    slug: 'ivca-startup-angel-ahmedabad',
    title: 'IVCA, Startup India - Startup Angel Program',
    startDate: '  November 24, 2023  ',
    startTime: '',
    location: 'Ahmedabad',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/7141024320029964103.jpeg',
    overviewTitle: 'About the program',
    eventOverview: [
      `The program's mission is to empower High Net Worth Individuals(HNIs), new /aspiring Angel Investors, Family Offices, and CXOs to become seasoned angel investors in the startup ecosystem.`,

      'By equipping them with the necessary knowledge and tools, the program aims to boost startup development and increase overall investment in the ecosystem.',
    ],
    programTitle: 'Problem Statement',
    programHighlights: [
      `Investing in startups differs significantly from running a business.`,
      ` This program addresses the challenge of effectively investing in early-stage startups and sets out to differentiate successful startup investors.`,
      ` It provides insights into portfolio discovery, management, moreover, it focuses on increasing the likelihood of generating substantial returns from early-stage investments.`,
    ],
    link: '',
    contact: [
      {
        name: 'Amit Pandey',
        designation: 'Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993102139971719039.jpg',
        email: 'amit.pandey@ivca.in',
        phone: '+91 8860719730',
      },

      {
        name: 'Anirudh Garg',
        designation: 'Associate - VC Ecosystem',
        phone: '+91 8556817134',
        email: 'anirudh@ivca.in',
        image: 'https://static.levocdn.com/WGLBUT82/7059471731709423758.jpeg',
      },
    ],
    agendaEvents: [
      {
        id: 'circle_2',
        timing: {
          start: '10:00am',
          end: '10:50am',
        },
        accentTag: '50 Mins',
        normalHeading:
          'Deal Flow to Profitable Exits and Ecosystem Mapping, Evaluation criteria and Metrics that matter ',
        listContent: [
          'Sourcing quality deal flow',
          ' Essential questions to ask before investing',
          'Supporting portfolio companies throughout their life cycle',
          ' Achieving highly profitable liquidity events',
          'Venture, Angel, and Startup Investing',
          'Difference Between Angel Funding & Venture Capital',
          ' How to Create Startup Investment Deal Flow',
          'How to Discover Valuable Startups, Evaluate Startup Pitches',
          ' How to Filter Startup Pitches',
          'Questions to Ask Entrepreneurs on Moat',
        ],
      },
      {
        id: 'circle_4',
        timing: {
          start: '10:50am',
          end: '11:25am',
        },
        accentTag: '05 Mins',
        normalHeading: 'Term Sheet Breakdown',

        speakers: [
          {
            name: 'Sanea Vakaliya ',
            designation: ' CFO, Bharat Innovation Fund',
          },
        ],
      },
      {
        id: 'circle_5',
        timing: {
          start: '11:25am',
          end: '12:30am',
        },
        accentTag: '65 Mins',
        normalHeading: 'Valuation & Dilution',

        speakers: [
          {
            name: 'Prof. Joshy Jacob',
            designation: 'IIMA ',
          },
        ],
        listContent: [
          'Valuation of startups: art or science',
          'Understanding equity dilution',
          'Factors influencing startup valuations',
        ],
      },
      {
        id: 'circle_6',
        timing: {
          start: '12:30am',
          end: '01:15pm',
        },
        accentTag: '60 Mins',
        normalHeading: ' Portfolio Monitoring, Governance and Exits',
        listContent: [
          ' The role of investors in startup boards',
          'Key services offered by investors, including fundraising, strategy, and recruitment support',
          'Designing and documenting startup exit strategies & significance of exit plans for early investors',
          ' The role of investment bankers other ecosystem stakeholders in the exit process',
        ],

        speakers: [
          {
            name: 'Kunal Upadhyay',
            designation:
              ' Co-Founder IIMA-CIIE, Managing Partner - Bharat Innovation Fund',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '01:15 pm',
          end: '02:00 pm',
        },
        accentTag: '45 Min',
        normalHeading: 'Lunch',
      },
      {
        id: 'circle_8',
        timing: {
          start: ' 02:00pm',
          end: '02:35pm',
        },
        accentTag: '35 Min',
        normalHeading: 'Women - Out of the Box',
        listContent: [
          'Addresses prevailing social prejudices and highlight the importance of empowering women to overcome such barriers',
          'Startups as an asset class and how to plunge into the journey of Angel Investing',
        ],
        speakers: [
          {
            name: 'Supriya Sharma',
            designation: 'IIMA-CIIE',
          },
        ],
      },

      {
        id: 'circle_7',
        timing: {
          start: '02:35 pm',
          end: '03:05 pm',
        },
        accentTag: '60 Min',
        normalHeading:
          ' Fireside Chat: Perspective on Founder-Investor Relations',
        speakers: [
          {
            name: ' Mr. Chintan Antani',
            designation: ' VP, Seed Investments, IIMA-CIIE(Moderator)',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '03:00 pm',
          end: '04:00 pm',
        },
        accentTag: '60 Min',
        normalHeading: 'Portfolio Monitoring, Governance and Exits',
        speakers: [
          {
            name: 'Shri. Ishaan Khosla',
            designation: 'Founding Partner, Huddle',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '04:00 pm',
          end: '04:45 pm',
        },
        accentTag: '45 Min',
        normalHeading: 'Women in the Lead: Investing in Startups',
        speakers: [
          {
            name: 'Smt. Deeksha Ahuja ',
            designation: 'Founder, Encubay ',
          },
          {
            name: 'Smt. Neiharika Rajiv',
            designation: 'Angel Investor ',
          },
          {
            name: 'Smt.Anisha Patnaik ',
            designation: 'Founder,LexStart Partners',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '04:45 pm',
          end: '05:30 pm',
        },
        accentTag: '45 Min',
        normalHeading: 'Networking & Tea/Coffee Break ',
      },
    ],
    outcomeTitle: `Outcome of Attending Such a Program`,
    outcomeHighlights: [
      `Gain the knowledge and tools required to become Angel investors in the startup ecosystem.`,
      `Learn how to source quality investment opportunities and ask the right questions before investing.`,
      `Understand the intricacies of post - investment engagement and exit strategies.`,
      `Expand their network within the investment community.	Enhance their ability to make profitable early - stage investments.`,
    ],
    attendeesTitle: 'Designed for individuals and professionals including',
    attendeesHighlights: [
      `High Net Worth Individuals(HNIs)`,
      `New / aspiring Angel Investors`,
      `Family Office Managers`,
      `Fund Managers`,
      `Boutique Funds and Angel Syndicates`,
      `Corporate Venture Professionals`,
      `Aspiring Angel Investors`,
      `Future General Partners(GPs)`,
    ],
  },

  {
    slug: 'ivca-startup-angel-newDelhi',
    title: 'IVCA, Startup India - Startup Angel Program',
    startDate: '  November 24, 2023  ',
    startTime: '',
    location: 'Vanijya Bhawan (Room 22), New Delhi',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/7141024320029964103.jpeg',
    overviewTitle: 'About the program',
    eventOverview: [
      `The program's mission is to empower High Net Worth Individuals(HNIs), new /aspiring Angel Investors, Family Offices, and CXOs to become seasoned angel investors in the startup ecosystem.`,

      'By equipping them with the necessary knowledge and tools, the program aims to boost startup development and increase overall investment in the ecosystem.',
    ],
    programTitle: 'Problem Statement',
    programHighlights: [
      `Investing in startups differs significantly from running a business.`,
      ` This program addresses the challenge of effectively investing in early-stage startups and sets out to differentiate successful startup investors.`,
      ` It provides insights into portfolio discovery, management, moreover, it focuses on increasing the likelihood of generating substantial returns from early-stage investments.`,
    ],
    link: '',
    contact: [
      {
        name: 'Amit Pandey',
        designation: 'Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993102139971719039.jpg',
        email: 'amit.pandey@ivca.in',
        phone: '+91 8860719730',
      },

      {
        name: 'Anirudh Garg',
        designation: 'Associate - VC Ecosystem',
        phone: '+91 8556817134',
        email: 'anirudh@ivca.in',
        image: 'https://static.levocdn.com/WGLBUT82/7059471731709423758.jpeg',
      },
    ],
    agendaEvents: [
      {
        id: 'circle_2',
        timing: {
          start: '10:00am',
          end: '10:45am',
        },
        accentTag: '45 Mins',
        normalHeading: 'Registrations',
      },
      {
        id: 'circle_4',
        timing: {
          start: '10:45am',
          end: '10:50am',
        },
        accentTag: '05 Mins',
        normalHeading: 'Opening Remarks',
      },
      {
        id: 'circle_5',
        timing: {
          start: '10:50am',
          end: '11:00am',
        },
        accentTag: '10 Mins',
        normalHeading: 'Context Setting for the Workshop',
      },
      {
        id: 'circle_6',
        timing: {
          start: '11:00am',
          end: '12:00pm',
        },
        accentTag: '60 Mins',
        normalHeading: 'From Deal Flow to Profitable Exits',
        // listContent: [
        //   'Government representative'
        // ]

        speakers: [
          {
            name: 'Shri. Saurabh Singh',
            designation: ' Director - Credit, Trifecta Capital',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '12:00 pm',
          end: '01:00 pm',
        },
        accentTag: '60 Min',
        normalHeading:
          'Ecosystem Mapping, Evaluation criteria and Metrics that matter',
        speakers: [
          {
            name: 'Smt. Padmaja Ruparel',
            designation:
              ' Co - Founder, Indian Angel Network and Founding Partner IAN Fund',
          },
        ],
      },
      {
        id: 'circle_8',
        timing: {
          start: ' 01:00pm',
          end: '02:00pm',
        },
        accentTag: '60 Min',
        normalHeading: 'Lunch Break',
      },
      {
        id: 'circle_7',
        timing: {
          start: '02:00 pm',
          end: '03:00 pm',
        },
        accentTag: '60 Min',
        normalHeading:
          'Valuation of Startups and Understanding Equity Dilution',
        speakers: [
          {
            name: 'Shri. Mukul Singhal',
            designation: 'Co - Founder and Partner, Pravega Ventures',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '03:00 pm',
          end: '04:00 pm',
        },
        accentTag: '60 Min',
        normalHeading: 'Portfolio Monitoring, Governance and Exits',
        speakers: [
          {
            name: 'Shri. Ishaan Khosla',
            designation: 'Founding Partner, Huddle',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '04:00 pm',
          end: '04:45 pm',
        },
        accentTag: '45 Min',
        normalHeading: 'Women in the Lead: Investing in Startups',
        speakers: [
          {
            name: 'Smt. Deeksha Ahuja ',
            designation: 'Founder, Encubay ',
          },
          {
            name: 'Smt. Neiharika Rajiv',
            designation: 'Angel Investor ',
          },
          {
            name: 'Smt.Anisha Patnaik ',
            designation: 'Founder,LexStart Partners',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '04:45 pm',
          end: '05:30 pm',
        },
        accentTag: '45 Min',
        normalHeading: 'Networking & Tea/Coffee Break ',
      },
    ],
    outcomeTitle: `Discover About`,
    outcomeHighlights: [
      `Scope of investing in startups`,
      `How to become an angel investor`,
      `Know about the possibility of earning returns/profits by investing in startups`,
      `Pivotal role of women as investors`,
    ],
    attendeesTitle: 'Designed for individuals and professionals including',
    attendeesHighlights: [
      `High Net Worth Individuals(HNIs)`,
      `New / aspiring Angel Investors`,
      `Family Office Managers`,
      `Fund Managers`,
      `Boutique Funds and Angel Syndicates`,
      `Corporate Venture Professionals`,
      `Aspiring Angel Investors`,
      `Future General Partners(GPs)`,
    ],
  },
  {
    slug: 'ifsca-nsxis-global-capital-and-ifsc-exchanges',
    title:
      'Direct Listing for Indian Startups: Path to Direct International Listing to Access Global Capital Pools',
    startDate: '  May 10, 2024  ',
    startTime: '03:30 PM',
    contact: [
      {
        name: 'Sunitha Prasad',
        email: 'sunitha@ivca.in',
        phone: '+91 99724 70000',
        designation: 'Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993101868986119948.png',
      },
      {
        name: 'Nikita Sukhla',
        email: 'nikita@ivca.in',
        phone: '+91 9500092894',
        designation: 'Associate',
        image: 'https://static.levocdn.com/WGLBUT82/7089563426032951113.png',
      },
    ],
    location:
      'Bengaluru  (Exact location will be shared once your RSVP is confirmed)',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-05-02at22944PM-eg6RlkGQhndz.jpeg',
    overviewTitle: 'Event Overview',
    eventOverview: [
      'IFSCA and NSE IX in collaboration with 3one4 Capital and IVCA Present - Direct Listing for Indian Startups: Path to Direct International Listing to Access Global Capital Pools.',
      'We invite you to join us for an informative session led by the  IFSCA and NSE IX on 10th May 2024, focusing on guiding Indian pre-IPO startups in navigating this framework and facilitating their listing on IFSC exchanges via GIFT-IFSC.',
    ],
    link: 'https://docs.google.com/forms/d/1zN44BPgbjW09qTvgqb0K26AFOBT8N8WAJHJ23JkNSBk/edit',
    agendaEvents: [
      {
        id: 'circle_2',
        timing: {
          start: '3:30 PM',
          end: '4:00 PM',
        },
        accentTag: '30 Mins',
        normalHeading: 'Registration',
      },
      {
        id: 'circle_4',
        timing: {
          start: '4:00 PM',
          end: '4:10 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Opening Remarks',
        speakers: [
          {
            name: 'Shri. Kumar Kanakasabapathy',
            designation: 'Chairman, NSE ICC',
          },
        ],
      },
      {
        id: 'circle_5',
        timing: {
          start: '4:10 PM',
          end: '5:10 PM',
        },
        accentTag: '60 Mins',
        normalHeading: `Session on “Exploring GIFT-IFSC: India's Gateway to Global Capital Markets”`,
        speakers: [
          {
            name: 'Shri. Pradeep Ramakrishnan',
            designation: 'Executive Director – IFSCA',
          },
        ],
      },
      {
        id: 'circle_6',
        timing: {
          start: '5:10 PM',
          end: '6:10 PM',
        },
        accentTag: '60 Mins',
        normalHeading: `Session on “Unlocking Global Capital: Equity Listing for Unlisted Indian Companies on the IFSC Exchanges”`,
        speakers: [
          {
            name: 'Shri. V. Balasubramaniam, MD & CEO',
            designation: 'NSE International Exchange',
          },
        ],
      },
      {
        id: 'circle_7',
        timing: {
          start: '6:10 PM',
          end: '6:30 PM',
        },
        accentTag: '20 Mins',
        normalHeading: 'Open Forum - Q&A from audience',
      },
      {
        id: 'circle_7',
        timing: {
          start: '6:30 PM',
          end: 'onwards',
        },
        accentTag: '',
        normalHeading: `Hors d'oeuvres + Networking`,
      },
    ],
  },
  {
    slug: 'ivca-cat-III-summit',
    title: 'IVCA CAT III Summit 2024',
    startDate: 'July 11th, 2024',
    location: 'Mumbai',
    startTime: '05:00 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-07-02at114629AM-sR8GjbfSuUXp.jpeg',
    contact: [
      {
        name: 'Aakriti Bamniyal',
        email: 'aakriti@ivca.in',
        phone: '+91 9711110011',
        designation: 'Sr. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
      },
      {
        name: 'Rohan Parulekar',
        email: 'rohan.parulekar@ivca.in',
        phone: '+91 98190 01130',
        // designation: 'Manager - Member Relations & Knowledge Series',
        // image: 'https://static.levocdn.com/WGLBUT82/7059471731709423758.jpeg',
      },
      {
        name: 'Sumeet Shetty',
        email: 'sumeet@ivca.in',
        phone: '+91 99998 93276',
        designation: 'Asst. Vice President, IVCA',
        image: 'https://static.levocdn.com/WGLBUT82/6993102296848134363.jpg',
      },
      {
        name: 'Shreya Kumar',
        email: 'shreya@ivca.in',
        phone: '+91 95609 22999',
        designation: 'Manager - Member Relations & Knowledge Series',
        image: 'https://static.levocdn.com/WGLBUT82/6997905993761010384.png',
      },
    ],
    programTitle: 'Summit Highlights',
    programHighlights: [
      'CAT III Industry Report Launch: In collaboration with Eleveight, we will unveil the CAT III Industry Report, offering an in-depth analysis of industry numbers, trends, forecasts, and survey results',
      'Strategic Insights: Equip yourself with the latest market trends and strategic considerations.',
      'Peer Discussions:  Engage  with  peers  and  contemporaries  on  key  topics  affecting  the  CAT  III landscape.',
      'Expected Attendees:  Over 120 CAT III funds, other Alternate Capital funds, LPs, Family Offices, Wealth Managers, Policy makers, regulators, and IVCA member knowledge partners.',
    ],
    overviewTitle: 'About the Session',
    eventOverview: [
      'The Summit is designed to foster conversations on the potential of Category III AIFs, exploring their distinctive features and future growth trajectories. This initiative aims to provide industry participants with expert insights, market trends, and strategic considerations, offering a comprehensive guide for investors looking to capitalise on the unique opportunities within this category.',
    ],
    keyTopicsTitle: 'Key Topics',
    keyTopicsTitleHighlights: [
      'Managers and Investors perspectives and outlook on the CAT III growth trajectory',
      'Key Impactful Reforms to Propel CAT III Industry',
      'On-shoring Global Strategies for Deepening the CAT III Landscape',
      'CAT III Report Launch',
    ],

    logos: [
      {
        name: 'AlphaGrep',
        _id: '1',
        logo: 'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-06-07at13513PM-Lkp3HyinRPr1.jpeg',
        website_link: '',
      },
      {
        name: 'Pwc',
        _id: '2',
        logo: 'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-06-07at13513PM1-2EYr54SHOxM7.jpeg',
        website_link: '',
      },
      {
        name: 'Sundaram Alternates',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-06-07at13513PM2-vxmNzQwIozYA.jpeg',
        website_link: '',
      },
    ],
    speakers: [
      {
        name: 'Pavan Shah',
        designation: 'General Manager',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/PavanShahPicture-gVHrJ684iHp5.jpg',
        gov: true,
        fund: 'IFSCA',
      },
      {
        name: 'Pradeep Ramkrishnan',
        designation: 'Executive Director',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-07-06at125234PM-EBh8xyUE45eg.jpeg',
        gov: true,
        fund: 'IFSCA',
      },
      {
        name: 'Akshaya Mishra',
        email: '',
        phone: '',
        designation: 'Head of Compliance',
        image:
          'https://static.levocdn.com/WGLBUT82/AksProfilepic-SvI2sF4z00ma.jpg',
        gov: false,
        fund: 'Nuvama Asset Management Limited',
      },

      {
        name: 'Apurva Salarpuria',
        designation: 'Executive Director',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/ApurvaSalarpuria-HXVDtJ3ag3l3.jpg',
        gov: false,
        fund: ' SALARPURIA SATTVA GROUP',
      },
      {
        name: 'ASHISH CHUGANI',
        designation: 'HEAD ALTERNATIVE ASSETS',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1684403547-Untitleddesign-2023-05-18T151912224-moxO3bQh4hAD.webp',
        gov: false,
        fund: ' nippon india alternative investments',
      },
      {
        name: 'Bhavdeep Bhatt',
        designation: 'CEO',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/IMG3414-rSCtlHfGZxzV.jpeg',
        gov: false,
        fund: ' Northern Arc Investments',
      },
      {
        name: 'Lakshmi Iyer',
        designation: 'CEO',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/IMG-20240517-WA0001-XZbmbF5kC2yR.jpg',
        gov: false,
        fund: 'Kotak Alternate Asset Managers Limited (KAAML)',
      },
      {
        name: 'Nalin Moniz',
        designation: 'CEO',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/NalinMoniz-ProfessionalHeadShot-YhECTNy7iFhz.jpg',
        gov: false,
        fund: 'Alternative Equities',
      },
      {
        name: 'Pritesh Majmudar',
        designation: 'Head – Legal & Compliance',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/ASC0299-bMZFnDTbCV2m.JPG',
        gov: false,
        fund: 'DSP Asset Managers Private Limited',
      },
      {
        name: 'Saurabh Rungta',
        designation: 'Managing Director and Chief Investment Officer',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-07-04at111709AM-k5KMTHkPmll2.jpeg',
        gov: false,
        fund: 'Avendus Wealth Management',
      },
      {
        name: 'Upasana Koul',
        designation: 'Co-founder',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/1-gVHmJ684usvi.jpeg',
        gov: false,
        fund: 'Eleveight',
      },
      {
        name: 'Vikaas M Sachdeva',
        designation: 'Managing Director',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/SSK069151-sR8GjbfcuAG8.jpg',
        gov: false,
        fund: 'Sundaram Alternates',
      },
      {
        name: 'Vikram Bohra',
        designation: 'Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Vikrambohrapic-CISgrO2ghjwy.jpg',
        gov: false,
        fund: 'Price Waterhouse & Co LLP',
      },
    ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '5:00 PM',
          end: '5:30 PM',
        },
        accentTag: '30 Mins',
        normalHeading: 'REGISTRATION & NETWORKING HIGH TEA',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '5:30 PM',
          end: '5:40 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'WELCOME ADDRESS',
        speakers: [
          {
            name: 'Bhautik Ambani',
            designation: 'CEO, AlphaGrep Investment Management',
          },
        ],
      },
      {
        id: 'ivca_private_3',
        timing: {
          start: '5:40 PM',
          end: '6:00 PM',
        },
        accentTag: '20 Mins',
        normalHeading: 'IVCA CAT III REPORT LAUNCH',
        speakers: [
          {
            name: 'Upasana Koul',
            designation: 'Co-founder, Eleveight',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '6:00 PM',
          end: '6:40 PM',
        },
        accentTag: '40 Mins',
        normalHeading:
          'MANAGERS AND INVESTORS PERSPECTIVES AND OUTLOOK ON THE CAT III GROWTH TRAJECTORY',
        speakers: [
          {
            name: 'Apurva Salarpuria',
            designation: 'Principal, Salarpuria Family Office',
          },
          {
            name: 'Ashish Chugani',
            designation:
              'Head Alternative Assets, Nippon India Alternative Investments',
          },
          {
            name: 'Bhavdeep Bhatt',
            designation: 'CEO, Northern Arc Investments',
          },
          {
            name: 'Vikaas Sachdeva',
            designation: 'Managing Director, Sundaram Alternates (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_5',
        timing: {
          start: '6:40 PM',
          end: '7:20 PM',
        },
        accentTag: '40 Mins',
        normalHeading: 'KEY IMPACTFUL REFORMS TO PROPEL CAT III INDUSTRY',
        speakers: [
          {
            name: 'Nalin Moniz',
            designation: 'CIO - Alternative Equity, Edelweiss Asset Management',
          },
          {
            name: 'Pritesh Majmudar',
            designation: 'Head of Compliance, DSPIM',
          },
          {
            name: 'Saurabh Rungta',
            designation:
              'Managing Director and Chief Investment Officer, Avendus Wealth Management',
          },
          {
            name: 'Vikram Bohra',
            designation: 'Partner, Price Waterhouse & Co LLP',
          },
          {
            name: 'Bhautik Ambani',
            designation: 'CEO, AlphaGrep Investment Management (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_6',
        timing: {
          start: '7:20 PM',
          end: '7:40 PM',
        },
        accentTag: '20 Mins',

        normalHeading: 'OPPORTUNITY FOR CAT III FUNDS IN IFSC',
        speakers: [
          {
            name: 'Pradeep Ramakrishnan',
            designation: 'Executive Director, IFSCA',
          },
          {
            name: 'Pavan Shah',
            designation: 'General Manager, IFSCA',
          },
        ],
      },

      {
        id: 'ivca_private_7',
        timing: {
          start: '7:40 PM',
          end: '7:55 PM',
        },
        accentTag: '15 Mins',
        normalHeading: 'OMNIBUS STRUCTURES FOR TRADES IN GIFT CITY',
        speakers: [
          {
            name: 'Akshaya Mishra',
            designation: 'Head of Compliance, Nuvama Asset. Management',
          },
        ],
      },

      {
        id: 'ivca_private_8',
        timing: {
          start: '7:55 PM',
          end: '8:00 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'CLOSING REMARKS',
        speakers: [
          {
            name: 'Vikaas Sachdeva',
            designation: 'Managing Director, Sundaram Alternates',
          },
        ],
      },
      {
        id: 'ivca_private_8',
        timing: {
          start: '8:00 PM',
        },
        normalHeading: 'NETWORKING COCKTAILS & DINNER',
      },
    ],
  },
  {
    slug: 'ivca-bharat-wapsi',
    title: 'Bharat Vapsi: Navigating Regulatory and Investment Landscapes',
    startDate: 'September 5th, 2024',
    location: 'Bengaluru',
    startTime: '05:00 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-08-22at21217PM-1d79L5P7gjzg.jpeg',
    contact: [
      {
        name: 'Sunitha Prasad',
        email: 'sunitha@ivca.in',
        phone: '+91 9972470000',
        // designation: 'Sr. Vice President, IVCA',
        // image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
      },
      {
        name: 'Nikita Shukla',
        email: 'nikita@ivca.in',
        phone: '+91 9500092894',
        // designation: 'Manager - Member Relations & Knowledge Series',
        // image: 'https://static.levocdn.com/WGLBUT82/7059471731709423758.jpeg',
      },
    ],
    // programTitle: 'Summit Highlights',
    // programHighlights: [
    //   'CAT III Industry Report Launch: In collaboration with Eleveight, we will unveil the CAT III Industry Report, offering an in-depth analysis of industry numbers, trends, forecasts, and survey results',
    //   'Strategic Insights: Equip yourself with the latest market trends and strategic considerations.',
    //   'Peer Discussions:  Engage  with  peers  and  contemporaries  on  key  topics  affecting  the  CAT  III landscape.',
    //   'Expected Attendees:  Over 120 CAT III funds, other Alternate Capital funds, LPs, Family Offices, Wealth Managers, Policy makers, regulators, and IVCA member knowledge partners.',
    // ],
    YTLink:
      'https://www.youtube.com/playlist?list=PLHR3PNcbEp9h4Y8ZUx9DtUZe7P8OQpjqS',

    overviewTitle: 'About the Session',
    eventOverview: [
      'As India’s startup ecosystem continues to evolve, 2023 saw over 8,000 startups make the strategic move to re-domicile to India. This session will bring together regulators, leading investors, and founders to discuss the implications of this trend and explore how domestic capital and favorable regulatory changes are reshaping the investment landscape.',
    ],
    keyTopicsTitle: 'Key Topics',
    keyTopicsTitleHighlights: [
      "Domestic Capital's Role: Leveraging domestic capital to shape the future of India's startup ecosystem.",
      'Attracting Domestic Capital: Strategies to channel more domestic investment into startups.',
      'Unlocking Pension and Insurance Funds: Measures to unlock domestic pension and insurance funds for startup investments.',
      'Domiciling Startups - India vs. Overseas: Key factors influencing the decision to domicile in India.',
      "Government's Role in Bharat Vapsi: Enhancing India's attractiveness as a startup domicile through policy initiatives.",
      'Building an Atma Nirbhar Capital Ecosystem: Actions to foster a self-reliant capital ecosystem in India.',
    ],

    logos: [
      {
        name: 'Amazon Web Services (AWS)',
        _id: '2',
        logo: 'https://static.levocdn.com/WGLBUT82/AWSLogo-T71Rn3S8uvvl.jpeg',
        website_link: '',
      },
      {
        name: 'Cyril Amarchand Mangaldas',
        _id: '1',
        logo: 'https://static.levocdn.com/WGLBUT82/CAMLogoStackedpurple-01-vxmozQYk2cKE.png',
        website_link: '',
      },

      {
        name: 'Ernst & Young (EY)    ',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/6995642256918537020.jpg',
        website_link: '',
      },
      {
        name: 'Goodwin',
        _id: '4',
        logo: 'https://static.levocdn.com/WGLBUT82/goodwn-aytLN6vdbliO.png',
        website_link: '',
      },
    ],
    speakers: [
      {
        name: 'Siddarth Pai',
        email: '',
        phone: '',
        designation:
          'Founding Partner, CFO and ESG Officer, 3one4 Capital and Co-Chair',
        image:
          'https://static.levocdn.com/WGLBUT82/SiddarthPai-2EYM54TtfhA5.png',
        gov: false,
        fund: 'IVCA Regulatory Affairs Council and IVCA Executive Committee Member',
      },
      {
        name: 'Vishal Gupta',
        email: '',
        phone: '',
        designation: 'CEO',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2024-08-30at45514PM-1d79L5quS4WY.png',
        gov: false,
        fund: 'PhonePe,Insurance',
      },
      {
        name: 'Karthik Prabhakar',
        email: '',
        phone: '',
        designation: 'Managing Partner',
        image:
          'https://static.levocdn.com/WGLBUT82/KarthikPrabhakarpic1-OaJNLBL2SA9D.jpeg',
        gov: false,
        fund: 'PeerCapital',
      },
      {
        name: 'Smita Goel',
        email: '',
        phone: '',
        designation: 'Director Finance',
        image: 'https://static.levocdn.com/WGLBUT82/unnamed1-4JO4lpE6rmDs.png',
        gov: false,
        fund: 'RTP Global',
      },

      {
        name: 'Harish S',
        designation: 'Partner',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/HarishS-1d7EL5iZxQ6q.jpg',
        gov: false,
        fund: 'Cyril Amarchand Mangaldas',
      },
      {
        name: 'KT Chandy',
        designation: 'Partner and Co-Leader',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/KTChandy-vxmozQYkZf7V.jpg',
        gov: false,
        fund: 'EY Private Tax | EY India',
      },
      {
        name: 'Reeba Chacko',
        designation: 'Senior Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/ReebaChako-WT0jrjPSeJpj.jpg',
        gov: false,
        fund: 'Cyril Amarchand Mangaldas',
      },
      {
        name: 'Amit Pandey',
        designation: 'Lead VC Ecosystem & Capacity Building',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/amitpandeydp-pKk9lu6OFaup.jpeg',
        gov: false,
        fund: 'IVCA',
      },
      {
        name: 'Anjali Bansal',
        designation:
          'Founding Partner & IVCA Climate & Sustainability Council member',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Anjaliprofilepic1-w9foJvRHJWBX.JPG',
        gov: false,
        fund: 'Avaana Capital, IVCA',
      },
      {
        name: 'Dr. Ekroop Caur',
        designation: 'I.A.S',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2024-08-17at105846AM-UpLgWy0juNX0.png',
        gov: false,
        fund: ' Secretary to Government, Department of Electronics, Information Technology, Biotechnology and Science & Technology, Government of Karnataka',
      },
      {
        name: 'Lavanya Ashok',
        designation:
          'Partner, Trifecta Capital, IVCA Executive Committee Member and IVCA VC Council member',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/LavanyaAshokPhoto2024-GLUtccAG8EKB.jpg',
        gov: false,
        fund: 'Trifecta Capital, IVCA',
      },
      {
        name: 'Manish Kheterpal',
        designation: 'Co-founder & Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Manish-Avatar-HD-hjB9vGLyotvp.jpg',
        gov: false,
        fund: 'WaterBridge Ventures, Vice Chair, IVCA VC Council',
      },
      {
        name: 'Prashanth Prakash',
        designation:
          'Founding Partner & IVCA VC Council Co-Chair and IVCA Executive Committee member',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Prashanth-HDpic-iPDjf0boUZqi.JPG',
        gov: false,
        fund: 'Accel Partners India, IVCA',
      },
      {
        name: 'Rajat Tandon',
        designation: 'President',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/RajatTandonProfile1-5AQfZxVDwhzA.JPG',
        gov: false,
        fund: 'IVCA',
      },
      {
        name: 'Abhishek Krishnan',
        designation: 'Partner',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/unnamed-SvIdsFT8ILr0.png',
        gov: false,
        fund: 'Goodwin',
      },
    ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '4:30 PM',
          end: '5:00 PM',
        },
        accentTag: '30 Mins',
        normalHeading: 'Registration & Networking High Tea/Coffee',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '5:00 PM',
          end: '5:05 PM',
        },
        accentTag: '05 Mins',
        normalHeading: 'Opening Address',
        speakers: [
          {
            name: 'Rajat Tandon',
            designation: 'President, IVCA',
          },
        ],
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '5:05 PM',
          end: '5:20 PM',
        },
        accentTag: '15 Mins',
        normalHeading: 'Keynote Address',
        listContent: [
          'Reverse Flip, IFSCA, Budget Insights (Focus on Angel Tax), SEBI insights',
        ],
        speakers: [
          {
            name: 'Siddarth Pai',
            designation:
              'Founding Partner, CFO and ESG Officer, 3one4 Capital and Co-Chair, IVCA Regulatory Affairs Council and IVCA Executive Committee Member',
          },
        ],
      },
      {
        id: 'ivca_private_3',
        timing: {
          start: '5:20 PM',
          end: '5:30 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Presentation by Ernst & Young',
        speakers: [
          {
            name: 'KT Chandy',
            designation: 'Partner and Co-leader EY Private Tax | EY India',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '5:30 PM',
          end: '5:50 PM',
        },
        accentTag: '20 Mins',
        normalHeading: 'Fireside Chat',
        // listContent: ['Discussion on the new Fund of Funds launched by GOK'],
        speakers: [
          {
            name: 'Dr. Ekroop Caur',
            designation:
              'I.A.S, Secretary to Government, Department of Electronics, Information Technology, Biotechnology and Science & Technology, Government of Karnataka',
          },
          {
            name: 'Prashanth Prakash',
            designation:
              'Founding Partner, Accel Partners India, IVCA VC Council Co-Chair and IVCA Executive Committee member',
          },
          {
            name: 'Amit Pandey',
            designation:
              'Lead - VC Ecosystem & Capacity Building, IVCA (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '5:50 PM',
          end: '6:00 PM',
        },
        normalHeading: 'Presentation by Cyril Amarchand Mangaldas',

        accentTag: '10 Mins',

        speakers: [
          {
            name: 'Reeba Chacko',
            designation: 'Senior Partner, Cyril Amarchand Mangaldas',
          },
          {
            name: 'Harish S.',
            designation: 'Partner, Cyril Amarchand Mangaldas',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '6:00 PM',
          end: '6:10 PM',
        },
        normalHeading: 'Presentation by Goodwin',

        accentTag: '10 Mins',
        speakers: [
          {
            name: 'Abhishek Krishnan',
            designation: 'Partner,Godwin',
          },
        ],
      },
      //   {
      //     id: 'ivca_private_4',
      //     timing: {
      //       start: '6:20 PM',
      //       end: '6:30 PM',
      //     },
      //     normalHeading: 'Presentation by Goodwin',
      //     accentTag: '10 Mins',
      //   },
      {
        id: 'ivca_private_4',
        timing: {
          start: '6:10 PM',
          end: '6:55 PM',
        },
        normalHeading:
          'Panel Discussion: How Atma Nirbhar Capital Can Fuel the Bharat Vapsi of Indian Startups',
        accentTag: '45 Mins',
        speakers: [
          {
            name: 'Samita Goel',
            designation: 'Director Finance, RTP Global',
          },
          {
            name: 'Lavanya Ashok',
            designation:
              'Partner, Trifecta Capital, IVCA Executive Committee Member and IVCA VC Council member',
          },
          {
            name: 'Anjali Bansal',
            designation:
              'Founding Partner, Avaana Capital, IVCA Climate & Sustainability Council member',
          },
          //   {
          //     name: 'Vishal Gupta',
          //     designation: 'CEO, PhonePe',
          //   },
          {
            name: 'Manish Kheterpal',
            designation:
              'Co-founder & Partner WaterBridge Ventures, Vice Chair, IVCA VC Council',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '6:55 PM',
          end: '7:15 PM',
        },
        normalHeading:
          'Fireside Chat: Scaling India Tech: Lessons from PhonePe’s Success and Fintech Innovations',
        accentTag: '20 Mins',
        speakers: [
          { name: 'Vishal Gupta', designation: 'CEO, PhonePe Insurance' },
          {
            name: 'Karthik Prabhakar',
            designation: 'Managing Partner, PeerCapital (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '7:15 PM',
          end: '7:20 PM',
        },
        normalHeading: 'Closing Remarks/Vote of thanks',
        accentTag: '05 Mins',
        speakers: [
          {
            name: 'Sunitha Prasad',
            designation: 'VP, IVCA',
          },
        ],
      },

      {
        id: 'ivca_private_8',
        timing: {
          start: '7:20 PM',
        },
        normalHeading: 'Networking Cocktails & Dinner',
      },
    ],
  },
  {
    slug: 'webinar-private-credit-as-a-broad-asset-class-and-investment-opportunity',
    title: 'Private Credit webinar Series ( Knowledge Session Module 1)',
    startDate: 'Module 1 On August 27th, 2024',
    location: 'Online Webinar',
    startTime: '04:00 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-08-12at62336PM-30WTpj2FjLn2.jpeg',
    coverImgLink:
      'https://svca.glueup.com/event/india-spotlight-a-journey-of-growth-innovation-114768/tickets.html',
    contact: [
      {
        name: 'Soniya Tolani',
        email: 'soniya@ivca.in',
        // phone: '+91 9972470000',
        // designation: 'Sr. Vice President, IVCA',
        // image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
      },
    ],
    programTitle: 'Why This Series Matters:',
    programHighlights: [
      'As Private Credit becomes an essential component of diversified investment strategies, this series will explore its expanding role, including insights into fixed income strategies, long-term returns compared to equity, and the impact of SEBI regulations on governance. The series aims to provide a comprehensive understanding of the market dynamics and strategic opportunities within this asset class, highlighting sub-asset classes like Venture Debt Performance Credit, and Special Situations.',
    ],
    overviewTitle: 'About the Session',
    eventOverview: [
      'India’s Private Credit investment landscape is witnessing significant growth, with 2023 marking a pivotal year as investments reached US$ 5.1 billion across 64 deals in the first half alone. This surge has increased Private Credit&#39;s share to 16% of total alternative investments, with projected Assets Under Management (AUM) expected to reach US$ 60-70 billion by 2028.',
    ],
    keyTopicsTitle: 'What to Expect:',
    keyTopicsTitleHighlights: [
      'Delivered over two sessions, this series will offer unique insights into Private Credit&#39;s evolving landscape. Attendees will gain knowledge from industry experts on investment structures, regulatory oversight, and the tools like CRISIL benchmarking that are shaping investment decisions. The discussions will also cover market growth, strategy maturity, and the alignment of fund managers with fund outcomes.',
      'While primarily designed for distributors and investment advisors, the content will also benefit investors seeking new growth opportunities in this expanding market.',
      'We encourage you to share this information within your network of distributors and investment advisors who might benefit from this knowledge. Your support in extending the reach of this educational initiative is greatly appreciated.',
    ],

    // logos: [
    //   {
    //     name: 'Cyril Amarchand Mangaldas',
    //     _id: '1',
    //     logo: 'https://static.levocdn.com/WGLBUT82/CAMLogoStackedpurple-01-vxmozQYk2cKE.png',
    //     website_link: '',
    //   },
    //   {
    //     name: 'Amazon Web Services (AWS)',
    //     _id: '2',
    //     logo: 'https://static.levocdn.com/WGLBUT82/AWSLogo-T71Rn3S8uvvl.jpeg',
    //     website_link: '',
    //   },
    //   {
    //     name: 'Ernst & Young (EY)    ',
    //     _id: '3',
    //     logo: 'https://static.levocdn.com/WGLBUT82/6995642256918537020.jpg',
    //     website_link: '',
    //   },
    // ],
    speakers: [
      {
        name: 'Kanchan Jain',
        email: '',
        phone: '',
        designation:
          'Co-Chair, IVCA Credit and Special Situatios Council & Head of BPEA Credit Group',
        image: 'https://static.levocdn.com/WGLBUT82/Picture9-HbVDtJTzmcAF.jpg',
        gov: false,
        fund: 'BPEA Credit',
      },

      {
        name: 'Vineet Sukumar',
        designation:
          'Co-Chair, IVCA Credit and Special Situatios Council & Co-Founder & Managing Director',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2024-08-17at114409AM-EBh8xyGfxLrg.png',
        gov: false,
        fund: 'Vivriti Capital',
      },
      {
        name: 'Vinod Murali',
        designation:
          'Co-Chair, IVCA Credit and Special Situatios Council & Co-Founder & Managing Partner',
        email: '',
        phone: '',
        image:
          'https://www.entrepreneurindia.com/tech25web/2023/images/speakers/vinod.jpg',
        gov: false,
        fund: 'Alteria Capital',
      },
      {
        name: 'Ashvin Chadha',
        designation: 'Managing Partner and Co-Founder',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-08-13at162731-yCrW3Mli1L3L.jpeg',
        gov: false,
        fund: 'Anicut Fund',
      },
      {
        name: 'Arvind Bansal',
        designation: 'Founder',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-08-13at2023141-FUGNXjZJzhb5.jpeg',
        gov: false,
        fund: 'Maximus Financial Advisors',
      },
      {
        name: 'Unmesh Kulkarni',
        designation: 'Managing Director Senior Advisor, Head - Markets IWMS',
        email: '',
        phone: '',
        image: '',
        gov: false,
        fund: 'Julius Baer Wealth Advisors (India)',
      },
    ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '4:00 PM',
          end: '4:10 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Webinar Introduction',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '4:10 PM',
          end: '4:50 PM',
        },
        accentTag: '40 Mins',
        normalHeading: 'Session I: Performing Credit',
        listContent: [
          'Market potential and growth driven by demand for yield-generating assets.',
          'Typical fund structures and strategies designed for risk minimization and return maximization.',
          'Key commercial terms and expected return profiles.',
        ],
        speakers: [
          {
            name: 'Vineet Sukumar',
            designation: 'Vivriti Capital',
          },
          {
            name: 'Kanchan Jain',
            designation: 'BPEA Credit',
          },
          {
            name: 'Unmesh Kulkarni',
            designation: 'Julius Baer',
          },
        ],
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '4:50 PM',
          end: '5:30 PM',
        },
        accentTag: '40 Mins',
        normalHeading: 'Session II: Venture Debt',
        listContent: [
          'Growing opportunities as a financing tool for startups and high-growth companies.',
          'Real-world case studies showcasing the benefits of Venture Debt',
          'Real-world case studies showcasing the benefits of Venture Debt',
        ],
        speakers: [
          {
            name: 'Vinod Murali ',
            designation: 'Alteria Capital',
          },
          {
            name: 'Arvind Bansal',
            designation: 'Founder, Maximus Financial Advisors',
          },
          {
            name: 'Ashvin Chadha',
            designation: 'Managing Partner and Cofounder, Anicut fund',
          },
        ],
      },
      //   {
      //     id: 'ivca_private_2',
      //     timing: {
      //       start: '4:50 PM',
      //       end: '5:30 PM',
      //     },
      //     accentTag: '40 Mins',
      //     normalHeading: 'Market Dynamics',
      //     listContent: [
      //       'Current trends and increasing institutional interest in Performing Credit and Venture Debt',
      //       'Key macroeconomic drivers influencing these sub-asset classes, including interest rates and regulatory changes',
      //     ],
      //   },
    ],
  },
  {
    slug: 'session-ii',
    title: ' Private Credit webinar Series ( Knowledge Session Module 2)',
    startDate: 'Module 2 On September 4th, 2024',
    location: 'Online Webinar',
    startTime: '04:00 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-08-12at62336PM-30WTpj2FjLn2.jpeg',
    coverImgLink:
      'https://svca.glueup.com/event/india-spotlight-a-journey-of-growth-innovation-114768/tickets.html',
    contact: [
      {
        name: 'Soniya Tolani',
        email: 'soniya@ivca.in',
        // phone: '+91 9972470000',
        // designation: 'Sr. Vice President, IVCA',
        // image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
      },
    ],
    programTitle: 'Why This Series Matters:',
    programHighlights: [
      'As Private Credit becomes an essential component of diversified investment strategies, this series will explore its expanding role, including insights into fixed income strategies, long-term returns compared to equity, and the impact of SEBI regulations on governance. The series aims to provide a comprehensive understanding of the market dynamics and strategic opportunities within this asset class, highlighting sub-asset classes like Venture Debt Performance Credit, and Special Situations.',
    ],
    overviewTitle: 'About the Session',
    eventOverview: [
      'India’s Private Credit investment landscape is witnessing significant growth, with 2023 marking a pivotal year as investments reached US$ 5.1 billion across 64 deals in the first half alone. This surge has increased Private Credit&#39;s share to 16% of total alternative investments, with projected Assets Under Management (AUM) expected to reach US$ 60-70 billion by 2028.',
    ],
    keyTopicsTitle: 'What to Expect:',
    keyTopicsTitleHighlights: [
      'Delivered over two sessions, this series will offer unique insights into Private Credit&#39;s evolving landscape. Attendees will gain knowledge from industry experts on investment structures, regulatory oversight, and the tools like CRISIL benchmarking that are shaping investment decisions. The discussions will also cover market growth, strategy maturity, and the alignment of fund managers with fund outcomes.',
      'While primarily designed for distributors and investment advisors, the content will also benefit investors seeking new growth opportunities in this expanding market.',
      'We encourage you to share this information within your network of distributors and investment advisors who might benefit from this knowledge. Your support in extending the reach of this educational initiative is greatly appreciated.',
    ],

    // logos: [
    //   {
    //     name: 'Cyril Amarchand Mangaldas',
    //     _id: '1',
    //     logo: 'https://static.levocdn.com/WGLBUT82/CAMLogoStackedpurple-01-vxmozQYk2cKE.png',
    //     website_link: '',
    //   },
    //   {
    //     name: 'Amazon Web Services (AWS)',
    //     _id: '2',
    //     logo: 'https://static.levocdn.com/WGLBUT82/AWSLogo-T71Rn3S8uvvl.jpeg',
    //     website_link: '',
    //   },
    //   {
    //     name: 'Ernst & Young (EY)    ',
    //     _id: '3',
    //     logo: 'https://static.levocdn.com/WGLBUT82/6995642256918537020.jpg',
    //     website_link: '',
    //   },
    // ],
    // speakers: [
    //   {
    //     name: 'Kanchan Jain',
    //     email: '',
    //     phone: '',
    //     designation:
    //       'Co-Chair, IVCA Credit and Special Situatios Council & Head of BPEA Credit Group',
    //     image: 'https://static.levocdn.com/WGLBUT82/Picture9-HbVDtJTzmcAF.jpg',
    //     gov: false,
    //     fund: 'BPEA Credit',
    //   },

    //   {
    //     name: 'Vineet Sukumar',
    //     designation:
    //       'Co-Chair, IVCA Credit and Special Situatios Council & Co-Founder & Managing Director',
    //     email: '',
    //     phone: '',
    //     image:
    //       'https://static.levocdn.com/WGLBUT82/Screenshot2024-08-17at114409AM-EBh8xyGfxLrg.png',
    //     gov: false,
    //     fund: 'Vivriti Capital',
    //   },
    //   {
    //     name: 'Vinod Murali',
    //     designation:
    //       'Co-Chair, IVCA Credit and Special Situatios Council & Co-Founder & Managing Partner',
    //     email: '',
    //     phone: '',
    //     image:
    //       'https://www.entrepreneurindia.com/tech25web/2023/images/speakers/vinod.jpg',
    //     gov: false,
    //     fund: 'Alteria Capital',
    //   },
    //   {
    //     name: 'Ashvin Chadha',
    //     designation: 'Managing Partner and Co-Founder',
    //     email: '',
    //     phone: '',
    //     image:
    //       'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-08-13at162731-yCrW3Mli1L3L.jpeg',
    //     gov: false,
    //     fund: 'Anicut Fund',
    //   },
    //   {
    //     name: 'Arvind Bansal',
    //     designation: 'Founder',
    //     email: '',
    //     phone: '',
    //     image:
    //       'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-08-13at2023141-FUGNXjZJzhb5.jpeg',
    //     gov: false,
    //     fund: 'Maximus Financial Advisors',
    //   },
    //   {
    //     name: 'Unmesh Kulkarni',
    //     designation: 'Managing Director Senior Advisor, Head - Markets IWMS',
    //     email: '',
    //     phone: '',
    //     image: '',
    //     gov: false,
    //     fund: 'Julius Baer Wealth Advisors (India)',
    //   },
    // ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '4:00 PM',
          end: '4:10 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Webinar Introduction',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '4:10 PM',
          end: '4:50 PM',
        },
        accentTag: '40 Mins',
        normalHeading: 'Session I: High Yield Session',
        listContent: [
          'Exploration of High-Yield Credit: Understanding high-yield credit as an emerging asset allocation class.',
          'Market Size and Growth: Examination of the size and growth of the high-yield credit market.',
          'Structures and Strategies: Discussion on structures and strategies that enhance risk-adjusted returns, making high-yield credit appealing to investors.',
          'Evolving Trends & Best Practices',
        ],
        speakers: [
          {
            name: 'Shantanu Nalavadi',
            designation: 'Managing Director at India RF',
          },
          {
            name: 'Nilesh',
            designation: 'Managing Director, Avendus Credit Solution Business',
          },
          {
            name: 'Eshwar Karra',
            designation: 'CEO at Kotak Strategic Situations Fund',
          },
          {
            name: 'Vijay Padmanabhan',
            designation:
              'Managing Director, Private Credit, Cambridge Associates',
          },
          {
            name: 'Abizer Diwanji',
            designation: 'Advisor - NeoStrat Advisors LLP (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '4:50 PM',
          end: '5:30 PM',
        },
        accentTag: '40 Mins',
        normalHeading:
          'Changing Paradigm in CRE – Challenges and Opportunities',
        listContent: [
          'India CRE market',
          'Growth & Changes over last 5 years',
          'Why REITS & Asset Aggregation will be key',
          'How can investors benefit from same',
        ],
        speakers: [
          {
            name: 'Mr. Gautam Hora',
            designation:
              'MD, Commercial Real Estate, Edelweiss Alternative Asset Advisors Ltd',
          },
          //   {
          //     name: 'Subahoo Chordia',
          //     designation:
          //       'President and Head Real Assets Funds, Edelweiss Alternatives',
          //   },
        ],
      },
      //   {
      //     id: 'ivca_private_2',
      //     timing: {
      //       start: '4:50 PM',
      //       end: '5:30 PM',
      //     },
      //     accentTag: '40 Mins',
      //     normalHeading: 'Market Dynamics',
      //     listContent: [
      //       'Current trends and increasing institutional interest in Performing Credit and Venture Debt',
      //       'Key macroeconomic drivers influencing these sub-asset classes, including interest rates and regulatory changes',
      //     ],
      //   },
    ],
  },
  {
    slug: 'india-spotlight',
    title: 'India Spotlight: A Journey of Growth and Innovation',
    startDate: 'August 21st, 2024',
    location: 'Oasia Downtown',
    startTime: '2:30 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/2024IndiaSpotlightSpeakerCardDrShilpak-k5KfTHox4ODw.png',
    // contact: [
    //   {
    //     name: 'Sunitha Prasad',
    //     email: 'sunitha@ivca.in',
    //     phone: '+91 9972470000',
    //     // designation: 'Sr. Vice President, IVCA',
    //     // image: 'https://static.levocdn.com/WGLBUT82/6993100871211061165.jpg',
    //   },
    //   {
    //     name: 'Nikita Shukla',
    //     email: 'nikita@ivca.in',
    //     phone: '+91 9500092894',
    //     // designation: 'Manager - Member Relations & Knowledge Series',
    //     // image: 'https://static.levocdn.com/WGLBUT82/7059471731709423758.jpeg',
    //   },
    // ],
    // programTitle: 'Why This Series Matters:',
    // programHighlights: [
    //   'As Private Credit becomes an essential component of diversified investment strategies, this series will explore its expanding role, including insights into fixed income strategies, long-term returns compared to equity, and the impact of SEBI regulations on governance. The series aims to provide a comprehensive understanding of the market dynamics and strategic opportunities within this asset class, highlighting sub-asset classes like Venture Debt Performance Credit, and Special Situations.',
    // ],
    // overviewTitle: 'About the Session',
    // eventOverview: [
    //   'India’s Private Credit investment landscape is witnessing significant growth, with 2023 marking a pivotal year as investments reached US$ 5.1 billion across 64 deals in the first half alone. This surge has increased Private Credit&#39;s share to 16% of total alternative investments, with projected Assets Under Management (AUM) expected to reach US$ 60-70 billion by 2028.',
    // ],
    // keyTopicsTitle: 'Why This Series Matters:',
    // keyTopicsTitleHighlights: [
    //   'Delivered over two sessions, this series will offer unique insights into Private Credit&#39;s evolving landscape. Attendees will gain knowledge from industry experts on investment structures, regulatory oversight, and the tools like CRISIL benchmarking that are shaping investment decisions. The discussions will also cover market growth, strategy maturity, and the alignment of fund managers with fund outcomes.',
    //   'While primarily designed for distributors and investment advisors, the content will also benefit investors seeking new growth opportunities in this expanding market.',
    //   'We encourage you to share this information within your network of distributors and investment advisors who might benefit from this knowledge. Your support in extending the reach of this educational initiative is greatly appreciated.',
    // ],

    logos: [
      {
        name: 'Khaitan & Co.',
        _id: '1',
        logo: 'https://static.levocdn.com/WGLBUT82/6995641290484528844.jpg',
        website_link: 'https://www.khaitanco.com/',
      },
      {
        name: 'Ernst & Young (EY)    ',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/6995642256918537020.jpg',
        website_link: 'https://www.ey.com/en_in',
      },
    ],
    // speakers: [
    //   {
    //     name: 'Siddarth Pai',
    //     email: '',
    //     phone: '',
    //     designation:
    //       'Founding Partner, IVCA Regulatory Affairs Council and IVCA Executive Committee Member',
    //     image: 'https://static.levocdn.com/WGLBUT82/SiddarthPai-2EYM54TtfhA5.png',
    //     gov: false,
    //     fund: 'CFO and ESG Officer, 3one4 Capital and Co-Chair',
    //   },

    //   {
    //     name: 'Harish S',
    //     designation: 'Partner Corporate',
    //     email: '',
    //     phone: '',
    //     image: 'https://static.levocdn.com/WGLBUT82/HarishS-1d7EL5iZxQ6q.jpg',
    //     gov: false,
    //     fund: ' Cyril Amarchand Mangaldas',
    //   },
    //   {
    //     name: 'KT Chandy',
    //     designation: 'Partner and Co-Leader',
    //     email: '',
    //     phone: '',
    //     image: 'https://static.levocdn.com/WGLBUT82/KTChandy-vxmozQYkZf7V.jpg',
    //     gov: false,
    //     fund: 'EY Private Tax | EY India',
    //   },
    //   {
    //     name: 'Reeba Chacko',
    //     designation: 'Senior Partner General Corporate',
    //     email: '',
    //     phone: '',
    //     image: 'https://static.levocdn.com/WGLBUT82/ReebaChako-WT0jrjPSeJpj.jpg',
    //     gov: false,
    //     fund: 'Cyril Amarchand Mangaldas',
    //   },
    // ],
    // agendaEvents: [
    //   {
    //     id: 'ivca_private_1',
    //     timing: {
    //       start: '5:00 PM',
    //       end: '5:30 PM',
    //     },
    //     accentTag: '30 Mins',
    //     normalHeading: 'REGISTRATION & NETWORKING HIGH TEA',
    //   },
    //   {
    //     id: 'ivca_private_2',
    //     timing: {
    //       start: '5:30 PM',
    //       end: '5:40 PM',
    //     },
    //     accentTag: '10 Mins',
    //     normalHeading: 'WELCOME ADDRESS',
    //     speakers: [
    //       {
    //         name: 'Bhautik Ambani',
    //         designation: 'CEO, AlphaGrep Investment Management',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'ivca_private_3',
    //     timing: {
    //       start: '5:40 PM',
    //       end: '6:00 PM',
    //     },
    //     accentTag: '20 Mins',
    //     normalHeading: 'IVCA CAT III REPORT LAUNCH',
    //     speakers: [
    //       {
    //         name: 'Upasana Koul',
    //         designation: 'Co-founder, Eleveight',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'ivca_private_4',
    //     timing: {
    //       start: '6:00 PM',
    //       end: '6:40 PM',
    //     },
    //     accentTag: '40 Mins',
    //     normalHeading:
    //       'MANAGERS AND INVESTORS PERSPECTIVES AND OUTLOOK ON THE CAT III GROWTH TRAJECTORY',
    //     speakers: [
    //       {
    //         name: 'Apurva Salarpuria',
    //         designation: 'Principal, Salarpuria Family Office',
    //       },
    //       {
    //         name: 'Ashish Chugani',
    //         designation:
    //           'Head Alternative Assets, Nippon India Alternative Investments',
    //       },
    //       {
    //         name: 'Bhavdeep Bhatt',
    //         designation: 'CEO, Northern Arc Investments',
    //       },
    //       {
    //         name: 'Vikaas Sachdeva',
    //         designation: 'Managing Director, Sundaram Alternates (Moderator)',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'ivca_private_5',
    //     timing: {
    //       start: '6:40 PM',
    //       end: '7:20 PM',
    //     },
    //     accentTag: '40 Mins',
    //     normalHeading: 'KEY IMPACTFUL REFORMS TO PROPEL CAT III INDUSTRY',
    //     speakers: [
    //       {
    //         name: 'Nalin Moniz',
    //         designation: 'CIO - Alternative Equity, Edelweiss Asset Management',
    //       },
    //       {
    //         name: 'Pritesh Majmudar',
    //         designation: 'Head of Compliance, DSPIM',
    //       },
    //       {
    //         name: 'Saurabh Rungta',
    //         designation:
    //           'Managing Director and Chief Investment Officer, Avendus Wealth Management',
    //       },
    //       {
    //         name: 'Vikram Bohra',
    //         designation: 'Partner, Price Waterhouse & Co LLP',
    //       },
    //       {
    //         name: 'Bhautik Ambani',
    //         designation: 'CEO, AlphaGrep Investment Management (Moderator)',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'ivca_private_6',
    //     timing: {
    //       start: '7:20 PM',
    //       end: '7:40 PM',
    //     },
    //     accentTag: '20 Mins',

    //     normalHeading: 'OPPORTUNITY FOR CAT III FUNDS IN IFSC',
    //     speakers: [
    //       {
    //         name: 'Pradeep Ramakrishnan',
    //         designation: 'Executive Director, IFSCA',
    //       },
    //       {
    //         name: 'Pavan Shah',
    //         designation: 'General Manager, IFSCA',
    //       },
    //     ],
    //   },

    //   {
    //     id: 'ivca_private_7',
    //     timing: {
    //       start: '7:40 PM',
    //       end: '7:55 PM',
    //     },
    //     accentTag: '15 Mins',
    //     normalHeading: 'OMNIBUS STRUCTURES FOR TRADES IN GIFT CITY',
    //     speakers: [
    //       {
    //         name: 'Akshaya Mishra',
    //         designation: 'Head of Compliance, Nuvama Asset. Management',
    //       },
    //     ],
    //   },

    //   {
    //     id: 'ivca_private_8',
    //     timing: {
    //       start: '7:55 PM',
    //       end: '8:00 PM',
    //     },
    //     accentTag: '10 Mins',
    //     normalHeading: 'CLOSING REMARKS',
    //     speakers: [
    //       {
    //         name: 'Vikaas Sachdeva',
    //         designation: 'Managing Director, Sundaram Alternates',
    //       },
    //     ],
    //   },
    //   {
    //     id: 'ivca_private_8',
    //     timing: {
    //       start: '8:00 PM',
    //     },
    //     normalHeading: 'NETWORKING COCKTAILS & DINNER',
    //   },
    // ],
  },
  {
    slug: 'esg-insights',
    title:
      'ESG Insights - Unlocking the value through effective implementation',
    startDate: 'September 26th, 2024',
    location: 'Online',
    startTime: '4:00 PM',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/ESGinAction1-WT0jrjDquExg.png',
    contact: [
      {
        name: 'Nikita Shukla',
        email: 'nikita@ivca.in',
        // phone: '+91 9500092894',
      },
      {
        name: 'Sunitha Prasad',
        email: 'sunitha@ivca.in',
        // phone: '+91 9500092894',
        // designation: 'Manager - Member Relations & Knowledge Series',
        // image: 'https://static.levocdn.com/WGLBUT82/7059471731709423758.jpeg',
      },
    ],
    // programTitle: 'Why This Series Matters:',
    // programHighlights: [
    //   'As Private Credit becomes an essential component of diversified investment strategies, this series will explore its expanding role, including insights into fixed income strategies, long-term returns compared to equity, and the impact of SEBI regulations on governance. The series aims to provide a comprehensive understanding of the market dynamics and strategic opportunities within this asset class, highlighting sub-asset classes like Venture Debt Performance Credit, and Special Situations.',
    // ],
    // overviewTitle: 'About the Session',
    // eventOverview: [
    //   'India’s Private Credit investment landscape is witnessing significant growth, with 2023 marking a pivotal year as investments reached US$ 5.1 billion across 64 deals in the first half alone. This surge has increased Private Credit&#39;s share to 16% of total alternative investments, with projected Assets Under Management (AUM) expected to reach US$ 60-70 billion by 2028.',
    // ],
    // keyTopicsTitle: 'Why This Series Matters:',
    // keyTopicsTitleHighlights: [
    //   'Delivered over two sessions, this series will offer unique insights into Private Credit&#39;s evolving landscape. Attendees will gain knowledge from industry experts on investment structures, regulatory oversight, and the tools like CRISIL benchmarking that are shaping investment decisions. The discussions will also cover market growth, strategy maturity, and the alignment of fund managers with fund outcomes.',
    //   'While primarily designed for distributors and investment advisors, the content will also benefit investors seeking new growth opportunities in this expanding market.',
    //   'We encourage you to share this information within your network of distributors and investment advisors who might benefit from this knowledge. Your support in extending the reach of this educational initiative is greatly appreciated.',
    // ],
    YTLink: 'https://www.youtube.com/watch?v=d1IOafIOL78&ab_channel=IVCA',

    // logos: [
    //   {
    //     name: 'Khaitan & Co.',
    //     _id: '1',
    //     logo: 'https://static.levocdn.com/WGLBUT82/6995641290484528844.jpg',
    //     website_link: 'https://www.khaitanco.com/',
    //   },
    //   {
    //     name: 'Ernst & Young (EY)    ',
    //     _id: '3',
    //     logo: 'https://static.levocdn.com/WGLBUT82/6995642256918537020.jpg',
    //     website_link: 'https://www.ey.com/en_in',
    //   },
    // ],
    speakers: [
      {
        name: 'Sowmya Arunkumar',
        email: '',
        phone: '',
        designation: 'Partner',
        image:
          'https://static.levocdn.com/WGLBUT82/SowmyaArunkumarPic-min-fF9iWebwUpZv.JPG',

        gov: false,
        fund: 'C4D Partners',
      },

      {
        name: 'Sowmya Suryanarayanan',
        designation:
          'Director-Impact & ESG, Aavishkaar Capital and IVCA Impact and ESG Council Co-Chair',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/sowmyasuryanarayanan-rSCnlHMSjZ4D.jpeg',
        gov: false,
        fund: 'Aavishkaar Capital',
      },
      {
        name: 'Deepak Kumar',
        designation: 'Executive',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/Deepak-2-DNPSs0JYPnuP.jpg',
        gov: false,
        fund: 'ESG Impact, British International Investment',
      },
      {
        name: 'Anil Choudhary',
        designation: 'Head ESG',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Anil-Choudhary-2-T71mn3ES0ctl.png',
        gov: false,
        fund: 'Truenorth',
      },
    ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '4:00 PM',
          end: '4:10 PM',
        },
        accentTag: '10 Mins',
        normalHeading:
          'Introduction to the Council’s Objectives and Initiatives',
        speakers: [
          {
            name: 'Sowmya Suryanarayanan',
            designation:
              'Director-Impact & ESG, Aavishkaar Capital and IVCA Impact and ESG Council Co-Chair',
          },
        ],
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '4:10 PM',
          end: '4:25 PM',
        },
        accentTag: '15 Mins',
        normalHeading:
          'Showcase 1: Initiatives and ESG practices followed by C4D Partners pre and post investment',
        speakers: [
          {
            name: 'Sowmya Arunkumar',
            designation: 'Partner, C4D Partners',
          },
        ],
      },
      {
        id: 'ivca_private_3',
        timing: {
          start: '4:25 PM',
          end: '4:40 PM',
        },
        accentTag: '15 Mins',
        normalHeading:
          'Showcase 2: Responsible Investment Practices for Impactful ESG outcomes',
        speakers: [
          {
            name: 'Anil Choudhary',
            designation: 'Head ESG, Truenorth',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '4:40 PM',
          end: '4:50 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'LP insights',
        speakers: [
          {
            name: 'Deepak Kumar',
            designation:
              ' Executive – ESG Impact, British International Investment',
          },
        ],
      },

      {
        id: 'ivca_private_8',
        timing: {
          start: '4:50 PM',
          end: '5:00 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Q&A',
      },
    ],
  },
  {
    slug: 'ivca-ecosystem-enablers-forum',
    title: 'IVCA Ecosystem Enablers Forum 2024',
    coverImgLink:
      'https://www.meraevents.com/previewevent?view=preview&eventId=261549',
    startDate: 'October 24th, 2024',
    location: 'Mumbai',
    startTime: '10:00 AM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-10-01at84548PM-w9fQkJv9zO1j1.jpeg',
    contact: [
      {
        name: 'Shreya Kumar',
        email: 'shreya@ivca.in',
      },
      {
        name: 'Jahnavi Mallick',
        email: 'jahnavi@ivca.in',
      },
    ],
    overviewTitle: 'About the Session',
    eventOverview: [
      'The IVCA Ecosystem Enablers Forum 2024 brings together industry leaders to discuss key strategies, innovations, and regulatory updates critical to the AIF ecosystem. The forum will focus on optimizing operational efficiency, exploring emerging trends in trusteeship and custodian services, and addressing evolving regulatory compliance requirements.',
    ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '10:00 AM',
          end: '10:30 AM',
        },
        accentTag: '30 Mins',
        normalHeading: 'Registration & Networking',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '10:30 AM',
          end: '10:45 AM',
        },
        accentTag: '15 Mins',
        normalHeading: 'Welcome address & introduction',
        listContent: [
          'Overview of the AIF market in India and growth trends.',
          'Importance of ecosystem services providers in enabling AIF growth.',
        ],
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '10:45 AM',
          end: '11:30 AM',
        },
        accentTag: '45 Mins',
        normalHeading: 'Optimizing Operational Efficiency In Funds (VISTRA)',
        listContent: [
          'When to outsource and when to insource?',
          'How to minimize documentation from LPs / Feeder funds cost benefit analysis',
          'Cost benefit analysis of different types of compliance framework.',
          'Role of trustees in AIF governance and compliance',
          'Best practices in trusteeship services',
        ],
        speakers: [
          {
            name: 'Neeraj Aggarwal',
            designation: 'Commercial Director, India & Mauritius',
          },
        ],
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '11:30 AM',
          end: '12:15 PM',
        },
        accentTag: '45 Mins',
        normalHeading:
          'Innovation, challenges and strategies for custodian services for AIFs (HSBC)',
        listContent: [
          'Importance of custodians in safeguarding AIF assets.',
          'Challenges and innovations in AIF custodian services.',
          'Global trends and challenges in custodian services.',
        ],
        speakers: [
          {
            name: 'Jyoti Jalan',
            designation: 'Director, Global Markets',
          },

          {
            name: 'Vineet Jain',
            designation: ' Director & Country Head',
          },
        ],
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '12:15 PM',
          end: '1:15 PM',
        },
        accentTag: '60 Mins',
        normalHeading: 'Networking lunch',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '1:15 PM',
          end: '2:00 PM',
        },
        accentTag: '45 Mins',
        normalHeading: 'The evolving role of depositories for AIFs (CDSL)',
        listContent: [
          'Playing a pivotal role in modernizing financial markets',
          'Leveraging technology for efficient depository services',
        ],
        speakers: [
          {
            name: 'Avinash Shere',
            designation: 'Assistant Vice President',
          },
        ],
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '2:00 PM',
          end: '2:45 PM',
        },
        accentTag: '45 Mins',
        normalHeading: 'The evolving role of RTA services for AIFs (CAMS)',
        listContent: [
          'Streamlining AIF investor onboarding and record-keeping.',
          'Leveraging technology for efficient RTA services.',
        ],
        speakers: [
          {
            name: 'Girish Sankar Krishnamoorthy',
            designation: 'Business Head, Alternative Services',
          },
        ],
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '2:45 PM',
          end: '3:15 PM',
        },
        accentTag: '30 Mins',
        normalHeading: 'Update on regulatory compliances for AIFs',
        listContent: [
          'Key compliance requirements for AIFs under SEBI regulations.',
          'Role of ecosystem providers in AIF compliance.',
        ],
        speakers: [
          {
            name: 'Harish Agarwal',
            designation:
              'President & Chief Operating Officer, EAAA Alternatives',
          },
          {
            name: 'Dr. Pritesh Majmudar',
            designation: 'Head - legal and Compliance, DSP Investment Managers',
          },
          {
            name: 'Vikas Gupta',
            designation: 'Senior Vice President - Finance, WestBridge Capital',
          },
          {
            name: 'Gaurita Udiyawa',
            designation: 'Khaitan & Co (Moderator)',
          },
        ],
      },

      {
        id: 'ivca_private_2',
        timing: {
          start: '3:15 PM Onwards',
        },
        normalHeading: 'Closing remarks and networking high tea.',
      },
    ],
  },
  //   Green Return
  {
    slug: 'ivca-green-return-2024',
    title: 'IVCA GreenReturns Summit 2024',
    coverImgLink: '',
    startDate: 'December 2nd - December 3rd, 2024',
    location: 'New Delhi ',
    // startTime: 'qw23',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/Greenreturnsummit202411-R6eVpN5SNtH2U.png',
    contact: [
      {
        name: 'Aakriti Bamniyal',
        email: 'aakriti@ivca.in',
      },
      {
        name: 'Arya',
        email: 'arya@ivca.in',
      },
    ],

    overviewTitle: 'About the Summit',
    eventOverview: [
      "India's pivotal role in the global effort to address carbon emissions and climate change cannot be overstated. Achieving the necessary reductions requires substantial investment, potentially trillions of dollars over the coming decades. For such investments to materialize, industries must achieve economic viability, necessitating close collaboration with policymakers to create effective market frameworks.",
    ],
    keyTopicsTitle: 'Why This Summit Matters:',
    keyTopicsTitleHighlights: [
      'IVCA GreenReturns Summit aims to serve as a crucial crucible for facilitating dialogues and interactions for climate finance to find the appropriate investments. The Summit will provide an excellent forum for conducting multiple side meetings with diverse investors and policymakers, further enhancing collaborative opportunities and strategic partnerships.',
      'The IVCA GreenReturns Summit is poised to become a major annual event, attracting hundreds of delegates, including global North investors, domestic and international PE/VC/infra funds, portfolio companies, policymakers, academics, and other key stakeholders from the climate finance community.',
    ],
    programTitle: 'Key Objectives',
    programHighlights: [
      'Showcasing climate investment opportunities and fund management in India.',
      'Attracting Global North finance decision-makers to India.',
      'Fostering engagement among investors, industry leaders, and policymakers.',
      'Facilitating the flow of commercial and impact capital through strategic structuring.',
      'Creating commercial frameworks for climate adaptation and resilience.',
    ],
  },
  //   Green Future
  {
    slug: 'ivca-green-future-2024',
    title:
      'Green Future Series: Unlocking Carbon Sequestration: Breakthroughs & Value Creation',
    coverImgLink: '',
    startDate: 'October 22nd, 2024',
    location: 'Virtaul',
    startTime: '3:00 PM - 4:00 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/GreenFutureSeriesBanner-VbXwqm3TDeLAO.png',
    contact: [
      {
        name: 'Arya',
        email: 'arya@ivca.in',
      },
    ],

    overviewTitle: 'About the Session',
    eventOverview: [
      'Join us for the next edition of the IVCA GreenFuture Series, a virtual monthly dialogue, where we will explore the rapidly growing carbon sequestration market in India.',
    ],
    keyTopicsTitle: 'Why This Series Matters:',
    keyTopicsTitleHighlights: [
      'This session aims to foster a comprehensive understanding of the carbon sequestration landscape, positioning it as a pivotal factor in India’s sustainable growth and climate action efforts.',
    ],
    programTitle: 'Key Objectives',
    programHighlights: [
      'Emerging Technologies & Breakthroughs: Insights into the latest innovations and advancements in carbon capture technologies.',
      'Market-Based Instruments and Regulatory Measures: Exploring the instruments and policies that are shaping carbon sequestration, including market-driven initiatives and regulatory frameworks.',
      'Challenges in Unlocking Carbon Capture Across Sectors: Identifying key barriers to scaling carbon capture across various industries.',
      'Potential for Returns: Understanding the financial opportunities and potential returns within the carbon sequestration market.',
    ],
  },
  //   IPEV Guidlines
  {
    slug: 'ivca-ipev-2024',
    title: 'Valuation Guidance Note and SEBI Circulars On Aspects Of Valuation',
    coverImgLink:
      'https://docs.google.com/forms/d/1xpCTpCgp6gOHI1H4oNqvS_XWjmfvS_UaBw3bzZcpwxc/edit',
    startDate: 'October 15th, 2024',
    location: 'Virtaul',
    startTime: '4:00 PM - 5:00 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/Screenshot2024-10-10at34214PM-PzNaMee8YI6A.png',
    contact: [
      {
        name: 'Rohan Parulekar',
        email: 'rohan.parulekar@ivca.in',
        phone: '+91 98190 01130',
      },
    ],

    overviewTitle: 'About the Session',
    eventOverview: [
      "SEBI's focus on transparency and robust valuation practices has led to the introduction of new guidelines and circulars impacting the AIF ecosystem. To provide member AIFs with clarity on the IVCA IPEV Valuation Guidance Note and SEBI's latest directives, IVCA is hosting a webinar designed to help you navigate these valuation standards effectively.",
    ],
    keyTopicsTitle: 'Why This Session Matters:',
    keyTopicsTitleHighlights: [
      'In this one-hour session, we will guide participants through the key elements of the valuation guidance note and SEBI’s circulars, followed by an interactive Q&A session to address any specific questions. This session is crucial for all member AIFs to ensure alignment with SEBI’s valuation standards and avoid any compliance issues.',
    ],
    // programTitle: 'Key Objectives',
    // programHighlights: [
    //   'Emerging Technologies & Breakthroughs: Insights into the latest innovations and advancements in carbon capture technologies.',
    //   'Market-Based Instruments and Regulatory Measures: Exploring the instruments and policies that are shaping carbon sequestration, including market-driven initiatives and regulatory frameworks.',
    //   'Challenges in Unlocking Carbon Capture Across Sectors: Identifying key barriers to scaling carbon capture across various industries.',
    //   'Potential for Returns: Understanding the financial opportunities and potential returns within the carbon sequestration market.',
    // ],
  },

  //   IVCA Private Credit Summit 2024
  {
    slug: 'ivca-private-credit-summit-2024',
    title: 'IVCA Private Credit Summit 2024',
    coverImgLink:
      'https://docs.google.com/forms/d/14iFIi-AAbv5cjr6c77Jlp45b3NWcRQWW8WJnFM4Oa0c/viewform?edit_requested=true',
    startDate: 'November 13th, 2024',
    location: 'Mumbai',
    startTime: '2:00 PM - 7:00 PM',
    imgSrc: 'https://static.levocdn.com/WGLBUT82/banner-9-pKkeluCH2rT5.jpg',
    contact: [
      {
        name: ' Soniya Tolani',
        email: 'soniya@ivca.in',
      },
    ],

    overviewTitle: 'About the Session',
    eventOverview: [
      'This closed-door summit will bring together key players from the private credit ecosystem, including insurance companies, pension funds, family offices (FOs), high-net-worth individuals (HNIs), limited partners (LPs), and private credit funds.',
    ],
    keyTopicsTitle: 'Discussion Highlights:',
    keyTopicsTitleHighlights: [
      'Differentiating risk and return profiles between credit and equity funds.',
      'Structuring security and investment terms in portfolio companies.',
      'Opportunities across performing credit, venture debt, distressed/special situations, and infrastructure /real estate strategies.',
      'Differentiation of private credit as an investment asset class from traditional lending.',
    ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '01:30 PM',
          end: '02:00 PM',
        },
        accentTag: '30 Mins',
        normalHeading: 'Registration & Networking Tea',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '02:00 PM',
          end: '02:10 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Welcome Address',
        speakers: [
          {
            name: 'Vineet Sukumar',
            designation: 'Founder & Managing Director, Vivriti Capital',
          },
        ],
      },
      {
        id: 'ivca_private_3',
        timing: {
          start: '02:10 PM',
          end: '02:40 PM',
        },
        accentTag: '30 Mins',
        normalHeading: 'Panel Discussion',
        listContent: [
          'The Role of Private Credit in Portfolio Diversification',
        ],
        speakers: [
          {
            name: 'Aakash Desai',
            designation: 'CIO & Head, Private Credit, 360 ONE Assets',
          },
          {
            name: 'Apoorva Sharma',
            designation: 'Managing Partner, Strides Venture',
          },
          {
            name: 'Bhavdeep Bhatt',
            designation: 'CEO, Northern Arc Investments',
          },
          {
            name: 'Rajesh H. Gandhi',
            designation: 'Partner, Deloitte (Moderator)',
          },
        ],

        // speakers: [
        //     {
        //       name: 'Shri Manoj Mittal',
        //       designation: 'Chairman & Managing Director, SIDBI',
        //     },
        // ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '02:40 PM',
          end: '02:55 PM',
        },
        accentTag: '15 Mins',
        normalHeading: 'Keynote Address',
        speakers: [
          {
            name: 'Shri Manoj Mittal',
            designation: 'Chairman & Managing Director, SIDBI',
          },
        ],
      },
      {
        id: 'ivca_private_5',
        timing: {
          start: '02:55 PM',
          end: '03:15 PM',
        },
        accentTag: '20 Mins',
        normalHeading: 'Fireside Chat',
        listContent: [
          'LP Perspective – Challenges & Opportunities in India Private Credit (A chat with LPs and a GP)',
        ],

        speakers: [
          {
            name: 'Neha Grover',
            designation: 'South Asia Lead, Private Equity, IFC',
          },
          {
            name: 'Gautam Sehgal',
            designation: 'CIO, Patni Family Office',
          },
          {
            name: 'Amit Agarwal',
            designation:
              'President & Head - Private Credit, EAAA Alternatives (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_6',
        timing: {
          start: '03:15 PM',
          end: '03:25 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Keynote',
        listContent: ['Allianz Global Investors'],
        speakers: [
          {
            name: 'Kulbhushan Kalia',
            designation:
              'Sr. Portfolio Manager, Global Private Debt, Allianz Global Investors',
          },
        ],
      },
      {
        id: 'ivca_private_7',
        timing: {
          start: '03:25 PM',
          end: '04:15 PM',
        },
        accentTag: '50 Mins',
        normalHeading:
          'Panel Discussion: GP Perspective – Private Credit in India',
        listContent: [
          'A deep dive into market depth and state across all key private credit asset classes – Performing,Special Situation, RE/Infra and Venture Debt',
        ],
        speakers: [
          {
            name: 'Nilesh Dhedhi',
            designation: 'MD & CEO, Avendus Finance',
          },
          {
            name: 'Rubin Chheda',
            designation:
              'MD & Head – Special Sits Strategy, Neo Assets Management',
          },
          {
            name: 'Saurabh Jhalaria',
            designation: 'CIO Alternative Credit Strategies, InCred',
          },
          {
            name: 'Vinod Murali',
            designation: 'Co-Founder & Managing Partner, Alteria Capital',
          },
          {
            name: 'Gurudutta Mishra',
            designation: 'Head - Performing Credit Fund, Piramal Alternatives',
          },
          {
            name: 'Bharat Gupta',
            designation: 'Partner, EY (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_8',
        timing: {
          start: '04:15 PM',
          end: '04:30 PM',
        },
        accentTag: '15 Mins',
        normalHeading: 'Report Launch by Lighthouse Canton',
        listContent: ['Lighthouse Canton – Venture Debt Report '],
        speakers: [
          {
            name: 'Ankit Agrawal',
            designation:
              'Executive Director, Portfolio Manager - LC Venture Debt, Lighthouse Canton',
          },
        ],
      },
      {
        id: 'ivca_private_9',
        timing: {
          start: '04:30 PM',
          end: '04:45 PM',
        },
        accentTag: '15 Mins',
        normalHeading: 'Fireside Chat',
        speakers: [
          {
            name: 'Dr. Ruchi Chojer',
            designation: 'Executive Director, SEBI',
          },
          {
            name: 'Kanchan Jain',
            designation: 'Head, Ascertis Credit Group',
          },
        ],
      },
      {
        id: 'ivca_private_9',
        timing: {
          start: '04:45 PM',
          end: '04:55 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Keynote Address',
        listContent: [
          'Kirkland & Ellis',
          'Unlocking Growth in India’s Credit Fund Ecosystem: Trends, Foreign LP Expectations, and Enhancements for Attracting Global Capital',
        ],
        speakers: [
          {
            name: 'Jamie Hills',
            designation: 'Partner, Kirkland & Ellis',
          },
        ],
      },
      {
        id: 'ivca_private_10',
        timing: {
          start: '04:55 PM',
          end: '05:45 PM',
        },
        accentTag: '50 Mins',

        normalHeading: 'Panel Discussion : Due Diligence Insights',
        listContent: [
          'How to assess investment strategies,comparison of asset classes, manager diligence, track record analysis and insights,role of ratings in diligence',
        ],
        speakers: [
          {
            name: 'Amita Somani',
            designation:
              'Head of Fixed Income, Narotam Sekhsaria Family Office',
          },
          {
            name: 'Sheeba D Mello',
            designation: 'Head, Private Capital, Partithi Investments',
          },
          {
            name: 'Srinivas Seshadri',
            designation: 'CIO, Mirabilis Investments (K Dinesh Family Office)',
          },
          {
            name: 'Rahul Bhuskute',
            designation: 'Chief Investment Officer, Bharti AXA Life Insurance',
          },
          {
            name: 'Vijay Padmanabhan',
            designation: 'Managing Director, Cambridge Associates',
          },
          {
            name: 'Ganesh Rao',
            designation: 'Trilegal (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_private_11',
        timing: {
          start: '05:45 PM',
          end: '05:50 PM',
        },
        accentTag: '05 Mins',

        normalHeading: 'Closing Remarks',
        speakers: [
          {
            name: 'Kanchan Jain',
            designation: 'Head, Ascertis Credit Group',
          },
        ],
      },
      {
        id: 'ivca_private_12',
        timing: {
          start: '05:50 PM',
          end: '06:00 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Break + Info on how roundtables will operate',
      },
      {
        id: 'ivca_private_12',
        timing: {
          start: '06:00 PM',
          end: '07:00 PM',
        },
        accentTag: '60 Mins',
        normalHeading: 'Roundtable Discussions',
        listContent: [
          'Performing Credit',
          'Special Situations',
          'Venture Debt',
          'Real Estate & Infra',
        ],
      },
      {
        id: 'ivca_private_13',
        timing: {
          start: '07:00 PM Onwards',
        },
        normalHeading: 'Networking Cocktails & Dinner',
      },
    ],
    speakers: [
      {
        name: 'Dr. Ruchi Chojer',
        designation: 'Executive Director ',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/DrRuchiChojer-ZnMdCUQRxnQNc.jpg',
        gov: false,
        fund: 'SEBI',
      },
      {
        name: 'Shri Manoj Mittal',
        designation: 'Chairman & Managing Director',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/manoj-YhEsTNkcrGAj.png',
        gov: false,
        fund: 'SIDBI',
      },
      {
        name: 'Aakash Desai',
        designation: 'CIO & Head',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-08at103157AM-QsAc4OkOPkem.png',
        gov: false,
        fund: '360 one Assets',
      },
      {
        name: 'Amit Agarwal',
        designation: 'President & Head - Private Credit',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Amit-Agarwal-GLULccdichhF.png',
        gov: false,
        fund: 'EAAA Alternatives ',
      },

      {
        name: 'Ankit Agarwal',
        designation: ' Executive Director, Portfolio Manager',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/AnkitAgrawalLC-JtatEt9faq5j.png',
        gov: false,
        fund: 'LC Venture Debt, Lighthouse Canton',
      },
      {
        name: 'Amita Somani',
        designation: 'Head of Fixed IncomeHead of Fixed Income ',
        email: '',
        phone: '',
        image: '',
        gov: false,
        fund: 'Narotam Sekhsaria Family Office',
      },
      {
        name: 'Apoorva Sharma',
        designation: 'Managing Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-08at13553PM-1d79L57gVWAL.png',
        gov: false,
        fund: 'Strides Venture',
      },
      {
        name: 'Bharat Gupta',
        designation: 'Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/BharatGupta-zucAw7VWV0jz.jpg',
        gov: false,
        fund: 'EY',
      },
      {
        name: 'Bhavdeep Bhatt',
        designation: 'CEO',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/BhavdeepBhatt-01T3tMLzyAuG.jpeg',
        gov: false,
        fund: 'Northern Arc Investments',
      },
      {
        name: 'Ganesh Rao',
        designation: 'Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-11-07at83036PM-30Wfpj6jjRkH.jpeg',
        gov: false,
        fund: 'Trilegal',
      },
      {
        name: 'Gurudutta Mishra',
        designation: 'Head - Performing Credit Fund',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-11-07at83100PM-XZbabF8FFTKP.jpeg',
        gov: false,
        fund: 'Piramal Alternatives ',
      },
      {
        name: 'Gautam Sehgal',
        designation: ' Chief Investment Officer (CIO) ',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-06at122842PM-NczkXHui5lUR.png',
        gov: false,
        fund: 'Patni Family Office',
      },
      {
        name: 'Jamie Hills',
        designation: ' Partner ',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-08at103818AM-GLU3ccrcitJe.png',
        gov: false,
        fund: 'Kirkland & Ellis',
      },
      {
        name: 'Kanchan Jain',
        designation: 'Head',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/kanchan-WT0jrj2E8Caq.png',
        gov: false,
        fund: 'Ascertis Credit Group',
      },
      {
        name: 'Kulbhushan Kalia',
        designation: 'Sr. Portfolio Manager, Global Private Debt, ',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Kulbhushanhighdef11-SvIOsFHjFvjl.jpg',
        gov: false,
        fund: 'Allianz Global Investors ',
      },
      {
        name: 'Neha Grover',
        designation: 'South Asia Lead, Private Equity',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Neha-Grover-fF94WePpexxB.png',
        gov: false,
        fund: 'IFC',
      },
      {
        name: 'Nilesh Dhedhi',
        designation: 'MD & CEO,',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/nilesh-fF9iWePpp3bu.png',
        gov: false,
        fund: 'Avendus Finance',
      },
      {
        name: 'Rahul Bhuskute',
        designation: 'Chief Investment Officer & Executive Vice President',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-06at122643PM-moxO3bF7Iwz0.png',
        gov: false,
        fund: 'Bharti AXA Life Insurance',
      },
      {
        name: 'Rajesh H. Gandhi',
        designation: 'Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2024-11-08at103839AM-HXV5tJKJi71F.png',
        gov: false,
        fund: 'Deloitte',
      },
      {
        name: 'Rubin Chheda',
        designation: 'MD & Head ',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/Rubin-1d7BL5KggRdn.png',
        gov: false,
        fund: 'Neo Assets Management',
      },

      {
        name: 'Saurabh Jhalaria',
        designation: 'CIO Alternative Credit Strategies',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/saurabh-XZbmbFRccEa7.png',
        gov: false,
        fund: 'InCred',
      },

      {
        name: 'Sheeba D Mello',
        designation: 'Family Office Investments',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/SheebaDMello-uY2VYmJbvKXc.jpg',
        gov: false,
        fund: ' Partithi Investments',
      },
      {
        name: 'Srinivas Seshadri',
        designation: 'CIO ',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/Srinivas-c2uAar3NqWOc.png',
        gov: false,
        fund: 'Mirabilis Investments (K Dinesh Family Office)',
      },

      {
        name: 'Vijay Padmanabhan',
        email: '',
        phone: '',
        designation: 'Managing Director',
        image: 'https://static.levocdn.com/WGLBUT82/IMG0099-1d7BL57gVZ7H.jpg',

        gov: false,
        fund: 'Cambridge Associates',
      },
      {
        name: 'Vineet Sukumar',
        email: '',
        phone: '',
        designation: 'Founder & Managing Director',
        image: 'https://static.levocdn.com/WGLBUT82/vineet-aytTN6O3LNe9.png',

        gov: false,
        fund: 'Vivriti Capital',
      },

      {
        name: 'Vinod Murali',
        designation: 'Co-Founder & Managing Partner',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/Vinod-ImvFBQerecLJ.png',
        gov: false,
        fund: 'Alteria Capital',
      },
      {
        name: 'Piyush Gupta',
        email: '',
        phone: '',
        designation: 'Head of Credit Markets',
        image: 'https://static.levocdn.com/WGLBUT82/7130244856559309199.jpeg',
        gov: false,
        fund: 'Investec Capital',
      },
    ],
    alphabeticalSort: false,
  },
  // Banglore Circle
  {
    slug: 'ivca-banglore-circles-2025',
    title: 'IVCA Banglore Circles 2025',
    coverImgLink:
      'https://docs.google.com/forms/d/1MIa1NQds2GyU9QwR6ZbEd-e5xLvhxmsqKnX7GdSNqT8/viewform?edit_requested=true',
    startDate: 'March 6th, 2025',
    location: 'Banglore',
    startTime: '5:00 PM - 7:00 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/WhatsAppImage2025-02-05at53331PM-30WWpj8oqvHK.jpeg',
    contact: [
      {
        name: ' Nikita Shukla ',
        email: 'nikita@ivca.in',
      },
      {
        name: 'Sunitha Prasad ',
        email: 'sunitha@ivca.in',
      },
    ],

    overviewTitle: 'About the Session',
    eventOverview: [
      "This third edition of Bangalore Circles, scheduled for the 6th of Mar'25, at the Shangrila Hotel, Bangalore, will have an exclusive gathering of 100+ VCs, PEs, Family Offices, CVCs, select founders, and Regulators. The event will take place between 5:00 p.m. to 7:00 p.m., followed by networking cocktails and dinner.",
    ],
    agendaEvents: [
      {
        id: 'ivca_private_1',
        timing: {
          start: '04:30 PM',
          end: '05:00 PM',
        },
        accentTag: '30 Mins',
        normalHeading: 'Registration & Networking High Tea',
      },
      {
        id: 'ivca_private_2',
        timing: {
          start: '05:00 PM',
          end: '05:05 PM',
        },
        accentTag: '05 Mins',
        normalHeading: 'Welcome Address',
        speakers: [
          {
            name: 'Rajat Tandon',
            designation: 'President,IVCA',
          },
        ],
      },
      {
        id: 'ivca_private_3',
        timing: {
          start: '05:05 PM',
          end: '05:15 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Keynote Address',
        speakers: [
          {
            name: 'Siddarth Pai',
            designation:
              'Founding Partner, CFO and ESG Officer, 3one4 Capital, Co-Chair, IVCA Regulatory Affairs Council and IVCA Executive Committee Member',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '05:15 PM',
          end: '05:45 PM',
        },
        accentTag: '30 Mins',
        // normalHeading: 'Opening Keynote 2',
        normalHeading:
          'Panel Discussion: Bridging the Gap: Policy, Regulation, and Self-Governance in India’s Private Capital Ecosystem',
        speakers: [
          {
            name: 'Nandini Pathak',
            designation: 'Partner, Bombay Law Chambers',
          },
          {
            name: 'Rajiv Raghunandan',
            designation: 'Managing Partner, Arali Ventures',
          },
          {
            name: 'Siddarth Pai',
            designation:
              'Founding Partner, CFO and ESG Officer, 3one4 Capital, Co-Chair, IVCA Regulatory Affairs Council and IVCA Executive Committee Member (Moderator)',
          },
          {
            name: 'Vardaan Ahluwalia',
            designation: 'General Counsel, Premji Invest',
          },
        ],
      },
      {
        id: 'ivca_private_4',
        timing: {
          start: '05:45 PM',
          end: '05:55 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Micro VC Report highlights by PwC',
        speakers: [
          {
            name: 'Udit Sharma',
            designation: 'Associate Director, Startups & Innovation, PwC India',
          },
        ],
      },
      {
        id: 'ivca_private_5',
        timing: {
          start: '05:55 PM',
          end: '06:35 PM',
        },
        accentTag: '40 Mins',
        normalHeading:
          'Panel Discussion: Exploring the Micro VC Landscape – Challenges and Pathways to Improvement',
        speakers: [
          {
            name: 'Anil Joshi',
            designation: 'Managing Partner, Unicorn India Ventures',
          },
          {
            name: 'Abhishek Agarwal',
            designation: 'Founder and Managing Partner, Rockstud Capital LLP',
          },
          {
            name: 'Namita Dalmia',
            designation: 'Partner, Enzia Ventures',
          },
          {
            name: 'Parag Srivastava',
            designation: 'Partner, Bombay Law Chambers',
          },
          {
            name: 'Raveen Shastry',
            designation: 'Partner, Multiply Ventures',
          },
        ],
      },

      {
        id: 'ivca_private_7',
        timing: {
          start: '06:35 PM',
          end: '06:45 PM',
        },
        accentTag: '10 Mins',
        normalHeading: 'Presentation by Sequretek Team on cyber security',
        speakers: [
          {
            name: 'Pankit Desai',
            designation: 'CEO & Co-Founder, Sequretek',
          },
        ],
      },
      {
        id: 'ivca_private_8',
        timing: {
          start: '06:45 PM',
          end: '07:25 PM',
        },
        accentTag: '40 Mins',
        normalHeading:
          'Panel Discussion: Opportunities and Challenges in Global Investment: Perspective from Family Office and LPs on Market Trends',

        speakers: [
          {
            name: 'Benaifer Malandkar',
            designation: 'CIO – RAAY Global Investments',
          },
          {
            name: 'Gaurav Manchanda',
            designation: 'Founder & Director, Nimida Group',
          },
          {
            name: 'Kartekeya Myadam',
            designation:
              'Founder and Chief Investment Officer, Richmount Ventures',
          },
          {
            name: 'Manick Wadhwa',
            designation:
              'Managing Partner, Tryrock Ventures / SKI Capital (Moderator)',
          },
          {
            name: 'Nikhil Bhandarkar',
            designation:
              'Head – MS Dhoni Family Office, Founding Partner – Panthera Peak Capital',
          },
        ],
      },
      {
        id: 'ivca_private_8',
        timing: {
          start: '07:25 PM',
          end: '07:30 PM',
        },
        accentTag: '05 Mins',
        normalHeading: 'Closing Remarks',
      },
      {
        id: 'ivca_private_8',
        timing: {
          start: '07:30 PM ',
          end: '09:00 PM',
        },
        accentTag: '90 Mins',
        normalHeading: 'Networking Cocktails & Dinner',
      },
    ],
    speakers: [
      {
        name: 'Anil Joshi',
        designation: 'Managing Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-02-21at12026PM-FUGNzXj5lP791.png',
        gov: false,
        fund: 'Unicorn India Ventures',
      },
      {
        name: 'Benaifer Malandkar',
        designation: 'CIO',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-02-21at12152PM-jfwup7Ax3ayc.png',
        gov: false,
        fund: 'RAAY Global Investments',
      },
      {
        name: 'Abhishek Agarwal',
        designation: 'Founder and Managing Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-02-21at12322PM-bMZFnDLw3qQN.png',
        gov: false,
        fund: 'Rockstud Capital LLP',
      },
      {
        name: 'Pankit Desai',
        designation: 'CEO & Co-Founder',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-02-21at12448PM-uY20Ym4A9VeZ.png',
        gov: false,
        fund: 'Sequretek',
      },
      {
        name: 'Manick Wadhwa',
        designation: 'Managing Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-02-21at12621PM-R6eKN5pEKAuC.png',
        gov: false,
        fund: 'Tryrock Ventures/SKI Capital',
      },
      {
        name: 'Parag Srivastava',
        designation: ' Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-02-21at12802PM-MqnjyVzMvodf.png',
        gov: false,
        fund: 'Bombay Law Chambers',
      },
      {
        name: 'Nikhi Bhandarkar',
        designation: ' Head',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-02-21at12953PM-uY2iYm4AyeCr.png',
        gov: false,
        fund: 'MS Dhoni Family Office & Founder, Panthera Peak Capital',
      },
      {
        name: 'Namita Dalmia',
        designation: ' Co-Founder & Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1574915834400-moxO3bWUx74T.jpeg',
        gov: false,
        fund: 'Enzia Ventures',
      },
      {
        name: 'Rajat Tandon',
        designation: 'President',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/WhatsAppImage2025-02-01at52146PM-tryCJ0OIkI7X.jpeg',
        gov: false,
        fund: 'IVCA',
      },
      {
        name: 'Gaurav Manchanda',
        designation: 'Founder & Director',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1685823212590-xloeCA38Zn0q.jpeg',
        gov: false,
        fund: 'Nimida Group',
      },
      {
        name: 'Nandini Pathak',
        designation: 'Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/NandiniPathakpic-YhECTNRiUd4c.jpeg',
        gov: false,
        fund: ' Bombay Law Chambers',
      },
      {
        name: 'Siddarth Pai',
        email: '',
        phone: '',
        designation:
          'Founding Partner, IVCA Regulatory Affairs Council and IVCA Executive Committee Member',
        image:
          'https://static.levocdn.com/WGLBUT82/SiddarthPai-2EYM54TtfhA5.png',
        gov: false,
        fund: 'CFO and ESG Officer, 3one4 Capital and Co-Chair',
      },
      {
        name: 'Rajiv Raghunandan',
        email: '',
        phone: '',
        designation: 'Managing Partner',
        image:
          'https://static.levocdn.com/WGLBUT82/RajivRaghunandanPic-30Wfpjzco2bL.jpeg',
        gov: false,
        fund: 'Arali Ventures',
      },
      {
        name: 'Vardaan Ahluwalia',
        email: '',
        phone: '',
        designation: 'General Counsel',
        image: 'https://static.levocdn.com/WGLBUT82/Vardaan-R6e9N5aDUaa8.jpeg',
        gov: false,
        fund: 'Premji Invest',
      },
      {
        name: 'Raveen Sastry',
        email: '',
        phone: '',
        designation: 'Partner',
        image:
          'https://static.levocdn.com/WGLBUT82/RaveenSastrypic-pKkIlupyUPLe.jpeg',
        gov: false,
        fund: ' Multiply Ventures',
      },
      {
        name: 'Kartekeya Myadam',
        email: '',
        phone: '',
        designation: 'Founder and Chief Investment Officer',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-03-05at104957AM-fF9qWeEbuJBo.png',
        gov: false,
        fund: 'Richmount Ventures',
      },
      {
        name: 'Udit Sharma',
        email: '',
        phone: '',
        designation: 'Associate Director',
        image:
          'https://static.levocdn.com/WGLBUT82/1567441755192-A8sT1F9bzpQh.jpeg',
        gov: false,
        fund: 'Startups & Innovation, PwC India',
      },
    ],

    programTitle: 'Key highlights',
    programHighlights: [
      'Key insights from the upcoming IVCA-PwC Micro VC Report – A presentation on emerging trends, challenges, and opportunities in the Micro VC ecosystem.',
      'The evolving Micro VC landscape – Challenges and pathways to improvement.',
      'Global investment trends – Perspectives from Family Offices & LPs.',
      'Cybersecurity & its impact on the investment ecosystem – Insights from industry experts.',
      ' Exclusive keynote sessions & thought leadership discussions.',
    ],

    alphabeticalSort: true,
    logos: [
      {
        name: 'Bombay Law Chambers',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/BLC-NEWLOGO-Dec2023-forlinkedin-VbXYm3VEc0BJ.jpeg',
        website_link: 'https://bombaylawchambers.com/',
      },
      {
        name: 'IQ-EQ',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/IQEQLockupStackedRGB-6HgFxPOgqLwF.jpg',
        website_link: 'https://iqeq.com/in/',
      },
      {
        name: 'Rockstud Capital',
        _id: '2',
        logo: 'https://static.levocdn.com/WGLBUT82/01RCLogo-OaJNLBYE4V57.png',
        website_link: 'https://www.rockstudcap.com/',
      },
      {
        name: 'Sequretek',
        _id: '1',
        logo: 'https://static.levocdn.com/WGLBUT82/SequretekLogon-iPD7f0RfdBiY.png',
        website_link: 'https://www.sequretek.com/',
      },
      {
        name: 'WestBridge Capital',
        _id: '2',
        logo: 'https://static.levocdn.com/WGLBUT82/WestbridgeLogo-PzNfMeunK08s.svg',
        website_link: 'https://westbridgecap.com/',
      },
    ],
  },
  //   IFSC
  {
    slug: 'ifsca-ivca-fund-management',
    title: 'IFSCA-IVCA Fund Management Conclave 2025',
    coverImgLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSfh5OSPQ0iQRkIdGYm7uDGfVvwrvVmK2lQ3kp4U1REAyQXmzA/viewform',
    startDate: 'March 12th, 2025',
    location: 'GIFT IFSC, Gujarat',
    startTime: '10:00 AM - 05:00 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/WhatsAppImage2025-03-10at45810PM-OaJBLB4DjcWd.jpeg',
    contact: [
      {
        name: 'Yachna Luthra ',
        email: 'yachna.luthra@ivca.in',
      },
      {
        name: 'Bhavye Anand ',
        email: ' bhavye@ivca.in',
      },
    ],

    overviewTitle: 'Overview',
    eventOverview: [
      'The IFSCA-IVCA Fund Management Conclave 2025, in collaboration with ICUL, Investec, PeakXV, and PwC, is set to be a premier gathering of leading investors, fund managers, and policymakers on March 12, 2025, at GIFT IFSC, Gujarat. As India’s alternative investment landscape undergoes rapid transformation, this exclusive forum will delve into the evolving regulatory frameworks, tax efficiencies, and cross-border investment opportunities shaping the future of fund management. ',
      "With 200+ Fund Management Entities (FMEs) already operating investment schemes, GIFT IFSC is fast emerging as a preferred global hub for AIFs, offering unparalleled regulatory incentives, tax benefits, and a seamless platform for international fund structures. The Conclave will bring together key decision-makers and industry pioneers to discuss strategies, unlock new opportunities, and chart the course for India's ascent as a global fund management powerhouse.",
    ],
    programTitle: 'Objectives',
    programHighlights: [
      'Fund Structuring Strategies for AIFs at GIFT IFSC – Explore innovative approaches tailored for Alternative Investment Funds (AIFs) within GIFT IFSC, leveraging its regulatory framework, ease of operations, and investor-friendly policies to enhance fund efficiency and global competitiveness.',
      'Provide Regulatory and Tax Perspectives for Fund Managers:Engage with policymakers, legal experts, and industry veterans to gain insights into the evolving regulatory landscape and tax benefits that make GIFT IFSC an attractive jurisdiction. The discussion will cover compliance best practices, governance mechanisms, and the long-term implications of tax incentives for fund managers.',
      ' Explore Investment Opportunities and Investor Outlook in the Alternative Capital Space:Analyze the latest trends in alternative capital investments, including the growing interest from domestic and international LPs, the rise of ESG-focused funds, and sector-specific opportunities that are shaping the future of private equity and venture capital in India.',
      'Highlight GIFT IFSC’s Role in Positioning India as a Preferred Jurisdiction for Global and Domestic Funds: Showcase how GIFT IFSC is emerging as a world-class financial hub, offering seamless cross-border fund flows, strategic tax efficiencies, and a business-friendly ecosystem that attracts global institutional investors and alternative capital managers looking to establish a presence in India.',
    ],
    agendaEvents: [
      {
        id: 'ifsca_ivca_1',
        timing: { start: '11:00 AM', end: '11:05 AM' },
        accentTag: '5 Mins',
        normalHeading: 'Welcome Address',
        speakers: [{ name: 'Rajat Tandon', designation: 'President, IVCA' }],
      },
      {
        id: 'ifsca_ivca_2',
        timing: { start: '11:05 AM', end: '11:15 AM' },
        accentTag: '10 Mins',
        normalHeading: 'Keynote Address',
        speakers: [
          { name: 'Shri K. Rajaraman', designation: 'Chairman, IFSCA' },
        ],
      },
      {
        id: 'ifsca_ivca_3',
        timing: { start: '11:15 AM', end: '11:25 AM' },
        accentTag: '10 Mins',
        normalHeading: 'Business Growth in IFSC',
        speakers: [
          {
            name: 'Dr. Dipesh Shah',
            designation: 'Executive Director (Development), IFSCA',
          },
        ],
      },
      {
        id: 'ifsca_ivca_4',
        timing: { start: '11:25 AM', end: '11:45 AM' },
        accentTag: '20 Mins',
        normalHeading: 'Fund Management Growth & Fund Regulations in IFSC',
        speakers: [
          {
            name: 'Shri Pradeep Ramakrishnan',
            designation: 'Executive Director, IFSCA',
          },
        ],
      },
      {
        id: 'ifsca_ivca_5',
        timing: { start: '11:45 AM', end: '12:15 PM' },
        accentTag: '30 Mins',
        normalHeading:
          'Legal, Tax & Fund Structures at GIFT City: Navigating the Next Frontier of Alternative Investments',
        speakers: [
          {
            name: 'Sushreet Pattanayak',
            designation: 'Partner, IC Universal Legal',
          },
          {
            name: 'R. Leelavathi Naidu',
            designation: 'Partner, IC Universal Legal',
          },
          { name: 'Kunal Shah', designation: 'Partner, PW & Co LLP' },
        ],
      },
      {
        id: 'ifsca_ivca_6',
        timing: { start: '12:15 PM', end: '1:00 PM' },
        accentTag: '45 Mins',
        normalHeading:
          'The GIFT City Advantage: Reimagining Private Capital Strategies for India & Beyond',
        speakers: [
          {
            name: 'Ashish Fafadia',
            designation: 'Partner, Blume Ventures',
          },
          {
            name: 'Kaushal Kapadia',
            designation:
              'Head of Fund Administration and Finance, Multiples Equity',
          },
          {
            name: 'Manavi Jain',
            designation: 'AVP, Public Policy, Peak XV Partners',
          },
          //   {
          //     name: 'Dr. Pritesh Majmudar',
          //     designation: 'Head - Legal and Compliance, DSP Group',
          //   },
          {
            name: 'Sushreet Pattanayak',
            designation: 'Partner, IC Universal Legal',
          },
          {
            name: 'Tushar Sachade',
            designation: 'Partner, PW & Co LLP (Moderator)',
          },
        ],
      },
      {
        id: 'ifsca_ivca_7',
        timing: { start: '1:00 PM', end: '2:00 PM' },
        accentTag: '60 Mins',
        normalHeading: 'Networking Lunch',
      },
      {
        id: 'ifsca_ivca_8',
        timing: { start: '2:00 PM', end: '2:40 PM' },
        accentTag: '40 Mins',
        normalHeading: 'Case study on Learnings of setting up at GIFT - IFSC',
        speakers: [
          {
            name: 'Mustafa Ghouse',
            designation: 'General Partner, Centre Court Capital',
          },
          {
            name: 'Sudhir.S',
            designation: 'Principal Officer, Aditya Birla Sun Life AMC Ltd',
          },
          {
            name: 'Hemal Mehta',
            designation: 'CFO, EAAA India Alternatives Ltd.',
          },
          {
            name: 'Siddarth Pai',
            designation:
              'Founding Partner, CFO, ESG Officer, 3one4 Capital Advisors and Co-Chair Regulatory Affairs Council, IVCA',
          },
        ],
      },
      {
        id: 'ifsca_ivca_9',
        timing: { start: '2:40 PM', end: '2:50 PM' },
        accentTag: '10 Mins',
        normalHeading:
          'Recent Initiatives and Supervisory Expectations ofIFSCA ',
        speakers: [
          {
            name: 'Shri Pavan Shah',
            designation: 'General Manager, IFSCA',
          },
        ],
      },
      {
        id: 'ifsca_ivca_9',
        timing: { start: '2:50 PM', end: '3:10 PM' },
        accentTag: '20 Mins',
        normalHeading:
          'Fireside Chat: IFSCA as preferred destination for global funds',
        speakers: [
          { name: 'Shri K. Rajaraman', designation: 'Chairman, IFSCA' },
          {
            name: 'Hamsini Karthik',
            designation: 'Editor BFSI, Moneycontrol (Moderator)',
          },
        ],
      },
      {
        id: 'ifsca_ivca_9',
        timing: { start: '3:10 PM', end: '3:20 PM' },
        accentTag: '10 Mins',
        normalHeading: 'Tea/Coffee Break',
      },
      {
        id: 'ifsca_ivca_10',
        timing: { start: '3:20 PM', end: '4:00 PM' },
        accentTag: '40 Mins',
        normalHeading:
          'Category III AIFs: NRIs, and the GIFT City Advantage in Public Markets',
        speakers: [
          {
            name: 'Bhautik Ambani',
            designation: 'CEO, AlphaGrep Investment Management IFSC',
          },
          {
            name: 'Bhavdeep Bhatt',
            designation: 'Chief Executive Officer, Northern Arc Investments',
          },
          {
            name: 'Vaibhav Sanghavi',
            designation: 'Chief Executive Officer, ASK Hedge Solutions',
          },
          {
            name: 'Dr. Pritesh Majmudar',
            designation: 'Head - Legal and Compliance, DSP Group',
          },
          {
            name: 'Nehal Sampat',
            designation: 'Partner, PW & Co LLP',
          },
          {
            name: 'R. Leelavathi Naidu',
            designation: 'Partner, IC Universal Legal (Moderator)',
          },
        ],
      },
      {
        id: 'ifsca_ivca_11',
        timing: { start: '4:00 PM', end: '4:40 PM' },
        accentTag: '40 Mins',
        normalHeading:
          'Credit Funds at GIFT City: Transforming Debt Capital Access for a New Era',
        speakers: [
          {
            name: ' Kanchan Jain',
            designation: 'Head, Ascertis Credit Group',
          },
          {
            name: 'Piyush Gupta',
            designation: 'Head of Credit Markets, Investec Capital',
          },
          {
            name: 'Rubin Chheda',
            designation:
              'MD & Head of Special Sits Strategy, Neo Asset Management',
          },
          {
            name: 'Shaurya Arora',
            designation: 'Partner & CIO, UTI Alternatives',
          },
          { name: 'Kunal Shah', designation: 'Partner, PW & Co LLP' },
          {
            name: 'Sushreet Pattanayak',
            designation: 'Partner, IC Universal Legal (Moderator)',
          },
        ],
      },
      {
        id: 'ifsca_ivca_12',
        timing: { start: '4:40 PM', end: '4:45 PM' },
        accentTag: '5 Mins',
        normalHeading: 'Vote of Thanks / Closing Address',
      },
      {
        id: 'ifsca_ivca_13',
        timing: { start: '4:45 PM', end: 'onwards' },
        accentTag: '',
        normalHeading: 'High Tea and Networking',
      },
    ],

    speakers: [
      {
        name: 'Rajat Tandon',
        designation: 'President',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/WhatsAppImage2025-02-01at52146PM-tryCJ0OIkI7X.jpeg',
        gov: false,
        fund: 'IVCA',
      },
      {
        name: 'Shri K. Rajaraman',
        designation: 'Chairman',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/4871f73b-cbed-42cb-a3bc-e78df06c9eda-lDifGc0qNJXS.jpg',
        gov: false,
        fund: 'IFSCA',
      },
      {
        name: 'Dr. Dipesh Shah',
        designation: 'Executive Director',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/DipeshShah-LkpuHyXmIP1C.jpeg',
        gov: false,
        fund: 'IFSCA',
      },
      {
        name: 'Shri Pradeep Ramakrishnan',
        designation: 'Executive Director',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1726464088160-6HgwxP8Bem1i.jpeg',
        gov: false,
        fund: 'IFSCA',
      },
      {
        name: 'R. Leelavathi Naidu',
        designation: 'Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/LeelavatiNaidu-Photo-QsAcT4OP4Dwvb.jpg',
        gov: false,
        fund: 'IC Universal Legal ',
      },

      {
        name: 'Siddarth Pai',
        designation: 'Founding Partner, CFO and ESG Officer',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/SiddarthPai-2EYM54TtfhA5.png',
        gov: false,
        fund: '3one4 Capital, Co-Chair, IVCA Regulatory Affairs Council & IVCA Executive Committee Member',
      },
      {
        name: 'Kunal Shah',
        designation: 'Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1597077862927-dO4Qwpx54T7q.jpeg',
        gov: false,
        fund: 'PW & Co LLP',
      },
      {
        name: 'Kaushal Kapadia',
        designation: 'Head of Fund Administration and Finance',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1712678480041-n3qaflCf4xbl.jpeg',
        gov: false,
        fund: 'Multiples Equity',
      },
      {
        name: 'Manavi Jain',
        designation: 'AVP, Public Policy',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1683090518594-DNPWs0iWK90K.jpeg',
        gov: false,
        fund: 'Peak XV Partners',
      },
      {
        name: 'Tushar Sachade',
        designation: 'Partner',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/7062694228850418829.jpg',
        gov: false,
        fund: ' PW & Co LLP (Moderator)',
      },

      {
        name: 'Pritesh Majmudar',
        designation: 'Head - Legal and Compliance',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/DrPriteshMajmudar-1d7ZL50TTES4.JPG',
        gov: false,
        fund: 'DSP Group',
      },

      {
        name: 'Ashish Fafadia',
        designation: 'Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/AshishFafadiaphoto-qW3w1Ur5UXlv.jpg',
        gov: false,
        fund: 'Blume Ventures',
      },
      {
        name: 'Hamsini Karthik',
        designation: 'Editor BFSI',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/41d8df3b9269f601389356edd4e42a8d400x400-MqnQyVWQNkE3.jpeg',
        gov: false,
        fund: 'Moneycontrol',
      },

      {
        name: 'Bhautik Ambani',
        designation: 'CEO',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/BhautikAmbani-T717n39FlYVz.jpg',
        gov: false,
        fund: 'AlphaGrep Investment Managers',
      },
      {
        name: 'Vaibhav Sanghavi',
        designation: '',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1697594491266-FUGJXjOv89yj.jpeg',
        gov: false,
        fund: 'ASK Hedge Solutions',
      },

      {
        name: 'Sushreet Pattanayak',
        designation: 'Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/CopyofSushreetPattanayak-Photo-lDigGcgx0rS5.jpg',
        gov: false,
        fund: 'ICUL',
      },

      {
        name: 'Kanchan Jain',
        designation: 'CEO & Managing Director',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/Picture9-HbVDtJTzmcAF.jpg',
        gov: false,
        fund: 'Ascertis Credit',
      },

      {
        name: 'Nilesh Dhedhi',
        designation: ' CEO & Managing Director ',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/nilesh-fF9iWePpp3bu.png',
        gov: false,
        fund: 'Avendus Finance',
      },
      {
        name: 'Mustafa Ghouse',
        designation: 'General Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1644989470398-6Hg4xPqzP6hN.jpeg',
        gov: false,
        fund: ' Centre Court Capital',
      },
      {
        name: 'Sudhir.S',
        designation: 'Principal Officer',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1646669936739-n3qBflCfS6zW.jpeg',
        gov: false,
        fund: 'Aditya Birla Sun Life AMC Ltd',
      },
      {
        name: 'Hemal Mehta',
        designation: 'CFO',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1630336320651-2EYW54jbYzNz.jpeg',
        gov: false,
        fund: 'EAAA India Alternatives Ltd.',
      },
      {
        name: 'Pavan Shah',
        designation: 'General Manager',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/PavanShahPicture-gVHrJ684iHp5.jpg',
        gov: false,
        fund: 'IFSCA',
      },
      {
        name: 'Bhavdeep Bhatt',
        designation: 'CEO',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/IMG3414-rSCtlHfGZxzV.jpeg',
        gov: false,
        fund: ' Northern Arc Investments',
      },
      {
        name: 'Nehal Sampat',
        designation: 'Partner',
        email: '',
        phone: '',
        image: '',
        gov: false,
        fund: '  PW & Co LLP',
      },
      {
        name: 'Rubin Chheda',
        designation: 'MD & Head ',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/Rubin-1d7BL5KggRdn.png',
        gov: false,
        fund: 'Neo Assets Management',
      },
      {
        name: 'Shaurya Arora',
        designation: 'Partner and Chief Investment Officer ',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/1516773855296-6Hg1xPqzuFa9.jpeg',
        gov: false,
        fund: 'UTI Alternatives',
      },
      {
        name: 'Piyush Gupta',
        email: '',
        phone: '',
        designation: 'Head of Credit Markets',
        image: 'https://static.levocdn.com/WGLBUT82/7130244856559309199.jpeg',
        gov: false,
        fund: 'Investec Capital',
      },
    ],
    alphabeticalSort: true,
  },

  {
    slug: 'ivca-renewables-summit-2025',
    title: 'IVCA Renewable Energy Summit 2025 ',
    coverImgLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSeuc-G-4pApo4Pm0biop8nheYO-q2uOrfnaYpllPcoiuezlUA/viewform',
    startDate: 'July 15th, 2025',
    location: 'Mumbai',
    // startTime: '10:00 AM - 05:00 PM',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/WhatsAppImage2025-05-05at23350PM-qW3Y1UHvGyFJ.jpeg',
    contact: [
      {
        name: 'Aakriti Bamniyal',
        email: 'aakriti@ivca.in',
      },
      {
        name: 'Mudit Johari ',
        email: ' mudit@ivca.in',
      },
    ],

    overviewTitle: 'Overview',
    eventOverview: [
      'India’s renewable energy sector is not only helping to meet rising power demand but is also a key driver of economic growth, job creation, and climate action. We are pleased to invite you to IVCA’s inaugural Renewable Energy Summit 2025 being held on 15th of July in Mumbai.',
    ],
    button: {
      text: 'Register Now!',
      link: 'https://docs.google.com/forms/d/e/1FAIpQLSeuc-G-4pApo4Pm0biop8nheYO-q2uOrfnaYpllPcoiuezlUA/viewform',
      external: true,
    },
    programTitle: 'Key Objectives of the Summit',
    programHighlights: [
      'Mobilize Capital for Renewables',
      'Collaborate with Policy and Market Leaders',
      "Showcase India's Renewable Innovations",
      'Facilitate High-Value Partnerships',
      'As India accelerates towards achieving its green growth targets, this summit convenes a powerful mix of global and domestic limited partners, general partners, corporate leaders, policymakers and regulators, and cleantech innovators to shape the next phase of growth in the renewable energy sector. Be a part of this transformative journey at the IVCA Renewable Energy Summit 2025',
    ],
    keyTopicsTitle: 'Agenda highlights',
    keyTopicsTitleHighlights: [
      'Insights from Government Leadership: Hear directly from policymakers about the latest initiatives and regulatory frameworks to accelerate clean energy adoption',
      'Accelerating Clean Power Finance in India: Explore innovative financing models',
      'Renewable Solutions Powering EV Charging, AI Data Centers, Green Hydrogen and More: Learn how renewables are enabling next-generation technologies',
      'Focus Area: Discover advancements in grid integration, storage, and hybrid energy systems',
      'Disruptive Innovations: See how Indian startups and technology leaders are reshaping the sector',
      'Networking Sessions: Engage with influential industry stakeholders, global investors, and innovators in renewable energy',
    ],
    agendaEvents: [
      {
        id: 'ivca_renewable_1',
        timing: { start: '09:00 AM', end: '09:30 AM' },
        accentTag: '30 Mins',
        normalHeading: 'Registration and Networking',
      },
      {
        id: 'ivca_renewable_2',
        timing: { start: '09:30 AM', end: '09:35 AM' },
        accentTag: '5 Mins',
        normalHeading: 'Lamp Lighting Ceremony',
        speakers: [
          {
            name: 'Shri. Pralhad Venkatesh Joshi',
            designation:
              'Hon’ble Union Minister of New and Renewable Energy, Govt. Of India',
          },
          {
            name: 'Shri Jayant Sinha',
            designation:
              'President, Eversource Capital; Senior Advisor, IVCA Climate & Sustainability Council; and Former Union Minister, Government of India',
          },
          {
            name: 'Madhusudan Kela',
            designation: 'Mentor, Singularity',
          },
          {
            name: 'Rajat Tandon',
            designation: 'President, IVCA',
          },
        ],
      },
      {
        id: 'ivca_renewable_3',
        timing: { start: '09:35 AM', end: '09:45 AM' },
        accentTag: '10 Mins',
        normalHeading: 'Welcome Address',
        speakers: [
          {
            name: 'Akhilesh Tilotia',
            designation:
              'Co-Founder, Thurro & Co-Chair, IVCA Climate and Sustainability Council',
          },
        ],
      },
      {
        id: 'ivca_renewable_4',
        timing: { start: '09:45 AM', end: '10:10 AM' },
        accentTag: '25 Mins',
        normalHeading: 'Keynote Address',
        speakers: [
          {
            name: 'Shri. Pralhad Venkatesh Joshi',
            designation:
              'Hon’ble Union Minister of New and Renewable Energy, Govt. Of India',
          },
        ],
      },
      {
        id: 'ivca_renewable_5',
        timing: { start: '10:10 AM', end: '10:30 AM' },
        accentTag: '20 Mins',
        normalHeading: 'Fireside Chat',
        speakers: [
          {
            name: 'Dr. Ruchi Chojer',
            designation:
              'Executive Director, Securities and Exchange Board of India (SEBI)',
          },
          {
            name: 'Anjali Bansal',
            designation: 'Founding Partner, Avaana Capital',
          },
        ],
      },
      {
        id: 'ivca_renewable_6',
        timing: { start: '10:30 AM', end: '10:50 AM' },
        accentTag: '20 Mins',
        normalHeading: 'Fireside Chat',
        speakers: [
          { name: 'Madhusudan Kela', designation: 'Mentor, Singularity' },
          { name: 'Prem Prabhakar', designation: 'MD & CEO, SBI Ventures' },
        ],
      },
      {
        id: 'ivca_renewable_7',
        timing: { start: '11:00 AM', end: '11:40 AM' },
        accentTag: '40 Mins',
        normalHeading:
          "Panel Discussion: Scaling Up: Financing India's Clean Power Capacities",
        listContent: [
          'Current financing landscape, market outlook and emerging trends',
          'Identifying investment gaps (Equity & Debt) and innovative financing solutions',
          'How to attract global and domestic capital into the sector',
          'Key challenges in scaling up financing',
          'Policy and regulatory recommendations',
        ],
        speakers: [
          {
            name: 'Mahendra Bisht',
            designation:
              'Managing Director - Energy Transition Fund, EAAA Alternatives',
          },
          {
            name: 'Maanvi Ahuja',
            designation:
              'Principal, Infrastructure and Sustainable Energies, India, CPP Investments',
          },
          {
            name: 'Pankaj Sindwani',
            designation:
              'Managing Partner – Tata Capital Decarbonisation Fund and Chief Business Officer – Cleantech Finance, Tata Capital',
          },
          {
            name: 'Alipt Sharma',
            designation: 'Partner, GEF Capital Partners',
          },
          {
            name: 'Tushar Kumar',
            designation: 'Partner, Just Climate',
          },
          {
            name: 'Vaibhav Garg',
            designation:
              'Director, Infrastructure & Real Assets Investment Banking, Avendus Capital (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_renewable_8',
        timing: { start: '11:40 AM', end: '12:20 PM' },
        accentTag: '40 Mins',
        normalHeading:
          'Panel Discussion: Commercial Vehicles, batteries and green hydrogen: Untapped Demand drivers accelerating Renewable Energy penetration in India',
        listContent: [
          'Status of Product Market Fit of Electric commercial vehicles',
          'Role of breakthrough battery and charging technologies',
          'Beyond Transport: Clean energy needed to make Hydrogen production "Green"',
          'Pinpointing the most attractive investment opportunities across the value chain—from batteries and vehicles to charging infrastructure and the underlying renewable assets.',
        ],
        speakers: [
          {
            name: 'Aanchal Jain',
            designation: 'CEO, PMI Electro Mobility Solutions Pvt. Ltd.',
          },
          {
            name: 'Abhishek Pareek',
            designation: 'Group Head – Finance, Waaree Group',
          },
          {
            name: 'Arun Vinayak',
            designation: 'Co-Founder & CEO, Exponent Energy',
          },
          {
            name: 'Kaveesh Thakker',
            designation: 'Principal, Multiples Alternate Asset Management',
          },
          {
            name: 'Suyash Kela',
            designation: 'Partner, Energy Transition, Singularity (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_renewable_9',
        timing: { start: '12:20 PM', end: '12:40 PM' },
        accentTag: '20 Mins',
        normalHeading:
          'Presentation: Impact of Climate Change on Renewables and Measures to Address These Challenges',
        speakers: [
          { name: 'Subahoo Chordia', designation: 'Co-CEO, EAAA Alternatives' },
        ],
      },
      {
        id: 'ivca_renewable_10',
        timing: { start: '12:40 PM', end: '01:40 PM' },
        accentTag: '60 Mins',
        normalHeading: 'Networking Lunch',
      },
      {
        id: 'ivca_renewable_11',
        timing: { start: '01:40 PM', end: '01:50 PM' },
        accentTag: '10 Mins',
        normalHeading:
          'Presentation: The Emergence of New Sub-Sectors in the Evolving Decarbonization Landscape',
        speakers: [
          {
            name: 'Prateek Jhawar',
            designation:
              'Managing Director and Head, Infrastructure & Real Assets, Avendus Capital',
          },
        ],
      },
      {
        id: 'ivca_renewable_12',
        timing: { start: '01:50 PM', end: '02:30 PM' },
        accentTag: '40 Mins',
        normalHeading:
          'Panel Discussion: How Startups Are Revolutionizing Renewable Energy in India',
        listContent: [
          'Startups as catalysts for innovation and growth',
          'Transforming diverse sectors with cleantech solutions',
          'Startups addressing key challenges in the renewable energy landscape',
        ],
        speakers: [
          {
            name: 'Amit Mehta',
            designation: 'Managing Partner, Asha Ventures',
          },
          { name: 'Mukul Jain', designation: 'Co-Founder, Anubal Fusion' },
          {
            name: 'Dr. Milind Kulkarni',
            designation: 'Chairman & CEO, RSOLEC',
          },
          {
            name: 'Shantanu Chaturvedi',
            designation: 'Partner, Transition VC',
          },
          {
            name: 'Viraraghavan Sankaran',
            designation: 'Founder, CEO, GreenJoules',
          },
          {
            name: 'Arpit Agarwal',
            designation: 'Partner, Blume Ventures (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_renewable_13',
        timing: { start: '02:30 PM', end: '02:50 PM' },
        accentTag: '20 Mins',
        normalHeading:
          'Fireside Chat: Mapping India’s Untapped Renewable Energy Opportunities (States Session)',
        listContent: [
          'Emerging Trends and Opportunities in Renewable Energy Investments',
          'Policy Interventions and State Support',
        ],
        speakers: [
          {
            name: 'Shri Vishal Kumar Dev',
            designation:
              'Principal Secretary, Energy Department, Government of Odisha',
          },
          {
            name: 'Yash Kela',
            designation: 'Founder and Chief Investment Officer, Singularity',
          },
        ],
      },
      {
        id: 'ivca_renewable_14',
        timing: { start: '02:50 PM', end: '03:30 PM' },
        accentTag: '40 Mins',
        normalHeading:
          'Panel Discussion: Powering India 24/7: The Role of Renewables, Energy Storage Solutions and Grid Modernization',
        listContent: [
          'Integration challenges: Variability and grid stability',
          'Achieving round-the-clock (RTC) power supply',
          'Energy storage systems for balancing supply and demand',
          'Modernizing the grid with smart technologies-automation, sensors, real-time analytics, and AI-driven forecasting',
        ],
        speakers: [
          {
            name: 'Ashmita Biswas',
            designation:
              'India Consultant – Energy Policy, International Energy Agency (IEA)',
          },
          {
            name: 'Anshul Gupta',
            designation: 'Co-founder & Chief Strategy & Innovations, Hygenco',
          },
          {
            name: 'Ayush Mishra',
            designation: 'Co-founder and CEO, AmpereHour Energy',
          },
          {
            name: 'Neha Saraf',
            designation:
              'Executive Director, Morgan Stanley Infrastructure Partners',
          },
          {
            name: 'Puneet Rustagi',
            designation:
              'Partner – Master Fund, National Investment and Infrastructure Fund (NIIF)',
          },
          {
            name: 'Hari Krishnan',
            designation:
              'Director, Investments, Greenstone Capital (Moderator)',
          },
        ],
      },
      {
        id: 'ivca_renewable_15',
        timing: { start: '03:30 PM', end: '03:40 PM' },
        accentTag: '10 Mins',
        normalHeading: 'Closing Remarks',
        speakers: [
          {
            name: 'Shri Jayant Sinha',
            designation:
              'President, Eversource Capital; Senior Advisor, IVCA Climate & Sustainability Council; and Former Union Minister, Government of India',
          },
        ],
      },
      {
        id: 'ivca_renewable_16',
        timing: { start: '03:40 PM', end: '04:45 PM' },
        accentTag: '65 Mins',
        normalHeading: 'Networking Session',
      },
    ],

    speakers: [
      {
        name: 'Amit Mehta',
        designation: 'Managing Partner',
        fund: 'Asha Ventures',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-12at20750PM-2EYf54tiSkc1.png',
        gov: false,
      },
      {
        name: 'Dr. Ruchi Chojer',
        designation: 'Executive Director',
        fund: 'Securities and Exchange Board of India (SEBI)',
        image:
          'https://static.levocdn.com/WGLBUT82/DrRuchiChojer-ZnMdCUQRxnQNc.jpg',
        gov: false,
      },
      {
        name: 'Anjali Bansal',
        designation: 'Founding Partner',
        fund: 'Avaana Capital',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-12at20637PM-6HgbxPQdiFbA.png',
        gov: false,
      },
      {
        name: 'Madhusudan Kela',
        designation: 'Mentor',
        fund: 'Singularity',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-09at125357PM-ZnMcTUkNaGpLR.png',
        gov: false,
      },
      {
        name: 'Prem Prabhakar',
        designation: 'MD & CEO',
        fund: 'SBI Ventures',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-09at125445PM-ImvhABr4XCIhO.png',
        gov: false,
      },
      {
        name: 'Shri. Pralhad Joshi',
        designation: 'Hon’ble Union Minister of New and Renewable Energy',
        fund: 'Government of India',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-10at112528PM-6HgVSxxWxeyjd.png',
        gov: true,
      },
      {
        name: 'Mahendra Bisht',
        designation: 'Managing Director - Energy Transition Fund',
        fund: 'EAAA Alternatives',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-12at21413PM-eg6BlkOeyVp1.png',
        gov: false,
      },
      {
        name: 'Maanvi Ahuja',
        designation:
          'Principal, Infrastructure and Sustainable Energies, India',
        fund: 'CPP Investments',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-12at21305PM-JtaGEt851jzd.png',
        gov: false,
      },
      {
        name: 'Pankaj Sindwani',
        designation:
          'Managing Partner – Tata Capital Decarbonisation Fund and Chief Business Officer – Cleantech Finance',
        fund: 'Tata Capital',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-12at21735PM-vxmizQk9E6uA.png',
        gov: false,
      },
      {
        name: 'Alipt Sharma',
        designation: 'Partner',
        fund: 'GEF Capital Partners',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-10at112717PM-vxmL3zMnM850Q.png',
        gov: false,
      },
      {
        name: 'Tushar Kumar',
        designation: 'Partner',
        fund: 'Just Climate',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-01at22153PM-LkptHyLDQNXl.png',
        gov: false,
      },
      {
        name: 'Vaibhav Garg',
        designation:
          'Director, Infrastructure & Real Assets Investment Banking',
        fund: 'Avendus Capital',
        image:
          'https://static.levocdn.com/WGLBUT82/1531629779667-GLUrccnrbqBU.jpeg',
        gov: false,
      },
      {
        name: 'Aanchal Jain',
        designation: 'Founder CEO',
        fund: 'PMI',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-09at125528PM-dO4QwFqA4vaX.png',
        gov: false,
      },
      {
        name: 'Abhishek Pareek',
        designation: 'Group Head – Finance',
        fund: 'Waaree Group',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-10at112839PM-YhEIWTcnc34yY.png',
        gov: false,
      },
      {
        name: 'Arun Vinayak',
        designation: 'Co-Founder & CEO',
        fund: 'Exponent Energy',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-10at113212PM-XZbwIbcBcCPfH.png',
        gov: false,
      },
      {
        name: 'Kaveesh Thakker',
        designation: 'Principal',
        fund: 'Multiples Alternate Asset Management',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-12at21208PM-n3qyfliFJ2XJ.png',
        gov: false,
      },
      {
        name: 'Suyash Kela',
        designation: 'Partner, Energy Transition',
        fund: 'Singularity',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-09at125603PM-BwjgoiP69cAo.png',
        gov: false,
      },
      {
        name: 'Subahoo Chordia',
        designation: 'Co-CEO',
        fund: 'EAAA Alternatives',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-12at21603PM-mox73bgJciA3.png',
        gov: false,
      },
      {
        name: 'Prateek Jhawar',
        designation: 'Managing Director and Head, Infrastructure & Real Assets',
        fund: 'Avendus Capital',
        image:
          'https://static.levocdn.com/WGLBUT82/1691734837735-pKkYlurBKGUQ.jpeg',
        gov: false,
      },
      {
        name: 'Mukul Jain',
        designation: 'Co-Founder',
        fund: 'Anubal Fusion',
        image: '',
        gov: false,
      },
      {
        name: 'Dr. Milind Kulkarni',
        designation: 'Chairman & CEO',
        fund: 'RSOLEC',
        image:
          'https://static.levocdn.com/WGLBUT82/1696662903734-EBhcxyEOicP8.jpeg',
        gov: false,
      },
      {
        name: 'Shantanu Chaturvedi',
        designation: 'Partner',
        fund: 'Transition VC',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-10at113047PM-hjBAGvKaKJzdX.png',
        gov: false,
      },
      {
        name: 'Viraraghavan Sankaran',
        designation: 'Founder, CEO',
        fund: 'GreenJoules',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-12at21642PM-oilerVfTC5SY.png',
        gov: false,
      },
      {
        name: 'Arpit Agarwal',
        designation: 'Partner',
        fund: 'Blume Ventures',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-12at20957PM-n3qBfliFJsHh.png',
        gov: false,
      },
      {
        name: 'Shri Vishal Kumar Dev',
        designation: 'Principal Secretary, Energy Department',
        fund: 'Government of Odisha',
        image:
          'https://static.levocdn.com/WGLBUT82/F9qs74Rb0AA1cUH-oildrVfTa84E.jpg',
        gov: true,
      },
      {
        name: 'Yash Kela',
        designation: 'Founder & CIO',
        fund: 'Singularity',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-10at112938PM-k5KxZTxyxDkuC.png',
        gov: false,
      },
      {
        name: 'Ashmita Biswas',
        designation: 'Policy Analyst and India Coordinator',
        fund: 'International Energy Agency (IEA)',
        image:
          'https://static.levocdn.com/WGLBUT82/1750356412854-T71Cn3ZK0xjd.jpeg',
        gov: false,
      },
      {
        name: 'Anshul Gupta',
        designation: 'Co-founder & Chief Strategy & Innovations',
        fund: 'Hygenco',
        image:
          'https://static.levocdn.com/WGLBUT82/1603491032758-PzNeMeP8S9dz.jpeg',
        gov: false,
      },
      {
        name: 'Ayush Mishra',
        designation: 'Co-Founder and CEO',
        fund: 'AmpereHour Energy',
        image:
          'https://static.levocdn.com/WGLBUT82/1720418966873-JtagEtJ9QgAm.jpeg',
        gov: false,
      },
      {
        name: 'Neha Saraf',
        designation: 'Executive Director',
        fund: 'Morgan Stanley Infrastructure Partners',
        image:
          'https://static.levocdn.com/WGLBUT82/1604290931022-aytrN6jaMRK9.jpeg',
        gov: false,
      },
      {
        name: 'Puneet Rustagi',
        designation: 'Partner – Master Fund',
        fund: 'National Investment and Infrastructure Fund (NIIF)',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-01at22047PM-4JOjlp18lCr2.png',
        gov: false,
      },
      {
        name: 'Hari Krishnan',
        designation: 'Director',
        fund: 'Greenstone',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-07-10at113307PM-VbXEum727CEoI.png',
        gov: false,
      },
      {
        name: 'Rajat Tandon',
        designation: 'President',
        fund: 'IVCA',
        image:
          'https://static.levocdn.com/WGLBUT82/RajatTandonProfile1-5AQfZxVDwhzA.JPG',
        gov: false,
      },
      {
        name: 'Shri Jayant Sinha',
        designation:
          'President, Eversource Capital Senior Advisor, IVCA Climate & Sustainability Council and Former Union Minister, Government of India',
        fund: '',
        image:
          'https://static.levocdn.com/WGLBUT82/WhatsAppImage2024-10-29at174249-HXVetJKDJbnv.jpeg',
        gov: true,
      },
      {
        name: 'Akhilesh Tilotia',
        designation:
          'Co-Founder, Thurro & Co-Chair, IVCA Climate and Sustainability Council',
        fund: '',
        image:
          'https://static.levocdn.com/WGLBUT82/akhilesh-tilotia-2-MqnQyVqwEvwU.jpg',
        gov: false,
      },
    ],
    logos: [
      {
        name: 'Avendus ',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-26at72744PM-Imv2BQDspbUX.png',
        website_link: 'https://www.avendus.com/india',
      },
      {
        name: 'EAA Alternatives ',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-26at72800PM-BwjOoGVfHO8G.png',
        website_link: 'https://www.eaaa.in/',
      },
      {
        name: 'Singularity ',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/SingularityLogoBlue1-01Tbstz1r8YYh.svg',
        website_link: '',
      },
    ],
    supported_by_logos: [
      {
        name: 'BowerAsia ',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/logo-moxj3bhTTsGm.webp',
        website_link: 'https://bowergroupasia.com/',
      },
      {
        name: 'US India Business Council ',
        _id: '3',
        logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-06-26at72428PM-2EYM54DdbEFd.png',
        website_link: 'https://www.uschamber.com/',
      },
    ],
    alphabeticalSort: true,
  },

  // CVC Banglore 2025
  {
    slug: 'evolving-role',
    title:
      'Inside Corporate Venturing: How India Inc. is Investing in the Future',
    coverImgLink: '',
    startDate: 'May 29th, 2025',
    location: 'Banglore',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/prevPost-1-v2day2-Bwj3CoGYO6foP.jpg',
    contact: [
      {
        name: 'Sunitha Prasad',
        email: 'sunitha@ivca.in',
      },
      {
        name: 'Nikita Shukla',
        email: 'nikita@ivca.in',
      },
      //   {
    ],

    overviewTitle: 'Overview',
    eventOverview: [
      'CVC Masterclass/Knowledge session for NASSCOM Corporate Members- a by invite, closed door round table . Two-hour Masterclass/knowledge session targeted at corporates who are exploring/thinking of corporate venturing.',
    ],
    programTitle: 'Key Objectives of the Summit',
    programHighlights: [
      'To sensitize them about the Alternate Investment Ecosystem',
      'Explain about Corporate Venturing and encourage them to start one',
      'Present them case studies/ insights from active CVCs like Accenture and Wipro',
    ],
    agendaEvents: [
      {
        id: 'ifsca_ivca_1',
        timing: { start: '02:30 PM', end: '03:00 PM' },
        accentTag: '30 Mins',
        normalHeading: 'Registration and Networking High Tea',
        // speakers: [{ name: 'Rajat Tandon', designation: 'President, IVCA' }],
      },
      {
        id: 'ifsca_ivca_2',
        timing: { start: '03:00 PM', end: '03:10 PM' },
        accentTag: '10 Mins',
        normalHeading:
          'Welcome Note and Context setting (about corporate venturing and PE/VC landscape)',
        speakers: [{ name: 'Rajat Tandon', designation: 'President, IVCA' }],
      },
      {
        id: 'ifsca_ivca_3',
        timing: { start: '03:10 PM', end: '03:50 PM' },
        accentTag: '40 Mins',
        normalHeading:
          'Masterclass on Setting up your Corporate Venturing arm for success ',
        speakers: [
          {
            name: 'Avnish Sabharwal',
            designation: 'Managing Director, Accenture Ventures',
          },
        ],
      },
      {
        id: 'ifsca_ivca_4',
        timing: { start: '03:50 PM', end: '04:30 PM' },
        accentTag: '45 Mins',
        normalHeading: 'Case studies',
        speakers: [
          {
            name: 'Sumit Keshan',
            designation: 'Managing Partner, Wipro Consumer VC',
          },
          {
            name: 'TC Meenakshisundaram (TCM)',
            designation: ' Founder & Vice-Chairman, Chiratae Ventures',
          },
        ],
      },
      {
        id: 'ifsca_ivca_4',
        timing: { start: '04:30 PM', end: '04:45 PM' },
        accentTag: '15 Mins',
        normalHeading: 'Fostering innovation through Deep Tech investments ',
        speakers: [
          {
            name: 'Krishna Kumar Natarajan',
            designation: 'Managing Partner, Mela Ventures ',
          },
        ],
      },
      {
        id: 'ifsca_ivca_4',
        timing: { start: '04:45 PM', end: '05:15 PM' },
        accentTag: '30 Mins',
        normalHeading: 'Q&A and Open Discussion, Closing Remarks',
      },
    ],
    speakers: [
      {
        name: 'TC Meenakshisundaram (TCM)',
        designation: 'Founder & Vice-Chairman',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-05-13at32441PM-lDiNGc80r3in.png',
        gov: false,
        fund: 'Chiratae Ventures',
      },
      {
        name: 'Sumit Keshan',
        designation: 'Managing Partner',
        email: '',
        phone: '',
        image: 'https://static.levocdn.com/WGLBUT82/SumitPic-QsAc4OVk5E4l.JPG',
        gov: false,
        fund: 'Wipro Consumer VC',
      },
      {
        name: 'Rajat Tandon',
        designation: 'President',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/RajatTandonProfile1-5AQfZxVDwhzA.JPG',
        gov: false,
        fund: 'IVCA',
      },
      {
        name: 'Krishna Kumar Natarajan',
        designation: 'Managing Partner',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/Screenshot2025-05-13at32821PM-c2u8ariqbF45.png',
        gov: false,
        fund: 'Mela Ventures ',
      },
      {
        name: 'Avnish Sabharwal',
        designation: 'Managing Director',
        email: '',
        phone: '',
        image:
          'https://static.levocdn.com/WGLBUT82/SabharwalAvnish-T71RYn3AVMyU5.jpg',
        gov: false,
        fund: 'Accenture Ventures',
      },
    ],
    alphabeticalSort: true,
  },

  //   Regulator Circle

  {
    slug: 'regulatory-circles',
    title:
      'Regulatory Circles | Enabling Trusted Dialogue for Finance and Compliance Leaders',
    coverImgLink: '',
    startDate: 'May 24th, 2025 | June 12th, 2025 | June 17th, 2025',
    location: 'Mumbai | Banglore | Delhi',
    imgSrc:
      'https://static.levocdn.com/WGLBUT82/IVCAcircleeaselpage-0001-k5K8vTHvsZWSa.jpg',
    contact: [
      {
        name: 'Rohan Parulekar',
        email: 'rohan.parulekar@ivca.in',
      },
      {
        name: 'Soniya Tolani',
        email: 'soniya@ivca.in',
      },
      //   {
    ],

    overviewTitle: 'Overview',
    eventOverview: [
      'The regulatory landscape for the alternate capital industry is evolving rapidly - shaped by compliance mandates, technological innovations, and global shifts. In this dynamic environment, CFOs and Compliance Heads are at the forefront, ensuring regulatory alignment with operational resilience, governance, and transparency.',
      'To support these leaders and foster meaningful, solutions-led dialogue, IVCA is launching the Regulatory Circles - a series of exclusive, closed-door sessions across Mumbai, Delhi, and Bengaluru.',
    ],
    programTitle:
      'The series will begin, gathering IVCA Member CFOs and compliance leaders to engage on:',
    programHighlights: [
      'Regulatory interpretation and operationalisation',
      'Compliance and reporting challenges',
      'Policy clarity and alignment opportunities',
    ],
  },
];

const EventDetailsLayout: React.FC = () => {
  const [eventData, setEventData] = React.useState<IEventData | undefined>(
    undefined
  );
  const router = useRouter();

  React.useEffect(() => {
    if (router.isReady) {
      const currSlug = router.query.slug as string;
      if (eventData && currSlug !== eventData.slug) {
        const currEvent = eventsData.find((item) => item.slug === currSlug);
        if (currEvent) {
          setEventData(currEvent);
        }
      } else {
        const currEvent = eventsData.find((item) => item.slug === currSlug);
        if (currEvent) {
          setEventData(currEvent);
        }
      }
    }
  }, [router.query, router.isReady]);

  return (
    <Box position="relative">
      <TopCover
        imgSrc={eventData?.imgSrc || '-'}
        imgType={eventData?.imgType || '-'}
        title={eventData?.title || '-'}
        button={{
          external: true,
          link: eventData?.button?.link || '',
          text: 'Register Now!',
        }}
        contact={
          eventData?.contact && eventData?.contact?.length > 0
            ? eventData?.contact
            : [
                {
                  name: 'Shreya Kumar',
                  email: 'shreya@ivca.in',
                  phone: '+91 95609 22999',
                  designation: 'Manager - Member Relations & Knowledge Series',
                  image:
                    'https://static.levocdn.com/WGLBUT82/6997905993761010384.png',
                },
              ]
        }
        startDate={eventData?.startDate || '-'}
        startTime={eventData?.startTime || ''}
        mainTagText={eventData?.location || ''}
        accentLabel={eventData?.accentLabel || ''}
        coverImgLink={eventData?.coverImgLink || ''}
      />
      {(eventData?.programHighlights ||
        eventData?.eventOverview ||
        eventData?.overviewTitle ||
        eventData?.programTitle ||
        eventData?.keyTopicsTitleHighlights ||
        eventData?.YTLink ||
        eventData?.keyTopicsTitle) && (
        <DetailsAndOverview
          // title={eventData?.title}
          overviewTitle={eventData?.overviewTitle}
          highlightsTitle={eventData?.programTitle}
          highlights={eventData?.programHighlights}
          overview={eventData?.eventOverview}
          keyTopicsTitle={eventData?.keyTopicsTitle}
          keyTopicsTitleHighlights={eventData?.keyTopicsTitleHighlights}
          YTLink={eventData?.YTLink}
        />
      )}

      {eventData?.speakers && (
        <Container maxW="1199px" pt={{ xs: '24px', lg: '36px' }} pb="3rem">
          <Speakers
            speakers={eventData?.speakers}
            alphabeticalSort={eventData?.alphabeticalSort}
          />
        </Container>
      )}

      <Container maxW="1199px" pt={{ xs: '24px', lg: '36px' }} pb="1rem">
        {eventData?.logos && eventData?.logos.length > 0 && (
          <Box>
            <Heading
              color="secondaryPurple.900"
              fontSize={{ xs: '24px', lg: '34px' }}
              fontWeight="700"
              lineHeight="130%"
              textAlign="center"
              marginBottom="20px"
            >
              {eventData?.sponsor_text || 'Our Partners'}
            </Heading>
            <Flex
              // columns={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }}
              w="100%"
              columnGap="17px"
              rowGap="30px"
              justify="center"
              flexWrap="wrap"
            >
              {eventData?.logos.map((item) => (
                <Link href={item?.website_link || ''} passHref>
                  <Box
                    as="a"
                    role="group"
                    cursor="pointer"
                    border="1px solid #EDEDED"
                    boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
                    // minW="219px"
                    w="300px"
                    h="100%"
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                  >
                    <Center
                      maxW="80%"
                      mx="auto"
                      h={{ base: '120px', md: '150px' }}
                    >
                      <Img
                        src={item?.logo}
                        alt={item.name}
                        maxH="86px"
                        h="80%"
                        objectFit="contain"
                      />
                    </Center>
                    <Flex alignItems="center" borderTop="1px solid #DCE3E9">
                      <Text
                        fontSize="15px"
                        py="20px"
                        w="full"
                        textAlign="center"
                        _groupHover={{ color: 'green.500', cursor: 'pointer' }}
                      >
                        {item.name}
                      </Text>
                    </Flex>
                  </Box>
                </Link>
              ))}
            </Flex>
          </Box>
        )}
      </Container>
      {eventData?.supported_by_logos &&
        eventData?.supported_by_logos.length > 0 && (
          <Container maxW="1199px" pt={{ xs: '24px', lg: '36px' }} pb="1rem">
            <Heading
              color="secondaryPurple.900"
              fontSize={{ xs: '24px', lg: '34px' }}
              fontWeight="700"
              lineHeight="130%"
              textAlign="center"
              marginBottom="20px"
            >
              Supported by
            </Heading>
            <Flex
              // columns={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }}
              w="100%"
              columnGap="17px"
              rowGap="30px"
              justify="center"
              flexWrap="wrap"
            >
              {eventData?.supported_by_logos.map((item) => (
                <Link href={item?.website_link || ''} passHref>
                  <Box
                    as="a"
                    role="group"
                    cursor="pointer"
                    border="1px solid #EDEDED"
                    boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
                    // minW="219px"
                    w="300px"
                    h="100%"
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                  >
                    <Center
                      maxW="80%"
                      mx="auto"
                      h={{ base: '120px', md: '150px' }}
                    >
                      <Img
                        src={item?.logo}
                        alt={item.name}
                        maxH="86px"
                        h="80%"
                        objectFit="contain"
                      />
                    </Center>
                    <Flex alignItems="center" borderTop="1px solid #DCE3E9">
                      <Text
                        fontSize="15px"
                        py="20px"
                        w="full"
                        textAlign="center"
                        _groupHover={{ color: 'green.500', cursor: 'pointer' }}
                      >
                        {item.name}
                      </Text>
                    </Flex>
                  </Box>
                </Link>
              ))}
            </Flex>
          </Container>
        )}
      <Container maxW="1199px" pt={{ xs: '24px', lg: '36px' }} pb="1rem">
        {/* <SubDetails details={eventDetails || []} /> */}
        <EventAgenda events={eventData?.agendaEvents || []} />
      </Container>

      {(eventData?.outcomeHighlights || eventData?.outcomeTitle) && (
        <DetailsAndOverview
          overviewTitle={eventData?.outcomeTitle}
          overview={eventData?.outcomeHighlights}
          highlightsTitle={eventData?.attendeesTitle}
          highlights={eventData?.attendeesHighlights}
        />
      )}
    </Box>
  );
};

export default EventDetailsLayout;
